<template>
  <div class="content">
    <div class="container-fluid">
       <div class="row">
        <b-modal
            id="modal-top-add"
            hide-footer
            :title="currentStep === 4 ? 'Preview Contract Information' : 'Add Contract - Step ' + currentStep"
            content-class="shadow" 
            size="xl"
          >
            <template #modal-header="{ close }">
                <h5>{{ currentStep === 4 ? 'Preview Contract Information' : 'Add Contract - Step ' + currentStep }}</h5>
                <p class="h5 mb-2">
                  <b-icon
                    icon="x-square"
                    class="close-icon"
                    @click="
                      close();
                      clearData();
                    "
                  ></b-icon>
                </p>
            </template>
            
            <!-- Step Progress Indicator -->
            <div class="step-progress mb-3" v-if="currentStep < 4">
              <div class="step" :class="{ active: currentStep >= 1 }">1</div>
              <div class="step-line" :class="{ active: currentStep >= 2 }"></div>
              <div class="step" :class="{ active: currentStep >= 2 }">2</div>
              <div class="step-line" :class="{ active: currentStep >= 3 }"></div>
              <div class="step" :class="{ active: currentStep >= 3 }">3</div>
              <div class="step-line" :class="{ active: currentStep >= 4 }"></div>
              <div class="step" :class="{ active: currentStep >= 4 }">4</div>
            </div>
            <!-- Step 1: House Information -->
            <div v-if="currentStep === 1">
              <validation-observer ref="step1Observer" v-slot="{ handleSubmit }">
                <b-form @submit.stop.prevent="handleSubmit(nextStep)">
                  <b-row no-gutters>
                    <b-col md="12">
                      <h6 class="section-title mb-3" style="color: rgb(37, 91, 48) !important;">
                        <b-icon icon="house"></b-icon> House Information
                      </h6>
                    </b-col>
                    
                    <b-col md="12">
                      <b-form-group label="House Type" class="mb-2">
                        <b-form-radio-group v-model="houseType" :options="houseTypeOptions" @change="resetHouseData"></b-form-radio-group>
                      </b-form-group>
                    </b-col>
                    
                    <template v-if="houseType === 'existing'">
                      <b-col md="12">
                        <Vselect
                          :modelValue="addData.houseId"
                          @update:modelValue="(newValue) => (addData.houseId = newValue)"
                          :options="houseOptions"
                          :rules="{ required: true }"
                          id="text-house"
                          name="text-house"
                          label="Select Existing House"
                          class="mb-1 mr-sm-2 some-select"
                          description="text-house-feedback"
                          validatorName="House"
                        />
                      </b-col>
                      <b-row v-if="addData.houseId !==null && addData.houseId !==0">
                        <b-col md="3">
                            <Vinput
                                inputType="text"
                                :modelValue="getPriceOptionByValue"
                                :rules="{}"
                                id="text-priceOption"
                                name="text-priceOption"
                                label="Price Option"
                                class="mb-1 mr-sm-2"
                                description="text-priceOption-feedback"
                                validatorName="Price Option"
                                disabled="disabled"
                              />
                        </b-col>
                        <b-col md="3">
                        <Vinput
                            inputType="text"
                            :modelValue="getRentCurrencyType"
                            :rules="{}"
                            id="text-rentCurrencyType"
                            name="text-rentCurrencyType"
                            label="Currency Type"
                            class="mb-1 mr-sm-2"
                            description="text-rentCurrencyType-feedback"
                            validatorName="Currency Type"
                            disabled="disabled"
                          />
                        </b-col>
                        <b-col md="3">
                        <Vinput
                            inputType="text"
                            :modelValue="getPriceByValue"
                            :rules="{}"
                            id="text-price"
                            name="text-price"
                            label="Price"
                            class="mb-1 mr-sm-2"
                            description="text-price-feedback"
                            validatorName="Price"
                            disabled="disabled"
                          />
                        </b-col>
                        <b-col md="3">
                          <Vinput
                            inputType="text"
                            :modelValue="vatLabel"
                            :rules="{}"
                            id="text-vatStatus"
                            name="text-vatStatus"
                            label="VAT (15%)"
                            class="mb-1 mr-sm-2"
                            description="text-vatStatus-feedback"
                            validatorName="VAT Status"
                            disabled="disabled"
                          />
                        </b-col>
                      </b-row>
                        <b-row v-if="addData.houseId !==null && addData.houseId !==0 && getPriceOptionByValue ==='PerSquareMeter'">
                          <b-col md="12">
                            <Vinput
                                inputType="text"
                                :modelValue="computedPriceExist"
                                :rules="{}"
                                id="text-monthly-price"
                                name="text-monthly-price"
                                label="Monthly Price"
                                class="mb-1 mr-sm-2"
                                description="text-monthly-price-feedback"
                                validatorName="Monthly Price"
                                disabled="disabled"
                              />
                          </b-col>
                        </b-row>
                        <b-row v-if="addData.houseId !==null && addData.houseId !==0 && houseOptions.length > 0 && (getBillOptionByHouseIdElectric(addData.houseId) === 'ByReading' || getBillOptionByHouseIdWater(addData.houseId) === 'ByReading')">
                          <b-col md="6" v-if="getBillOptionByHouseIdElectric(addData.houseId) === 'ByReading'">
                            <VinputNumber
                                inputType="number"
                                :modelValue="addData.electricReading"
                                @update:modelValue="
                                  (newValue) => (addData.electricReading = newValue)
                                "
                                :rules="{min_value: 0, required: true}"
                                id="text-electricReading"
                                name="text-electricReading"
                                label="Base Electric Reading (KWH)"
                                class="mb-1 mr-sm-2"
                                description="text-electricReading-feedback"
                                validatorName="Base Electric Reading"
                                :step=".01"
                              />
                          </b-col>
                          <b-col md="6" v-if="getBillOptionByHouseIdWater(addData.houseId) === 'ByReading'">
                             <VinputNumber
                                inputType="number"
                                :modelValue="addData.waterReading"
                                @update:modelValue="
                                  (newValue) => (addData.waterReading = newValue)
                                "
                                :rules="{min_value: 0, required: true}"
                                id="text-waterReading"
                                name="text-waterReading"
                                label="Base Water Reading (Meter Cube)"
                                class="mb-1 mr-sm-2"
                                description="text-waterReading-feedback"
                                validatorName="Base Water Reading (Meter Cube)"
                                :step=".01"
                              />
                          </b-col>
                        </b-row>
                        <b-row v-if="addData.houseId !==null && addData.houseId !==0 && houseOptions.length > 0 && getBillExistOptionByHouseId(addData.houseId) === 'yes'">
                          <b-col md="12">
                            <Vinput
                                inputType="date"
                                :modelValue="addData.firstBillPaymentStarts"
                                @update:modelValue="
                                  (newValue) => (addData.firstBillPaymentStarts = newValue)
                                "
                                :rules="{ required: true }"
                                id="text-firstBillPaymentStarts"
                                name="text-firstBillPaymentStarts"
                                label="First Bill Payment Starts On"
                                class="mb-1 mr-sm-2"
                                description="text-firstBillPaymentStarts-feedback"
                                validatorName="First Bill Payment Starts On"
                              />
                          </b-col>
                        </b-row>
                      </template>
                      <template v-else>
                        <b-col md="12">
                          <Vselect
                            :modelValue="addData.buildingId"
                            @update:modelValue="
                              (newValue) => (addData.buildingId = newValue)
                            "
                              :options="buildingOptions"
                            :rules="{ required: true }"
                            id="text-building"
                            name="text-building"
                            label="Building"
                            class="mb-1 mr-sm-2 some-select"
                            description="text-building-feedback"
                            validatorName="Building"
                          />
                        </b-col>
                        <!-- Property Details -->
                        <b-card class="mb-3" border-variant="light">
                          <template #header>
                            <h6 class="mb-0 text-primary"><b-icon icon="geo-alt"></b-icon> Property Details</h6>
                          </template>
                          <b-row>
                            <b-col md="4">
                              <VinputNumber
                                inputType="number"
                                :modelValue="addData.floor"
                                @update:modelValue="
                                  (newValue) => (addData.floor = newValue)
                                "
                                :rules="{required: true }"
                                id="text-floor"
                                name="text-floor"
                                label="Floor"
                                class="mb-3"
                                description="text-floor-feedback"
                                validatorName="Floor"
                              />
                            </b-col>
                            <b-col md="4">
                              <Vinput
                                inputType="text"
                                :modelValue="addData.roomNumber"
                                @update:modelValue="
                                  (newValue) => (addData.roomNumber = newValue)
                                "
                                :rules="{ required: true }"
                                id="text-roomNumber"
                                name="text-roomNumber"
                                label="Room Number"
                                class="mb-3"
                                description="text-roomNumber-feedback"
                                validatorName="Room Number"
                              />
                            </b-col>
                            <b-col md="4">
                              <VinputNumber
                                inputType="number"
                                :modelValue="addData.size"
                                @update:modelValue="updateSize"
                                :rules="{ required: true }"
                                id="text-size"
                                name="text-size"
                                label="Size (sq.m)"
                                class="mb-3"
                                description="text-size-feedback"
                                validatorName="Size"
                                :step=".01"
                              />
                              <div v-if="errorMessage" class="error-message text-danger small">
                              {{errorMessage}}
                              </div>
                            </b-col>
                          </b-row>
                        </b-card>
                        
                        <!-- Pricing Information -->
                        <b-card class="mb-3" border-variant="light">
                          <template #header>
                            <h6 class="mb-0 text-success"><b-icon icon="currency-dollar"></b-icon> Pricing Information</h6>
                          </template>
                          <b-row>
                            <b-col md="6">
                              <Vselect
                                :modelValue="addData.priceOption"
                                @update:modelValue="
                                  (newValue) => (addData.priceOption = newValue)
                                "
                                  :options="priceOptions"
                                :rules="{ required: true }"
                                id="text-price-options"
                                name="text-price-options"
                                label="Pricing Method"
                                class="mb-3 some-select"
                                description="How rent is calculated"
                                validatorName="Pricing Method"
                              />
                            </b-col>
                            <b-col md="6">
                               <Vselect
                                :modelValue="addData.rentCurrencyType"
                                @update:modelValue="
                                  (newValue) => (addData.rentCurrencyType = newValue)
                                "
                                  :options="rentCurrencyTypeOptions"
                                :rules="{ required: true }"
                                id="text-rent-currency-options"
                                name="text-rent-currency-options"
                                label="Currency"
                                class="mb-3 some-select"
                                description="Payment currency type"
                                validatorName="Currency"
                              />
                            </b-col>
                          </b-row>
                          <b-row>
                            <b-col md="12">
                              <VinputNumber
                                  inputType="number"
                                  :modelValue="addData.latest_price"
                                  @update:modelValue="updatePrice"
                                  :rules="{ required: true }"
                                  id="text-price"
                                  name="text-price"
                                  label="Unit Price"
                                  class="mb-3"
                                  description="Price per unit (per month or per square meter)"
                                  validatorName="Unit Price"
                                  :step=".01"
                                />
                              <div v-if="errorMessage1" class="error-message text-danger small">
                              {{errorMessage1}}
                              </div>
                            </b-col>
                          </b-row>
                        </b-card>
                        <!-- Calculated Price -->
                        <b-card v-if="addData.priceOption === 'PerSquareMeter'" class="mb-3" border-variant="info">
                          <template #header>
                            <h6 class="mb-0 text-info"><b-icon icon="calculator"></b-icon> Calculated Monthly Price</h6>
                          </template>
                          <VinputNumber
                              inputType="number"
                              :modelValue="computedPrice"
                              @update:modelValue="
                                (newValue) => (computedPrice = newValue)
                              "
                              :rules="{}"
                              id="text-monthly-price"
                              name="text-monthly-price"
                              label="Total Monthly Rent"
                              class="mb-3"
                              description="Automatically calculated: Size × Unit Price"
                              validatorName="Monthly Price"
                              :step=".01"
                              disabled="disabled"
                            />
                        </b-card>
                        
                        <!-- Tax & Additional Information -->
                        <b-card class="mb-3" border-variant="warning">
                          <template #header>
                            <h6 class="mb-0 text-warning"><b-icon icon="percent"></b-icon> Tax & Additional Information</h6>
                          </template>
                          <b-row>
                            <b-col md="6">
                              <b-form-group label="Include VAT (15%)" class="mb-3">
                                <b-form-radio-group v-model="selectedOption" :options="[{text: 'Yes', value: 'Yes'}, {text: 'No', value: 'No'}]" buttons button-variant="outline-primary"></b-form-radio-group>
                              </b-form-group>
                            </b-col>
                            <b-col md="6">
                              <Vinput
                                  inputType="textarea"
                                  :modelValue="addData.description"
                                  @update:modelValue="
                                    (newValue) => (addData.description = newValue)
                                  "
                                  :rules="{  }"
                                  id="text-notes"
                                  name="text-notes"
                                  label="Property Notes"
                                  class="mb-3"
                                  description="Additional notes about the property, amenities, or special conditions"
                                  validatorName="Property Notes"
                                  rows="5"
                                  placeholder="Enter detailed property information, amenities, special features, or conditions..."
                                />
                            </b-col>
                          </b-row>
                        </b-card>
                        <!-- Utility Services -->
                        <b-card v-if="getBillOptionByIDElectric(addData.buildingId) === 'ByReading' || getBillOptionByIDWater(addData.buildingId) === 'ByReading' || getBillExistOptionByBuildingId(addData.buildingId) === 'yes'" class="mb-3" border-variant="secondary">
                          <template #header>
                            <h6 class="mb-0 text-secondary"><b-icon icon="lightning"></b-icon> Utility Services</h6>
                          </template>
                          <b-row>
                            <b-col md="4" v-if="getBillOptionByIDElectric(addData.buildingId) === 'ByReading'">
                              <VinputNumber
                                  inputType="number"
                                  :modelValue="addData.electricReading"
                                  @update:modelValue="
                                    (newValue) => (addData.electricReading = newValue)
                                  "
                                  :rules="{min_value: 0, required: true}"
                                  id="text-electricReading"
                                  name="text-electricReading"
                                  label="Electric Reading (KWH)"
                                  class="mb-3"
                                  description="Initial electricity meter reading"
                                  validatorName="Electric Reading"
                                  :step=".01"
                                />
                            </b-col>
                            <b-col md="4" v-if="getBillOptionByIDWater(addData.buildingId) === 'ByReading'">
                               <VinputNumber
                                  inputType="number"
                                  :modelValue="addData.waterReading"
                                  @update:modelValue="
                                    (newValue) => (addData.waterReading = newValue)
                                  "
                                  :rules="{min_value: 0, required: true}"
                                  id="text-waterReading"
                                  name="text-waterReading"
                                  label="Water Reading (m³)"
                                  class="mb-3"
                                  description="Initial water meter reading"
                                  validatorName="Water Reading"
                                  :step=".01"
                                />
                            </b-col>
                            <b-col md="4" v-if="getBillExistOptionByBuildingId(addData.buildingId) === 'yes'">
                              <Vinput
                                  inputType="date"
                                  :modelValue="addData.firstBillPaymentStarts"
                                  @update:modelValue="
                                    (newValue) => (addData.firstBillPaymentStarts = newValue)
                                  "
                                  :rules="{ required: true }"
                                  id="text-firstBillPaymentStarts"
                                  name="text-firstBillPaymentStarts"
                                  label="First Bill Payment Date"
                                  class="mb-3"
                                  description="When utility billing starts"
                                  validatorName="First Bill Payment Date"
                                />
                            </b-col>
                          </b-row>
                        </b-card>
                    </template>
                  </b-row>
                </b-form>
              </validation-observer>
            </div>
            
            <!-- Step 2: Tenant Information -->
            <div v-if="currentStep === 2">
              <validation-observer ref="step2Observer" v-slot="{ handleSubmit }">
                <b-form @submit.stop.prevent="handleSubmit(nextStep)">
                  <b-row no-gutters>
                    <b-col md="12">
                      <h6 class="section-title mb-3" style="color: rgb(37, 91, 48) !important;">
                        <b-icon icon="people-fill"></b-icon> Tenant Information
                      </h6>
                    </b-col>
                    
                    <b-col md="12">
                      <b-form-group label="Tenant Type" class="mb-2">
                        <b-form-radio-group v-model="tenantType" :options="tenantTypeOptions" @change="resetTenantData"></b-form-radio-group>
                      </b-form-group>
                    </b-col>
                    <template v-if="tenantType === 'existing'">
                      <b-col md="12">
                        <Vselect
                          :modelValue="addData.tenantId"
                          @update:modelValue="(newValue) => (addData.tenantId = newValue)"
                          :options="tenantOptions"
                          :rules="{ required: true }"
                          id="text-tenant"
                          name="text-tenant"
                          label="Select Existing Tenant"
                          class="mb-1 mr-sm-2 some-select"
                          description="text-tenant-feedback"
                          validatorName="Tenant"
                        />
                      </b-col>
                    </template>
                    

                      <template v-else>
                        <!-- Personal Information -->
                        <b-card class="mb-3" border-variant="light">
                          <template #header>
                            <h6 class="mb-0 text-primary"><b-icon icon="person"></b-icon> Personal Information</h6>
                          </template>
                          <b-row>
                            <b-col md="6">
                              <Vinput
                                inputType="text"
                                :modelValue="addData.fullName"
                                @update:modelValue="
                                  (newValue) => (addData.fullName = newValue)
                                "
                                :rules="{ required: true }"
                                id="text-fullName"
                                name="text-fullName"
                                label="Full Name"
                                class="mb-3"
                                description="text-fullName-feedback"
                                validatorName="Full Name"
                              />
                            </b-col>
                            <b-col md="6">
                              <Vselect
                                :modelValue="addData.sex"
                                @update:modelValue="
                                  (newValue) => (addData.sex = newValue)
                                "
                                  :options="sexOptions"
                                :rules="{ required: true }"
                                id="text-sex"
                                name="text-sex"
                                label="Gender"
                                class="mb-3 some-select"
                                description="text-sex-feedback"
                                validatorName="Gender"
                              />
                            </b-col>
                          </b-row>
                        </b-card>
                        
                        <!-- Contact Information -->
                        <b-card class="mb-3" border-variant="light">
                          <template #header>
                            <h6 class="mb-0 text-info"><b-icon icon="telephone"></b-icon> Contact Information</h6>
                          </template>
                          <b-row>
                            <b-col md="6">
                              <Vinput
                                inputType="email"
                                :modelValue="addData.email"
                                @update:modelValue="
                                  (newValue) => (addData.email = newValue)
                                "
                                :rules="{regex:/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/}"
                                id="text-email"
                                name="text-email"
                                label="Email Address"
                                class="mb-3"
                                description="Valid email address for communication"
                                validatorName="Email"
                              />
                            </b-col>
                            <b-col md="6">
                              <VinputGroup
                                inputType="text"
                                :modelValue="addData.phoneNumber"
                                @update:modelValue="
                                  (newValue) => (addData.phoneNumber = newValue)
                                "
                                :rules="{ required: true, regex:/^\d{9}$/ }"
                                id="text-phoneNumber"
                                name="text-phoneNumber"
                                label="Phone Number"
                                class="mb-3"
                                description="9-digit phone number"
                                validatorName="Phone Number"
                                prepend="+251"
                              />
                            </b-col>
                          </b-row>
                          <b-row>
                            <b-col md="12">
                              <Vinput
                                inputType="textarea"
                                :modelValue="addData.address"
                                @update:modelValue="
                                  (newValue) => (addData.address = newValue)
                                "
                                :rules="{ required: true }"
                                id="text-address"
                                name="text-address"
                                label="Address"
                                class="mb-3"
                                description="Complete residential address"
                                validatorName="Address"
                                rows="2"
                              />
                            </b-col>
                          </b-row>
                        </b-card>
                    </template>
                  </b-row>
                </b-form>
              </validation-observer>
            </div>
            
            <!-- Step 3: Contract Details -->
            <div v-if="currentStep === 3">
              <validation-observer ref="step3Observer" v-slot="{ handleSubmit }">
                <b-form @submit.stop.prevent="handleSubmit(nextStep)">
                  <b-row no-gutters>
                    <b-col md="12">
                      <h6 class="section-title mb-3" style="color: rgb(37, 91, 48) !important;">
                        <b-icon icon="ui-checks"></b-icon> Contract Details
                      </h6>
                    </b-col>

                       <!-- Contract Period -->
                        <b-card class="mb-3" border-variant="light">
                          <template #header>
                            <h6 class="mb-0 text-primary"><b-icon icon="calendar-range"></b-icon> Contract Period</h6>
                          </template>
                          <b-row>
                            <b-col md="4">
                              <Vinput
                                inputType="date"
                                :modelValue="addData.startDate"
                                @update:modelValue="
                                  (newValue) => (addData.startDate = newValue)
                                "
                                :rules="{ required: true }"
                                id="text-startDate"
                                name="text-startDate"
                                label="Contract Start Date"
                                class="mb-3"
                                description="When the rental agreement begins"
                                validatorName="Start Date"
                              />
                            </b-col>
                            <b-col md="4">
                              <Vinput
                                inputType="date"
                                :modelValue="addData.endDate"
                                @update:modelValue="
                                  (newValue) => (addData.endDate = newValue)
                                "
                                :rules="{ required: true }"
                                id="text-endDate"
                                name="text-endDate"
                                label="Contract End Date"
                                class="mb-3"
                                description="When the rental agreement expires"
                                validatorName="End Date"
                              />
                            </b-col>
                            <b-col md="4">
                              <Vinput
                                inputType="range"
                                :modelValue="addData.dueDate"
                                @update:modelValue="
                                  (newValue) => (addData.dueDate = newValue)
                                "
                                :rules="{ required: true }"
                                id="text-dueDate"
                                name="text-dueDate"
                                :label="daysMessage"
                                class="mb-3"
                                description="Grace period for payment"
                                validatorName="Due Date"
                                min="0"
                                max="15"
                                :step="1"
                                :title="addData.dueDate.toString()"
                              />
                            </b-col>
                          </b-row>
                        </b-card>
                        <!-- Payment Terms -->
                        <b-card class="mb-3" border-variant="success">
                          <template #header>
                            <h6 class="mb-0 text-success"><b-icon icon="cash-stack"></b-icon> Payment Terms</h6>
                          </template>
                          <b-row>
                            <b-col md="6">
                              <label class="form-label">Advance Payment Period</label>
                              <b-row>
                                <b-col md="6">
                                  <Vselect
                                    :modelValue="addData.advancePeriod"
                                    @update:modelValue="(newValue) => (addData.advancePeriod = newValue)"
                                    :options="periodOptions"
                                    :rules="{ required: true }"
                                    id="text-advance-period"
                                    name="text-advance-period"
                                    label="Number"
                                    class="mb-3 some-select"
                                    description="text-period-feedback"
                                    validatorName="Advance Period"
                                  />
                                </b-col>
                                <b-col md="6">
                                  <Vselect
                                    :modelValue="addData.advancePeriodtwo"
                                    @update:modelValue="(newValue) =>{ (addData.advancePeriodtwo = newValue); updateInitialPayment();}"
                                    :options="periodOptions2"
                                    :rules="{ required: true }"
                                    id="text-advancePeriodtwo"
                                    name="text-advancePeriodtwo"
                                    label="Unit"
                                    class="mb-3 some-select"
                                    description="text-advancePeriodtwo-feedback"
                                    validatorName="Period Unit"
                                  />
                                </b-col>
                              </b-row>
                            </b-col>
                            <b-col md="6">
                              <VinputNumber
                                inputType="number"
                                :modelValue="addData.initialPayment"
                                @update:modelValue="(newValue) => (addData.initialPayment = newValue)"
                                :rules="{ }"
                                id="text-InitalPayment"
                                name="text-InitalPayment"
                                label="Advance Payment Amount"
                                class="mb-3"
                                description="Automatically calculated based on period"
                                validatorName="Advance Payment"
                                :step=".01"
                                disabled
                              />
                            </b-col>
                          </b-row>
                          <b-row>
                            <b-col md="6">
                              <VinputNumber
                                inputType="number"
                                :modelValue="addData.guaranteedMoney"
                                @update:modelValue="
                                  (newValue) => (addData.guaranteedMoney = newValue)
                                "
                                :rules="{ }"
                                id="text-guaranteedMoney"
                                name="text-guaranteedMoney"
                                label="Security Deposit"
                                class="mb-3"
                                description="Refundable security deposit amount"
                                validatorName="Security Deposit"
                                :step=".01"
                              />
                            </b-col>
                          </b-row>
                        </b-card>
                        <b-row style="margin-left: 0px;">
                        <b-col
                          xs="1"
                          style="justify-content: center; align-items: center"
                        >
                         <Vselect
                          :modelValue="addData.period"
                          @update:modelValue="
                            (newValue) => (addData.period = newValue)
                          "
                            :options="periodOptions"
                          :rules="{ required: true }"
                          id="text-period"
                          name="text-period"
                          label="Rent Payment Period"
                          class="mb-1 mr-sm-2 some-select"
                          description="text-period-feedback"
                          validatorName="Rent Payment Period"
                        />
                        </b-col>
                         <b-col
                          xs="2"
                          style="justify-content: center; align-items: center"
                        >
                        <Vselect
                          :modelValue="addData.periodtwo"
                          @update:modelValue="
                            (newValue) => (addData.periodtwo = newValue)
                          "
                            :options="periodOptions2"
                          :rules="{ required: true }"
                          id="text-periodtwo"
                          name="text-periodtwo"
                          label="*"
                          class="mb-1 mr-sm-2 some-select"
                          description="text-periodtwo-feedback"
                          validatorName="Period"
                        />
                        </b-col>
                        <!-- hellohello -->
                        <b-col
                          xs="9"
                          style="justify-content: right; align-items: right"
                        ></b-col>
                        </b-row>
                        <b-row>
                          <b-col md="6">
                            <Vselect
                            :modelValue="addData.withHolding"
                            @update:modelValue="
                              (newValue) => (addData.withHolding = newValue)
                            "
                              :options="withHoldingOptionValue"
                            :rules="{ required: true }"
                            id="text-withHolding-option-options"
                            name="text-withHolding-option-options"
                            label="Withholding Tax (3%)"
                            class="mb-1 mr-sm-2 some-select"
                            description="text-withHolding-option-options-feedback"
                            validatorName="Withholding Tax (3%)"
                            />
                          </b-col>
                          <b-col md="6">
                            <Vselect
                            :modelValue="addData.penaltyOption"
                            @update:modelValue="
                              (newValue) => (addData.penaltyOption = newValue)
                            "
                              :options="penaltyOptionValue"
                            :rules="{ required: true }"
                            id="text-penalty-option-options"
                            name="text-penalty-option-options"
                            label="Penalty Options"
                            class="mb-1 mr-sm-2 some-select"
                            description="text-penalty-option-options-feedback"
                            validatorName="Penalty Options"
                            />
                          </b-col>
                        </b-row>
                       <!-- Penalty Condition -->
                        <b-col
                          md="12"
                          style="justify-content: center; align-items: center"
                          v-if="showPenaltyFields"
                        >
                          <Vselect
                            :modelValue="addData.penaltyCondition"
                            @update:modelValue="
                              (newValue) => (addData.penaltyCondition = newValue)
                            "
                            :options="penaltyConditionValue"
                            :rules="{ required: true }"
                            id="text-penalty-condition-options"
                            name="text-penalty-condition-options"
                            label="Penalty Condition"
                            class="mb-1 mr-sm-2"
                            description="text-penalty-condition-options-feedback"
                            validatorName="Penalty Condition"
                          />
                        </b-col>
                        
                        <!-- Date Range for Penalty Increment -->
                        <b-col
                          md="12"
                          style="justify-content: center; align-items: center"
                          v-if="showPenaltyFields && addData.penaltyCondition === 'incremental'"
                        >
                          <Vselect
                            :modelValue="addData.dateRangeForPenaltyIncrement"
                            @update:modelValue="
                              (newValue) => (addData.dateRangeForPenaltyIncrement = newValue)
                            "
                            :options="dateRangeOption"
                            :rules="{ required: true }"
                            id="text-penalty-date-range-options"
                            name="text-penalty-date-range-options"
                            label="Date Range for Penalty Increment"
                            class="mb-1 mr-sm-2 some-select"
                            description="text-penalty-date-range-options-feedback"
                            validatorName="Date Range for Penalty Increment"
                          />
                        </b-col>
                        
                        <!-- Custom Date Range Input -->
                        <b-col
                          md="12"
                          style="justify-content: center; align-items: center"
                          v-if="showPenaltyFields && addData.penaltyCondition === 'incremental' && addData.dateRangeForPenaltyIncrement === 'Other'"
                        >
                          <VinputNumber
                            inputType="number"
                            :modelValue="addData.dateRangeForUserInput"
                            @update:modelValue="
                              (newValue) => (addData.dateRangeForUserInput = newValue)
                            "
                            :rules="{ required: true }"
                            id="text-dateRangeForUserInput"
                            name="text-dateRangeForUserInput"
                            label="Another Date Range"
                            class="mb-1 mr-sm-2"
                            description="text-otherDateRange-feedback"
                            validatorName="Another Date Range"
                            :step="1"
                          />
                        </b-col>
                        
                        <!-- Penalty Amount for Percentage -->
                        <b-col
                          md="12"
                          style="justify-content: center; align-items: center"
                          v-if="showPenaltyFields && addData.penaltyOption === 'percentage'"
                        >
                          <Vselect
                            :modelValue="addData.penaltyAmount"
                            @update:modelValue="
                              (newValue) => (addData.penaltyAmount = newValue)
                            "
                            :options="penaltyAmountPercentOption"
                            :rules="{ required: true }"
                            id="text-penalty-amount-percent-options"
                            name="text-penalty-amount-percent-options"
                            label="Penalty Amount"
                            class="mb-1 mr-sm-2 some-select"
                            description="text-penalty-amount-percent-options-feedback"
                            validatorName="Penalty Amount"
                          />
                        </b-col>
                        
                        <!-- Custom Penalty Percentage Input -->
                        <b-col
                          md="12"
                          style="justify-content: center; align-items: center"
                          v-if="showPenaltyFields && addData.penaltyOption === 'percentage' && addData.penaltyAmount === 'Other'"
                        >
                          <VinputNumber
                            inputType="number"
                            :modelValue="addData.penaltyAmountPercent"
                            @update:modelValue="
                              (newValue) => (addData.penaltyAmountPercent = newValue)
                            "
                            :rules="{ required: true }"
                            id="text-penaltyAmountPercent"
                            name="text-penaltyAmountPercent"
                            label="Penalty Amount of monthly price in percent"
                            class="mb-1 mr-sm-2"
                            description="text-otherPenaltyPercent-feedback"
                            validatorName="Penalty Amount of monthly price in percent"
                            :step=".01"
                          />
                        </b-col>
                        
                        <!-- Penalty Amount for Fixed Amount -->
                        <b-col
                          md="12"
                          style="justify-content: center; align-items: center"
                          v-if="showPenaltyFields && addData.penaltyOption === 'fixedAmount'"
                        >
                          <Vselect
                            :modelValue="addData.penaltyAmount"
                            @update:modelValue="
                              (newValue) => (addData.penaltyAmount = newValue)
                            "
                            :options="penaltyAmountFixedOption"
                            :rules="{ required: true }"
                            id="text-penalty-amount-fixed-options"
                            name="text-penalty-amount-fixed-options"
                            label="Penalty Amount"
                            class="mb-1 mr-sm-2 some-select"
                            description="text-penalty-amount-fixed-options-feedback"
                            validatorName="Penalty Amount"
                          />
                        </b-col>
                        
                        <!-- Custom Fixed Penalty Amount Input -->
                        <b-col
                          md="12"
                          style="justify-content: center; align-items: center"
                          v-if="showPenaltyFields && addData.penaltyOption === 'fixedAmount' && addData.penaltyAmount === 'Other'"
                        >
                          <VinputNumber
                            inputType="number"
                            :modelValue="addData.penaltyAmountFixed"
                            @update:modelValue="
                              (newValue) => (addData.penaltyAmountFixed = newValue)
                            "
                            :rules="{ required: true }"
                            id="text-penaltyAmountFixed"
                            name="text-penaltyAmountFixed"
                            label="Fixed Amount of penalty"
                            class="mb-1 mr-sm-2"
                            description="text-otherPenaltyFixed-feedback"
                            validatorName="Fixed Amount of penalty"
                            :step=".01"
                          />
                        </b-col>
                        <!-- <b-col
                          md="12"
                          style="justify-content: center; align-items: center"
                        >
                        Payment Conditions 
                        </b-col>
                       <b-col
                          md="12"
                          style="justify-content: center; align-items: center"
                        >
                          <b-form-checkbox  v-model="aboveSelected">Advance Payment</b-form-checkbox>
                        </b-col>
                        <b-col
                          md="12"
                          style="justify-content: center; align-items: center"
                        >
                          <b-form-checkbox  v-model="belowSelected">Partial Payment</b-form-checkbox>
                        </b-col> -->
                         <b-col
                          md="12"
                          style="justify-content: center; align-items: center"
                        >
                        Attached Document
                        </b-col>
                        <b-col
                          md="12"
                          style="justify-content: center; align-items: center"
                        >
                        <b-form-file v-model="file" ref="file-input" class="mb-2" accept=".pdf,.jpg,.png,.jpeg,.doc,.docx" @change="handleFileChange" :disabled="isUploading"></b-form-file>
                        <p class="mt-2">Selected file: <b>{{ file ? file.name : '' }}</b></p>
                        <div v-if="fileError" class="text-danger mt-2">{{ fileError }}</div>
                        <div v-if="isUploading" class="mt-2">
                          <b-progress :value="uploadProgress" :max="100" show-progress animated></b-progress>
                          <small class="text-muted">Uploading... {{ uploadProgress }}%</small>
                        </div>
                        </b-col>
                  </b-row>
                </b-form>
              </validation-observer>
            </div>
            
            <!-- Step 4: Contract Review -->
            <div v-if="currentStep === 4">
              <div class="contract-review-section">
                <div class="text-center mb-3">
                  <h6 class="section-title" style="color: rgb(37, 91, 48) !important;">
                    <b-icon icon="file-pdf"></b-icon> Contract Review
                  </h6>
                </div>
                <div class="contract-review-container">
                  <div class="text-center mb-4">
                    <h4 class="text-primary">Contract Agreement Review</h4>
                    <p class="text-muted">Please review all contract details before submission</p>
                  </div>
                        <!-- Contract Summary Document -->
                        <div class="contract-document bg-light p-4 rounded border">
                          <div class="document-header text-center mb-4">
                            <h5 class="text-primary mb-1">RENTAL AGREEMENT CONTRACT</h5>
                            <p class="text-muted small">This agreement is made between the landlord and tenant under the following terms and conditions</p>
                          </div>
                          
                          <!-- Action Buttons -->
                          <div class="text-center mb-4">
                            <b-button-group>
                              <b-button variant="outline-primary" @click="printContract">
                                <b-icon icon="printer"></b-icon> Print Agreement
                              </b-button>
                              <b-button variant="outline-success" @click="downloadContract">
                                <b-icon icon="download"></b-icon> Download PDF
                              </b-button>
                            </b-button-group>
                          </div>
                          
                          <!-- Parties Section -->
                          <div class="contract-section mb-4">
                            <h6 class="section-title border-bottom pb-2 mb-3" style="color: rgb(37, 91, 48) !important;">
                              <b-icon icon="people-fill"></b-icon> PARTIES TO THE AGREEMENT
                            </h6>
                            <b-card no-body class="border-0">
                              <b-row no-gutters>
                                <b-col md="6">
                                  <b-card class="h-100 border-primary">
                                    <h6 class="text-white mb-2 p-2 rounded" style="background-color: rgb(37, 91, 48) !important;">LANDLORD</h6>
                                    <b-row>
                                      <b-col cols="6"><strong>Name:</strong></b-col>
                                      <b-col cols="6">
                                        <b-form-input v-model="landlordName" placeholder="Enter landlord name" size="sm" style="border:none;border-bottom:1px solid #333;border-radius:0;padding:0;"></b-form-input>
                                      </b-col>
                                      <b-col cols="6"><strong>Role:</strong></b-col>
                                      <b-col cols="6">Lessor</b-col>
                                      <b-col cols="6"><strong>Rep. by:</strong></b-col>
                                      <b-col cols="6">{{ getCurrentUserName() }}</b-col>
                                    </b-row>
                                  </b-card>
                                </b-col>
                                <b-col md="6">
                                  <b-card class="h-100 border-primary">
                                    <h6 class="text-white mb-2 p-2 rounded" style="background-color: rgb(37, 91, 48) !important;">TENANT</h6>
                                    <template v-if="tenantType === 'existing'">
                                      <b-row>
                                        <b-col cols="6"><strong>Name:</strong></b-col>
                                        <b-col cols="6">{{ getTenantName }}</b-col>
                                        <b-col cols="6"><strong>Role:</strong></b-col>
                                        <b-col cols="6">Lessee</b-col>
                                        <b-col cols="6"><strong>Status:</strong></b-col>
                                        <b-col cols="6">Existing</b-col>
                                      </b-row>
                                    </template>
                                    <template v-else>
                                      <b-row>
                                        <b-col cols="6"><strong>Name:</strong></b-col>
                                        <b-col cols="6">{{ addData.fullName }}</b-col>
                                        <b-col cols="6"><strong>Email:</strong></b-col>
                                        <b-col cols="6">{{ addData.email }}</b-col>
                                        <b-col cols="6"><strong>Phone:</strong></b-col>
                                        <b-col cols="6">+251{{ addData.phoneNumber }}</b-col>
                                        <b-col cols="6"><strong>Address:</strong></b-col>
                                        <b-col cols="6">{{ addData.address }}</b-col>
                                        <b-col cols="6"><strong>Gender:</strong></b-col>
                                        <b-col cols="6">{{ addData.sex }}</b-col>
                                      </b-row>
                                    </template>
                                  </b-card>
                                </b-col>
                              </b-row>
                            </b-card>
                          </div>
                          
                          <!-- Property Section -->
                          <div class="contract-section mb-4">
                            <h6 class="section-title border-bottom pb-2 mb-3" style="color: rgb(37, 91, 48) !important;">
                              <b-icon icon="house-door"></b-icon> PROPERTY DETAILS
                            </h6>
                            <b-card class="border-primary">
                              <h6 class="text-white mb-3 p-2 rounded" style="background-color: rgb(37, 91, 48) !important;">Property Description</h6>
                              <p class="mb-3">The landlord hereby agrees to rent to the tenant the following described property:</p>
                              
                              <template v-if="houseType === 'existing'">
                                <b-row>
                                  <b-col cols="4"><strong>Property:</strong></b-col>
                                  <b-col cols="8">{{ getHouseName }}</b-col>
                                  <b-col cols="4"><strong>Pricing:</strong></b-col>
                                  <b-col cols="8">{{ getPriceOptionByValue }}</b-col>
                                  <b-col cols="4"><strong>Currency:</strong></b-col>
                                  <b-col cols="8">{{ getRentCurrencyType }}</b-col>
                                  <b-col cols="4"><strong>Rate:</strong></b-col>
                                  <b-col cols="8">{{ numberWithCommas(parseFloat(getPriceByValue.replace(/,/g, ''))) }} per {{ getPriceOptionByValue === 'PerSquareMeter' ? 'sq.m' : 'month' }} ({{ vatLabel }})</b-col>
                                  <!-- <b-col v-if="getPriceOptionByValue === 'PerSquareMeter'" cols="4"><strong>Monthly:</strong></b-col>
                                  <b-col v-if="getPriceOptionByValue === 'PerSquareMeter'" cols="8">{{ computedPriceExist }}</b-col> -->
                                  <!-- <b-col cols="4"><strong>VAT (15%):</strong></b-col>
                                  <b-col cols="8">{{ vatLabel }}</b-col> -->
                                  <b-col cols="4"><strong>Rent Amount(Before VAT):</strong></b-col>
                                  <b-col cols="8">{{ numberWithCommas(existingPriceBeforeVat) }} {{ getRentCurrencyType }}</b-col>
                                  <b-col cols="4"><strong>VAT Amount:</strong></b-col>
                                  <b-col cols="8">{{ numberWithCommas(existingVatAmount) }} {{ getRentCurrencyType }}</b-col>
                                  <b-col cols="4"><strong>Total Amount:</strong></b-col>
                                  <b-col cols="8"><strong>{{ numberWithCommas(existingPriceAfterVat) }} {{ getRentCurrencyType }}</strong></b-col>
                                </b-row>
                              </template>
                              <template v-else>
                                <b-row>
                                  <b-col cols="4"><strong>Building:</strong></b-col>
                                  <b-col cols="8">{{ getBuildingName }}</b-col>
                                  <b-col cols="4"><strong>Floor:</strong></b-col>
                                  <b-col cols="8">{{ addData.floor }}</b-col>
                                  <b-col cols="4"><strong>Room:</strong></b-col>
                                  <b-col cols="8">{{ addData.roomNumber }}</b-col>
                                  <b-col cols="4"><strong>Size:</strong></b-col>
                                  <b-col cols="8">{{ addData.size }} sq.m</b-col>
                                  <b-col cols="4"><strong>Pricing:</strong></b-col>
                                  <b-col cols="8">{{ addData.priceOption }}</b-col>
                                  <b-col cols="4"><strong>Currency:</strong></b-col>
                                  <b-col cols="8">{{ addData.rentCurrencyType }}</b-col>
                                  <b-col cols="4"><strong>Rate:</strong></b-col>
                                  <b-col cols="8">{{ numberWithCommas(addData.latest_price) }} per {{ addData.priceOption === 'PerSquareMeter' ? 'sq.m' : 'month' }}</b-col>
                                  <b-col v-if="addData.priceOption === 'PerSquareMeter'" cols="4"><strong>Monthly:</strong></b-col>
                                  <b-col v-if="addData.priceOption === 'PerSquareMeter'" cols="8">{{ numberWithCommas(computedPrice) }}</b-col>
                                  <b-col cols="4"><strong>VAT (15%):</strong></b-col>
                                  <b-col cols="8">{{ vatLabel }}</b-col>
                                  <b-col cols="4"><strong>Price Before VAT:</strong></b-col>
                                  <b-col cols="8">{{ numberWithCommas(newPriceBeforeVat) }} {{ addData.rentCurrencyType }}</b-col>
                                  <b-col cols="4"><strong>VAT Amount:</strong></b-col>
                                  <b-col cols="8">{{ numberWithCommas(newVatAmount) }} {{ addData.rentCurrencyType }}</b-col>
                                  <b-col cols="4"><strong>Price After VAT:</strong></b-col>
                                  <b-col cols="8"><strong>{{ numberWithCommas(newPriceAfterVat) }} {{ addData.rentCurrencyType }}</strong></b-col>
                                  <b-col v-if="addData.description" cols="4"><strong>Description:</strong></b-col>
                                  <b-col v-if="addData.description" cols="8">{{ addData.description }}</b-col>
                                </b-row>
                              </template>
                            </b-card>
                          </div>
                          
                          <!-- Terms and Conditions Section -->
                          <div class="contract-section mb-4">
                            <h6 class="section-title border-bottom pb-2 mb-3" style="color: rgb(37, 91, 48) !important;">
                              <b-icon icon="file-text"></b-icon> TERMS AND CONDITIONS
                            </h6>
                            <b-row>
                              <b-col md="6">
                                <b-card class="h-100 border-primary">
                                  <h6 class="text-white mb-2 p-2 rounded" style="background-color: rgb(37, 91, 48) !important;">Lease Period</h6>
                                  <p class="mb-3">This lease agreement shall commence on <strong>{{ addData.startDate }}</strong> and shall terminate on <strong>{{ addData.endDate }}</strong>.</p>
                                  <p class="mb-3"><strong>Duration:</strong> {{ contractDuration }}</p>
                                  
                                  <h6 class="text-white mb-2 p-2 rounded" style="background-color: rgb(37, 91, 48) !important;">Payment Terms</h6>
                                  <b-row class="mb-2">
                                    <b-col cols="6"><strong>Frequency:</strong></b-col>
                                    <b-col cols="6">{{ addData.period }} {{ addData.periodtwo === 1 ? 'month(s)' : 'year(s)' }}</b-col>
                                    <b-col cols="6"><strong>Due Date:</strong></b-col>
                                    <b-col cols="6">{{ addData.dueDate }} days</b-col>
                                    <template v-if="addData.initialPayment > 0">
                                      <b-col cols="6"><strong>Advance Amount:</strong></b-col>
                                      <b-col cols="6">{{ numberWithCommas(addData.initialPayment) }} {{ advanceCurrency }}</b-col>
                                      <b-col cols="6"><strong>Advance Before VAT:</strong></b-col>
                                      <b-col cols="6">{{ numberWithCommas(advanceBeforeVat) }} {{ advanceCurrency }}</b-col>
                                      <b-col cols="6"><strong>Advance VAT Amount:</strong></b-col>
                                      <b-col cols="6">{{ numberWithCommas(advanceVatAmount) }} {{ advanceCurrency }}</b-col>
                                      <b-col cols="6"><strong>Advance After VAT:</strong></b-col>
                                      <b-col cols="6"><strong>{{ numberWithCommas(advanceAfterVat) }} {{ advanceCurrency }}</strong></b-col>
                                    </template>
                                  </b-row>
                                </b-card>
                              </b-col>
                              
                              <b-col md="6">
                                <b-card class="h-100 border-primary">
                                  <h6 class="text-white mb-2 p-2 rounded" style="background-color: rgb(37, 91, 48) !important;">Security & Penalties</h6>
                                  <b-row class="mb-2">
                                    <b-col v-if="addData.guaranteedMoney > 0" cols="6"><strong>Deposit:</strong></b-col>
                                    <b-col v-if="addData.guaranteedMoney > 0" cols="6">{{ numberWithCommas(addData.guaranteedMoney) }} {{ addData.rentCurrencyType || 'ETB' }}</b-col>
                                    <b-col cols="6"><strong>Penalty:</strong></b-col>
                                    <b-col cols="6">{{ addData.penaltyOption === 'noPenalty' ? 'None' : getPenaltyDescription() }}</b-col>
                                  </b-row>
                                  
                                  <h6 class="text-white mb-2 p-2 rounded" style="background-color: rgb(37, 91, 48) !important;">Tax Information</h6>
                                  <b-row>
                                    <b-col cols="6"><strong>VAT (15%):</strong></b-col>
                                    <b-col cols="6">{{ vatLabel }}</b-col>
                                    <b-col cols="6"><strong>W.Tax (3%):</strong></b-col>
                                    <b-col cols="6">{{ addData.withHolding === 'Yes' ? 'Applicable' : 'Not Applicable' }}</b-col>
                                    <b-col cols="6"><strong>Price Before VAT:</strong></b-col>
                                    <b-col cols="6">{{ numberWithCommas(houseType === 'existing' ? existingPriceBeforeVat : newPriceBeforeVat) }}</b-col>
                                    <b-col cols="6"><strong>VAT Amount:</strong></b-col>
                                    <b-col cols="6">{{ numberWithCommas(houseType === 'existing' ? existingVatAmount : newVatAmount) }}</b-col>
                                    <b-col cols="6"><strong>Price After VAT:</strong></b-col>
                                    <b-col cols="6"><strong>{{ numberWithCommas(houseType === 'existing' ? existingPriceAfterVat : newPriceAfterVat) }}</strong></b-col>
                                  </b-row>
                                </b-card>
                              </b-col>
                            </b-row>
                          </div>
                          
                          <!-- Utilities Section -->
                          <div class="contract-section mb-4" v-if="hasUtilities()">
                            <h6 class="section-title border-bottom pb-2 mb-3" style="color: rgb(37, 91, 48) !important;">
                              <b-icon icon="lightning"></b-icon> UTILITIES AND SERVICES
                            </h6>
                            <b-card class="border-primary">
                              <h6 class="text-white mb-3 p-2 rounded" style="background-color: rgb(37, 91, 48) !important;">Utility Services</h6>
                              <p class="mb-3">The following utilities and services are included with this rental agreement:</p>
                              
                              <b-row>
                                <template v-if="showElectricReading()">
                                  <b-col cols="4"><strong>Electricity:</strong></b-col>
                                  <b-col cols="8">Base reading: {{ addData.electricReading }} KWH</b-col>
                                </template>
                                
                                <template v-if="showWaterReading()">
                                  <b-col cols="4"><strong>Water:</strong></b-col>
                                  <b-col cols="8">Base reading: {{ addData.waterReading }} m³</b-col>
                                </template>
                                
                                <template v-if="addData.firstBillPaymentStarts">
                                  <b-col cols="4"><strong>First Bill:</strong></b-col>
                                  <b-col cols="8">{{ addData.firstBillPaymentStarts }}</b-col>
                                </template>
                              </b-row>
                            </b-card>
                          </div>
                          
                          <!-- Legal Agreement Section -->
                          <div class="contract-section mb-4">
                            <h6 class="section-title border-bottom pb-2 mb-3" style="color: rgb(37, 91, 48) !important;">
                              <b-icon icon="shield-check"></b-icon> LEGAL AGREEMENT
                            </h6>
                            <b-card class="border-primary">
                              <h6 class="text-white mb-3 p-2 rounded" style="background-color: rgb(37, 91, 48) !important;">Agreement Terms</h6>
                              
                              <b-row class="mb-3">
                                <b-col cols="4"><strong>Acknowledgment:</strong></b-col>
                                <b-col cols="8">Both parties agree to all terms and conditions</b-col>
                                <b-col cols="4"><strong>Governing Law:</strong></b-col>
                                <b-col cols="8">Laws of Ethiopia</b-col>
                                <b-col cols="4"><strong>Document:</strong></b-col>
                                <b-col cols="8">{{ file ? file.name : 'No additional documents' }}</b-col>
                              </b-row>
                              
                              <h6 class="text-white mb-3 p-2 rounded" style="background-color: rgb(37, 91, 48) !important;">Signatures</h6>
                              <b-row>
                                <b-col md="6">
                                  <div class="signature-box p-3 border rounded bg-light">
                                    <p class="mb-1"><strong>Landlord Signature:</strong></p>
                                    <div class="signature-line border-bottom mb-2" style="height: 40px;"></div>
                                    <small class="text-muted">Date: _______________</small>
                                  </div>
                                </b-col>
                                <b-col md="6">
                                  <div class="signature-box p-3 border rounded bg-light">
                                    <p class="mb-1"><strong>Tenant Signature:</strong></p>
                                    <div class="signature-line border-bottom mb-2" style="height: 40px;"></div>
                                    <small class="text-muted">Date: _______________</small>
                                  </div>
                                </b-col>
                              </b-row>
                            </b-card>
                          </div>
                        </div>
                </div>
              </div>
            </div>
            
            <!-- Navigation Buttons -->
            <div class="modal-navigation mt-4">
              <b-row class="justify-content-between align-items-center">
                <b-col cols="auto">
                  <b-button 
                    variant="outline-secondary" 
                    :disabled="currentStep === 1" 
                    @click="previousStep"
                    class="px-4"
                  >
                    <b-icon icon="chevron-left"></b-icon> Previous
                  </b-button>
                </b-col>
                <b-col cols="auto">
                  <div class="d-flex align-items-center">
                    <span class="text-muted me-2">Step {{ currentStep }} of 4</span>
                    <div class="progress" style="width: 120px; height: 6px;">
                      <div 
                        class="progress-bar" 
                        style="background-color: rgb(37, 91, 48) !important;"
                        :style="{ width: (currentStep / 4) * 100 + '%' }"
                      ></div>
                    </div>
                  </div>
                </b-col>
                <b-col cols="auto">
                  <b-button 
                    v-if="currentStep === 1"
                    variant="primary" 
                    @click="validateAndNextStep"
                    class="px-4 step-btn"
                    :class="{ 'btn-enabled': isStep1Valid }"
                    :disabled="!isStep1Valid"
                    style="background-color: rgb(37, 91, 48) !important; border-color: rgb(37, 91, 48) !important;"
                  >
                    Next <b-icon icon="chevron-right"></b-icon>
                  </b-button>
                  <b-button 
                    v-else-if="currentStep === 2"
                    variant="primary" 
                    @click="validateAndNextStep"
                    class="px-4 step-btn"
                    :class="{ 'btn-enabled': isStep2Valid }"
                    :disabled="!isStep2Valid"
                    style="background-color: rgb(37, 91, 48) !important; border-color: rgb(37, 91, 48) !important;"
                  >
                    Next <b-icon icon="chevron-right"></b-icon>
                  </b-button>
                  <b-button 
                    v-else-if="currentStep === 3"
                    variant="info"
                    @click="validateAndNextStep"
                    class="px-4 step-btn"
                    :class="{ 'btn-enabled': isStep3Valid }"
                    :disabled="!isStep3Valid"
                    style="background-color: #17a2b8 !important; border-color: #17a2b8 !important;"
                  >
                    <b-icon icon="eye"></b-icon> Preview
                  </b-button>
                  <b-button 
                    v-else
                    variant="success"
                    @click="handleSubmitClick"
                    class="px-4 submit-btn"
                    :class="{ 'btn-enabled': isFormValid && !isSubmitting }"
                    style="background-color: rgb(37, 91, 48) !important; border-color: rgb(37, 91, 48) !important;"
                    :disabled="!isFormValid || isUploading || isSubmitting"
                  >
                    <b-spinner v-if="isUploading || isSubmitting" small class="mr-2"></b-spinner>
                    <b-icon v-else icon="check-circle"></b-icon> 
                    {{ isUploading || isSubmitting ? 'Submitting...' : 'Submit Contract' }}
                  </b-button>
                </b-col>
              </b-row>
            </div>

          </b-modal> 
      </div>
      <div class="row">
        <b-modal
            id="modal-top-EditContract"
            hide-footer
            title="Edit Contract"
            content-class="shadow" 
          >
            <template #modal-header="{ close }">
              <h5>Edit Contract</h5>
              <p class="h5 mb-2">
                <b-icon
                  icon="x-square"
                  class="close-icon"
                  @click="
                    close();
                    clearData();
                  "
                ></b-icon>
              </p>
            </template>
            <validation-observer ref="observer" v-slot="{ handleSubmit }">
              <b-form
                class="text-left"
                @submit.stop.prevent="handleSubmit(confirmSubmitEditForm)"
              >
                <b-row no-gutters>
                  <b-col
                    md="12"
                    style="justify-content: center; align-items: center"
                  >
                    <Vinput
                      inputType="date"
                      :modelValue="editData.startDate"
                      @update:modelValue="
                        (newValue) => (editData.startDate = newValue)
                      "
                      :rules="{ required: true }"
                      id="text-startDate"
                      name="text-startDate"
                      label="Start Date"
                      class="mb-1 mr-sm-2"
                      description="text-startDate-feedback"
                      validatorName="Start Date"
                    />
                  </b-col>
                    <b-col
                    md="12"
                    style="justify-content: center; align-items: center"
                  >
                    <Vinput
                      inputType="date"
                      :modelValue="editData.endDate"
                      @update:modelValue="
                        (newValue) => (editData.endDate = newValue)
                      "
                      :rules="{ required: true }"
                      id="text-endDate"
                      name="text-endDate"
                      label="End Date"
                      class="mb-1 mr-sm-2"
                      description="text-endDate-feedback"
                      validatorName="End Date"
                    />
                  </b-col>
                    <b-col
                    md="12"
                    style="justify-content: center; align-items: center"
                  >
                    <Vinput
                      inputType="range"
                      :modelValue="editData.dueDate.toString()"
                      @update:modelValue="
                        (newValue) => (editData.dueDate = parseInt(newValue))
                      "
                      :rules="{ required: true }"
                      id="text-dueDate"
                      name="text-dueDate"
                      :label="daysMessageEdit"
                      class="mb-1 mr-sm-2"
                      description="text-dueDate-feedback"
                      validatorName="Due Date"
                      min="0"
                      max="15"
                      :step="1"
                      :title="editData.dueDate.toString()"
                    />
                  </b-col>
                  <!-- Payment Terms Section -->
                  <b-col md="12" class="mt-3 mb-2">
                    <h6 class="text-primary">Payment Terms</h6>
                  </b-col>
                  <b-col
                    md="12"
                    style="justify-content: center; align-items: center"
                  >
                    <VinputNumber
                      inputType="number"
                      :modelValue="editData.guaranteedMoney"
                      @update:modelValue="
                        (newValue) => (editData.guaranteedMoney = newValue)
                      "
                      :rules="{ }"
                      id="text-guaranteedMoney"
                      name="text-Guaranteed Money"
                      label="Security Deposit"
                      class="mb-1 mr-sm-2"
                      description="text-guaranteedMoney-feedback"
                      validatorName="Security Deposit"
                      :step=".01"
                    />
                  </b-col>
                  
                  <!-- Advance Payment Section -->
                  <b-col md="12" class="mt-3">
                    <h6 class="text-primary mb-3">Advance Payment Configuration</h6>
                    <b-col md="12">
                      <Vselect
                        :modelValue="editData.advancePeriod.toString()"
                        @update:modelValue="(newValue) => { editData.advancePeriod = parseInt(newValue); updateEditInitialPayment(); }"
                        :options="periodOptions"
                        :rules="{ required: true }"
                        id="text-advance-period-edit"
                        name="text-advance-period-edit"
                        label="Advance Period Number"
                        class="mb-3 some-select"
                        description="text-period-feedback"
                        validatorName="Advance Period"
                      />
                    </b-col>
                    <b-col md="12">
                      <Vselect
                        :modelValue="editData.advancePeriodtwo.toString()"
                        @update:modelValue="(newValue) => { editData.advancePeriodtwo = parseInt(newValue); updateEditInitialPayment(); }"
                        :options="periodOptions2"
                        :rules="{ required: true }"
                        id="text-advancePeriodtwo-edit"
                        name="text-advancePeriodtwo-edit"
                        label="Advance Period Unit"
                        class="mb-3 some-select"
                        description="text-advancePeriodtwo-feedback"
                        validatorName="Period Unit"
                      />
                    </b-col>
                    <b-col md="12">
                      <VinputNumber
                        inputType="number"
                        :modelValue="editData.initialPayment"
                        @update:modelValue="(newValue) => (editData.initialPayment = newValue)"
                        :rules="{ }"
                        id="text-InitalPayment-edit"
                        name="text-InitalPayment-edit"
                        label="Advance Payment Amount"
                        class="mb-3"
                        description="Auto-calculated"
                        validatorName="Advance Payment"
                        :step=".01"
                        disabled
                      />
                    </b-col>
                  </b-col>
                  
                  <!-- Rent Payment Period Section -->
                  <b-col md="12" class="mt-3">
                    <h6 class="text-primary mb-3">Rent Payment Configuration</h6>
                    <b-row>
                      <b-col
                        xs="1"
                        style="justify-content: center; align-items: center"
                      >
                        <Vselect
                        :modelValue="editData.period.toString()"
                        @update:modelValue="
                          (newValue) => { editData.period = parseInt(newValue); updateEditInitialPayment(); }
                        "
                          :options="periodOptions"
                        :rules="{ required: true }"
                        id="text-period"
                        name="text-period"
                        label="Period"
                        class="mb-1 mr-sm-2 some-select"
                        description="text-period-feedback"
                        validatorName="Period"
                      />
                      </b-col>
                        <b-col
                        xs="2"
                        style="justify-content: center; align-items: center"
                      >
                      <Vselect
                        :modelValue="editData.periodtwo.toString()"
                        @update:modelValue="
                          (newValue) => { editData.periodtwo = parseInt(newValue); updateEditInitialPayment(); }
                        "
                          :options="periodOptions2"
                        :rules="{ required: true }"
                        id="text-periodtwo"
                        name="text-periodtwo"
                        label="*"
                        class="mb-1 mr-sm-2 some-select"
                        description="text-periodtwo-feedback"
                        validatorName="Period"
                      />
                      </b-col>
                      <b-col
                        xs="2" style="justify-content: center; align-items: center"
                      >
                      <Vselect
                      :modelValue="editData.withHolding"
                      @update:modelValue="
                        (newValue) => (editData.withHolding = newValue)
                      "
                        :options="withHoldingOptionValue"
                      :rules="{ required: true }"
                      id="text-withHolding-option-options"
                      name="text-withHolding-option-options"
                      label="Withholding Tax (3%)"
                      class="mb-1 mr-sm-2 some-select"
                      description="text-withHolding-option-options-feedback"
                      validatorName="Withholding Tax (3%)"
                      />
                      </b-col>
                      <b-col
                        xs="2"
                        style="justify-content: center; align-items: center"
                      >
                      <Vselect
                      :modelValue="editData.penaltyOption"
                      @update:modelValue="
                        (newValue) => (editData.penaltyOption = newValue)
                      "
                        :options="penaltyOptionValue"
                      :rules="{ required: true }"
                      id="text-penalty-option-options"
                      name="text-penalty-option-options"
                      label="Penalty Options"
                      class="mb-1 mr-sm-2 some-select"
                      description="text-penalty-option-options-feedback"
                      validatorName="Penalty Options"
                      />
                      </b-col>
                       <template v-if="editData.penaltyOption === 'fixedAmount' || editData.penaltyOption === 'percentage'">
                        <b-col
                          md="12"
                          style="justify-content: center; align-items: center"
                        >
                      <Vselect
                          :modelValue="editData.penaltyCondition"
                          @update:modelValue="
                            (newValue) => (editData.penaltyCondition = newValue)
                          "
                            :options="penaltyConditionValue"
                          :rules="{ required: true }"
                          id="text-penalty-option-options"
                          name="text-penalty-condition-options"
                          label="Penalty Condition"
                          class="mb-1 mr-sm-2 some-select"
                          description="text-penalty-condition-options-feedback"
                          validatorName="Penalty Condition"
                          />
                        </b-col>
                        <template v-if="editData.penaltyCondition === 'incremental'">
                        <b-col
                          md="12"
                          style="justify-content: center; align-items: center"
                        >
                         <Vselect
                            :modelValue="editData.dateRangeForPenaltyIncrement"
                            @update:modelValue="
                              (newValue) => (editData.dateRangeForPenaltyIncrement = newValue)
                            "
                              :options="dateRangeOption"
                            :rules="{ required: true }"
                            id="text-penalty-option-options"
                            name="text-penalty-date-range-options"
                            label="Date Range for Penalty Increment"
                            class="mb-1 mr-sm-2 some-select"
                            description="text-penalty-date-range-options-feedback"
                            validatorName="Date Range for Penalty Increment"
                          />
                        </b-col>
                        <b-col
                    md="12"
                    style="justify-content: center; align-items: center"
                    v-if="editData.dateRangeForPenaltyIncrement === 'Other'"
                  >
                    <VinputNumber
                      inputType="number"
                      :modelValue="editData.dateRangeForUserInput"
                      @update:modelValue="
                        (newValue) => (editData.dateRangeForUserInput = newValue)
                      "
                      :rules="{ required: true }"
                      id="text-dateRangeForUserInput"
                      name="text-dateRangeForUserInput"
                      label="Another Date Range"
                      class="mb-1 mr-sm-2"
                      description="text-otherDateRange-feedback"
                      validatorName="Another Date Range"
                      :step="1"
                    />
                  </b-col>
                        </template>
                        <template v-if="editData.penaltyOption === 'percentage'">
                         <b-col
                          md="12"
                          style="justify-content: center; align-items: center"
                        >
                         <Vselect
                            :modelValue="editData.penaltyAmount"
                            @update:modelValue="
                              (newValue) => (editData.penaltyAmount = newValue)
                            "
                              :options="penaltyAmountPercentOption"
                            :rules="{ required: true }"
                            id="text-penalty-option-options"
                            name="text-penalty-amount-options"
                            label="Penalty Amount"
                            class="mb-1 mr-sm-2 some-select"
                            description="text-penalty-amount-options-feedback"
                            validatorName="Penalty Amount"
                          />
                        </b-col>
                        <b-col
                    md="12"
                    style="justify-content: center; align-items: center"
                    v-if="editData.penaltyAmount === 'Other'"
                  >
                    <VinputNumber
                      inputType="number"
                      :modelValue="editData.penaltyAmountPercent"
                      @update:modelValue="
                        (newValue) => (editData.penaltyAmountPercent = newValue)
                      "
                      :rules="{ required: true }"
                      id="text-penaltyAmountPercent"
                      name="text-penaltyAmountPercent"
                      label="Penalty Amount of monthy price in percent"
                      class="mb-1 mr-sm-2"
                      description="text-otherPenaltyPerent-feedback"
                      validatorName="Penalty Amount of monthy price in percent"
                      :step=".01"
                    />
                  </b-col>
                         </template>
                         <template v-if="editData.penaltyOption === 'fixedAmount'">
                              <b-col
                          md="12"
                          style="justify-content: center; align-items: center"
                        >
                         <Vselect
                            :modelValue="editData.penaltyAmount"
                            @update:modelValue="
                              (newValue) => (editData.penaltyAmount = newValue)
                            "
                              :options="penaltyAmountFixedOption"
                            :rules="{ required: true }"
                            id="text-penalty-option-options"
                            name="text-penalty-amount-options"
                            label="Penalty Amount"
                            class="mb-1 mr-sm-2 some-select"
                            description="text-penalty-amount-options-feedback"
                            validatorName="Penalty Amount"
                          />
                        </b-col>
                        <b-col
                    md="12"
                    style="justify-content: center; align-items: center"
                    v-if="editData.penaltyAmount === 'Other'"
                  >
                    <VinputNumber
                      inputType="number"
                      :modelValue="editData.penaltyAmountFixed"
                      @update:modelValue="
                        (newValue) => (editData.penaltyAmountFixed = newValue)
                      "
                      :rules="{ required: true }"
                      id="text-penaltyAmountFixed"
                      name="text-penaltyAmountFixed"
                      label="Fixed Amount of penality"
                      class="mb-1 mr-sm-2"
                      description="text-otherPenaltyPerent-feedback"
                      validatorName="Fixed Amount of penality"
                      :step=".01"
                    />
                  </b-col>
                        </template>
                        </template>
                      <b-col
                        xs="9"
                        style="justify-content: right; align-items: right"
                      ></b-col>
                    </b-row>
                  </b-col>

                  <b-col md="12" class="mt-3">
                    <p class="mt-2" v-if="editData.encodedPdf !== null && editData.encodedPdf !=='' ">Attached file: <b-badge @click="downloadFile(editData.contractId)" variant="primary">Document</b-badge></p>
                    <b-col
                      md="12"
                      style="justify-content: center; align-items: center"
                    >
                      Attach Document 
                    </b-col>
                    <b-col
                      md="12"
                      style="justify-content: center; align-items: center"
                    >
                      <b-form-file v-model="file" ref="file-input" class="mb-2" accept=".pdf,.jpg,.png,.jpeg,.doc,.docx" @change="handleFileChange" :disabled="isUploading"></b-form-file>
                      <p class="mt-2">Selected file: <b>{{ file ? file.name : '' }}</b></p>
                      <div v-if="fileError" class="text-danger mt-2">{{ fileError }}</div>
                      <div v-if="isUploading" class="mt-2">
                        <b-progress :value="uploadProgress" :max="100" show-progress animated></b-progress>
                        <small class="text-muted">Uploading... {{ uploadProgress }}%</small>
                      </div>
                    </b-col>
                  </b-col>
                  <b-col class="mt-2">
                    <b-button @click="handleEditSubmitClick" variant="primary" :disabled="isSubmitting">
                    <b-spinner v-if="isSubmitting" small class="mr-2"></b-spinner>
                    {{ isSubmitting ? 'Submitting...' : 'Submit' }}
                  </b-button>
                  </b-col>
                </b-row>
              </b-form>
            </validation-observer>
          </b-modal>
      </div>
      <div class="row">
        <b-modal
            id="modal-top-Details"
            hide-footer
            title="Contract Details"
            content-class="shadow" 
            size="xl"
          >
            <template #modal-header="{ close }">
              <h5>Contract Details</h5>
              <p class="h5 mb-2">
                <b-icon
                  icon="x-square"
                  class="close-icon"
                  @click="
                    close();
                    clearData();
                  "
                ></b-icon>
              </p>
            </template>
            
            <!-- Action Buttons -->
            <div class="text-center mb-4">
              <b-button-group>
                <b-button variant="outline-primary" @click="printContractDetail">
                  <b-icon icon="printer"></b-icon> Print Contract
                </b-button>
                <b-button variant="outline-success" @click="downloadContractDetail">
                  <b-icon icon="download"></b-icon> Download PDF
                </b-button>
              </b-button-group>
            </div>
            <!-- Contract Status Badge -->
            <b-row>
              <b-col md="9"></b-col>
              <b-col md="3" class="mb-2" style="display: flex; align-items: center; justify-content: right;">
                <b-badge v-if="selectedContract.contractInformation.status == 1" variant="primary" style="font-size: 16px;">Active Contract</b-badge>
                <b-badge v-else variant="secondary" style="font-size: 16px;">Inactive Contract</b-badge>
              </b-col>
            </b-row>
            
            <!-- Contract Document View -->
            <div class="contract-document bg-light p-4 rounded border">
              <div class="document-header text-center mb-4">
                <h5 class="text-primary mb-1">RENTAL AGREEMENT CONTRACT DETAILS</h5>
                <p class="text-muted small">Complete contract information and current status</p>
              </div>
              <!-- Parties Section -->
              <div class="contract-section mb-4">
                <h6 class="section-title border-bottom pb-2 mb-3" style="color: rgb(37, 91, 48) !important;">
                  <b-icon icon="people-fill"></b-icon> PARTIES TO THE AGREEMENT
                </h6>
                <b-card no-body class="border-0">
                  <b-row no-gutters>
                    <b-col md="6">
                      <b-card class="h-100 border-primary">
                        <h6 class="text-white mb-2 p-2 rounded" style="background-color: rgb(37, 91, 48) !important;">LANDLORD</h6>
                        <b-row>
                          <b-col cols="6"><strong>Name:</strong></b-col>
                          <b-col cols="6">
                            <b-form-input v-model="landlordName" placeholder="Enter landlord name" size="sm" style="border:none;border-bottom:1px solid #333;border-radius:0;padding:0;"></b-form-input>
                          </b-col>
                          <b-col cols="6"><strong>Role:</strong></b-col>
                          <b-col cols="6">Lessor</b-col>
                          <b-col cols="6"><strong>Rep. by:</strong></b-col>
                          <b-col cols="6">{{ getCurrentUserName() }}</b-col>
                        </b-row>
                      </b-card>
                    </b-col>
                    <b-col md="6">
                      <b-card class="h-100 border-primary">
                        <h6 class="text-white mb-2 p-2 rounded" style="background-color: rgb(37, 91, 48) !important;">TENANT</h6>
                        <b-row>
                          <b-col cols="6"><strong>Name:</strong></b-col>
                          <b-col cols="6">{{ selectedContract.tenantInformation.fullName }}</b-col>
                          <b-col cols="6"><strong>Email:</strong></b-col>
                          <b-col cols="6">{{ selectedContract.tenantInformation.email || 'Not provided' }}</b-col>
                          <b-col cols="6"><strong>Phone:</strong></b-col>
                          <b-col cols="6">{{ selectedContract.tenantInformation.phoneNumber }}</b-col>
                          <b-col cols="6"><strong>Address:</strong></b-col>
                          <b-col cols="6">{{ selectedContract.tenantInformation.address }}</b-col>
                        </b-row>
                      </b-card>
                    </b-col>
                  </b-row>
                </b-card>
              </div>
              
              <!-- Property Section -->
              <div class="contract-section mb-4">
                <h6 class="section-title border-bottom pb-2 mb-3" style="color: rgb(37, 91, 48) !important;">
                  <b-icon icon="house-door"></b-icon> PROPERTY DETAILS
                </h6>
                <b-card class="border-primary">
                  <h6 class="text-white mb-3 p-2 rounded" style="background-color: rgb(37, 91, 48) !important;">Property Description</h6>
                  <b-row>
                    <b-col cols="4"><strong>Building:</strong></b-col>
                    <b-col cols="8">{{ selectedContract.buildingInformation.buildingName }}</b-col>
                    <b-col cols="4"><strong>Floor:</strong></b-col>
                    <b-col cols="8">{{ selectedContract.houseInformation.floor }}</b-col>
                    <b-col cols="4"><strong>Room:</strong></b-col>
                    <b-col cols="8">{{ selectedContract.houseInformation.roomNumber }}</b-col>
                    <b-col cols="4"><strong>Size:</strong></b-col>
                    <b-col cols="8">{{ selectedContract.houseInformation.size }} sq.m</b-col>
                    <b-col cols="4"><strong>Pricing:</strong></b-col>
                    <b-col cols="8">{{ selectedContract.houseInformation.priceOption }}</b-col>
                    <b-col cols="4"><strong>Rate:</strong></b-col>
                    <b-col cols="8">{{ numberWithCommas(selectedContract.houseInformation.price) }} per {{ selectedContract.houseInformation.priceOption === 'PerSquareMeter' ? 'sq.m' : 'month' }}</b-col>
                    <b-col v-if="selectedContract.houseInformation.priceOption === 'PerSquareMeter'" cols="4"><strong>Monthly:</strong></b-col>
                    <b-col v-if="selectedContract.houseInformation.priceOption === 'PerSquareMeter'" cols="8">{{ numberWithCommas(selectedContract.houseInformation.price * selectedContract.houseInformation.size) }}</b-col>
                    <b-col cols="4"><strong>Status:</strong></b-col>
                    <b-col cols="8">{{ getStatus(selectedContract.houseInformation.status) }}</b-col>
                  </b-row>
                </b-card>
              </div>
              <!-- Terms and Conditions Section -->
              <div class="contract-section mb-4">
                <h6 class="section-title border-bottom pb-2 mb-3" style="color: rgb(37, 91, 48) !important;">
                  <b-icon icon="file-text"></b-icon> TERMS AND CONDITIONS
                </h6>
                <b-row>
                  <b-col md="6">
                    <b-card class="h-100 border-primary">
                      <h6 class="text-white mb-2 p-2 rounded" style="background-color: rgb(37, 91, 48) !important;">Lease Period</h6>
                      <b-row class="mb-2">
                        <b-col cols="6"><strong>From:</strong></b-col>
                        <b-col cols="6">{{ selectedContract.contractInformation.startDate }}</b-col>
                        <b-col cols="6"><strong>To:</strong></b-col>
                        <b-col cols="6">{{ selectedContract.contractInformation.endDate }}</b-col>
                        <b-col cols="6"><strong>Period:</strong></b-col>
                        <b-col cols="6">{{ getPeriod(selectedContract.contractInformation.period) }}</b-col>
                        <b-col cols="6"><strong>Due Date:</strong></b-col>
                        <b-col cols="6">{{ selectedContract.contractInformation.dueDate }} days</b-col>
                      </b-row>
                    </b-card>
                  </b-col>
                  
                  <b-col md="6">
                    <b-card class="h-100 border-primary">
                      <h6 class="text-white mb-2 p-2 rounded" style="background-color: rgb(37, 91, 48) !important;">Payment Status</h6>
                      <b-row class="mb-2">
                        <b-col cols="6"><strong>Rent Status:</strong></b-col>
                        <b-col cols="6">
                          <b-badge v-if="selectedContract.contractInformation.paymentStatus == 'Paid'" style="color: rgba(240, 206, 13, 0.937); background-color: rgb(37, 91, 48);">Paid</b-badge>
                          <b-badge v-if="selectedContract.contractInformation.paymentStatus == 'Unpaid'" variant="primary">Unpaid</b-badge>
                          <b-badge v-if="selectedContract.contractInformation.paymentStatus == 'Overdue'" variant="danger">Overdue</b-badge>
                        </b-col>
                        <b-col cols="6"><strong>Bill Status:</strong></b-col>
                        <b-col cols="6">
                          <b-badge v-if="selectedContract.contractInformation.billAmountStatus == 'Paid'" style="color: rgba(240, 206, 13, 0.937); background-color: rgb(37, 91, 48);">Paid</b-badge>
                          <b-badge v-if="selectedContract.contractInformation.billAmountStatus == 'Unpaid'" variant="primary">Unpaid</b-badge>
                          <b-badge v-if="selectedContract.contractInformation.billAmountStatus == 'Overdue'" variant="danger">Overdue</b-badge>
                        </b-col>
                        <b-col cols="6"><strong>Next Payment:</strong></b-col>
                        <b-col cols="6">{{ selectedContract.contractInformation.nextPaymentDate }}</b-col>
                        <b-col cols="6"><strong>Bill Payment:</strong></b-col>
                        <b-col cols="6">{{ selectedContract.contractInformation.billPaymentDate }}</b-col>
                      </b-row>
                    </b-card>
                  </b-col>
                </b-row>
              </div>
              
              <!-- Penalty Information -->
              <div class="contract-section mb-4" v-if="selectedContract.contractInformation.penaltyOption !== 'noPenalty'">
                <h6 class="section-title border-bottom pb-2 mb-3" style="color: rgb(37, 91, 48) !important;">
                  <b-icon icon="exclamation-triangle"></b-icon> PENALTY INFORMATION
                </h6>
                <b-card class="border-warning">
                  <b-row>
                    <b-col cols="4"><strong>Penalty Option:</strong></b-col>
                    <b-col cols="8">{{ selectedContract.contractInformation.penaltyOption }}</b-col>
                    <b-col cols="4"><strong>Penalty Condition:</strong></b-col>
                    <b-col cols="8">{{ selectedContract.contractInformation.penaltyCondition }}</b-col>
                    <b-col cols="4"><strong>Penalty Amount:</strong></b-col>
                    <b-col cols="8">{{ selectedContract.contractInformation.penaltyAmount }}</b-col>
                    <b-col v-if="selectedContract.contractInformation.dateRangeForPenaltyIncrement" cols="4"><strong>Increment Days:</strong></b-col>
                    <b-col v-if="selectedContract.contractInformation.dateRangeForPenaltyIncrement" cols="8">{{ selectedContract.contractInformation.dateRangeForPenaltyIncrement }}</b-col>
                  </b-row>
                </b-card>
              </div>
              <!-- Guaranty Information -->
              <div class="contract-section mb-4">
                <h6 class="section-title border-bottom pb-2 mb-3" style="color: rgb(37, 91, 48) !important;">
                  <b-icon icon="shield-check"></b-icon> GUARANTY INFORMATION
                </h6>
                <b-card class="border-success">
                  <b-row>
                    <b-col cols="4"><strong>Guaranty Amount:</strong></b-col>
                    <b-col cols="8">{{ numberWithCommas(selectedContract.guaranty.guarantyAmount) }} {{ selectedContract.guaranty.currency }}</b-col>
                    <b-col cols="4"><strong>Currency:</strong></b-col>
                    <b-col cols="8">{{ selectedContract.guaranty.currency }}</b-col>
                    <b-col cols="4"><strong>Status:</strong></b-col>
                    <b-col cols="8">{{ selectedContract.guaranty.status }}</b-col>
                  </b-row>
                </b-card>
              </div>
              
              <!-- Payment History -->
              <div class="contract-section mb-4" v-if="selectedContract.paymentHistory.length > 0">
                <h6 class="section-title border-bottom pb-2 mb-3" style="color: rgb(37, 91, 48) !important;">
                  <b-icon icon="cash-stack"></b-icon> PAYMENT HISTORY
                </h6>
                <b-card class="border-info">
                  <b-table-simple small striped hover>
                    <b-thead>
                      <b-tr>
                        <b-th>Payment Amount</b-th>
                        <b-th>Payment Date</b-th>
                      </b-tr>
                    </b-thead>
                    <b-tbody>
                      <b-tr v-for="(item, index) in selectedContract.paymentHistory" :key="index">
                        <b-td>{{ numberWithCommas(item.payedAmount) }}</b-td>
                        <b-td>{{ item.paymentDate }}</b-td>
                      </b-tr>
                      <b-tr class="table-active">
                        <b-td><strong>Total Paid:</strong></b-td>
                        <b-td><strong>{{ numberWithCommas(selectedContract.totalPayed) }}</strong></b-td>
                      </b-tr>
                    </b-tbody>
                  </b-table-simple>
                </b-card>
              </div>
            </div>
        </b-modal>
      </div>
      <div class="row">
        <b-modal
            id="modal-top-disable"
            hide-footer
            title="Terminate Contract"
            content-class="shadow" 
            size="xs"
          >
            <template #modal-header="{ close }">
                <h5>Terminate Contract</h5>
                <p class="h5 mb-2">
                  <b-icon
                    icon="x-square"
                    class="close-icon"
                    @click="
                      close();
                      clearData();
                    "
                  ></b-icon>
                </p>
            </template>
            <validation-observer ref="observer" v-slot="{ handleSubmit }">
              <b-form
                class="text-left"
                @submit.stop.prevent="handleSubmit(searchContractByID)"
              >
                <b-row no-gutters>
                  <b-col
                    md="12"
                    style="justify-content: center; align-items: center"
                  >
                    <Vinput
                      inputType="text"
                      :modelValue="contractId"
                      @update:modelValue="
                        (newValue) => (contractId = newValue)
                      "
                      :rules="{ required: true }"
                      id="text-contractId"
                      name="text-contractId"
                      label="Contract ID"
                      class="mb-1 mr-sm-2"
                      description="text-contractId-feedback"
                      validatorName="Contract ID"
                    />
                  </b-col>
                  <b-col class="mt-2">
                    <b-button type="submit" variant="primary">Find</b-button>
                  </b-col>
                </b-row>
              </b-form>
            </validation-observer>
          </b-modal>
      </div>
      <div class="row">
        <b-modal
            id="modal-top-disable-detail"
            hide-footer
            title="Terminate Contract"
            content-class="shadow" 
            size="xl"
          >
            <template #modal-header="{ close }">
                <h5>Terminate Contract</h5>
                <p class="h5 mb-2">
                  <b-icon
                    icon="x-square"
                    class="close-icon"
                    @click="
                      close();
                      clearData();
                    "
                  ></b-icon>
                </p>
            </template>
            <b-table-simple
              :small="true"
              sticky-header
              style="max-height: 395px;"
              striped
              responsive
              hover
            >
              <b-thead>
                <b-tr>
                  <b-th style="width: 5% !important;">Contract ID</b-th>
                  <b-th style="width: 7% !important;">Building</b-th>
                  <b-th style="width: 5% !important;">Room Number</b-th>
                  <b-th style="width: 5% !important;">Tenant</b-th>
                  <b-th style="width: 5% !important;">Tenant Phone</b-th>
                  <b-th style="width: 7% !important;">Created At</b-th>
                  <b-th style="width: 8% !important;">Start Date</b-th>
                  <b-th style="width: 8% !important;">End Date</b-th>
                  <b-th style="width: 7% !important;">Next Payment Date</b-th>
                  <b-th style="width: 7% !important;">Next Bill Payment Date</b-th>
                  <b-th style="width: 7% !important;">Currency Type</b-th>
                  <b-th style="width: 7% !important;">Guaranty Payment</b-th>
                   <b-th style="width: 7% !important;">Guaranty Payment Status</b-th>
                  <b-th style="width: 10% !important;">Already Paid For (days)</b-th>
                  <b-th style="width: 7% !important;">Unpaid Amount</b-th>
                  <b-th style="width: 7% !important;">Unpaid Bill</b-th>
                  <b-th sticky-column style="width: 5%;"></b-th>
                </b-tr>
              </b-thead>
              <b-tbody>
                <b-tr>
                  <b-td>{{disableContractData.contractIdentifier}}</b-td>
                  <b-td>{{disableContractData.buildingName }}</b-td>
                  <b-td>{{disableContractData.roomNumber}}</b-td>
                  <b-td>{{disableContractData.tenantFullName }}</b-td>
                  <b-td>{{disableContractData.tenantPhoneNumber}}</b-td>
                  <b-td>{{disableContractData.createdDate}}</b-td>
                  <b-td>{{disableContractData.startDate}}</b-td>
                  <b-td>{{disableContractData.endDate}}</b-td>
                  <b-td>{{disableContractData.nextPaymentDate}}</b-td>
                  <b-td>{{disableContractData.billPaymentDate}}</b-td>
                  <b-td>{{disableContractData.currencyType}}</b-td>
                  <b-td>{{disableContractData.guaranteedMoney}}</b-td>
                  <b-td>{{disableContractData.guaranteedMoneyStatus}}</b-td>
                  <b-td>{{disableContractData.remainingDate}}</b-td>
                  <b-td>{{numberWithCommas(disableContractData.remainingAmount)}}</b-td>
                  <b-td>{{numberWithCommas(disableContractData.remainingBillPrice)}}</b-td>
                  <b-td sticky-column>
                    <b-badge @click="SubmitDisableContract(disableContractData.contractIdentifier)" variant="primary">Disable</b-badge>
                  </b-td>
                </b-tr>
              </b-tbody>
            </b-table-simple>
          </b-modal>
      </div>
       <div class="row">
        <b-modal
            id="modal-top-EnableContract"
            hide-footer
            :title="renewCurrentStep === 3 ? 'Preview Renewal Information' : 'Renew Contract - Step ' + renewCurrentStep"
            content-class="shadow" 
            size="xl"
          >
            <template #modal-header="{ close }">
              <h5>{{ renewCurrentStep === 3 ? 'Preview Renewal Information' : 'Renew Contract - Step ' + renewCurrentStep }}</h5>
              <p class="h5 mb-2">
                <b-icon
                  icon="x-square"
                  class="close-icon"
                  @click="
                    close();
                    clearData();
                  "
                ></b-icon>
              </p>
            </template>
            
            <!-- Step Progress Indicator -->
            <div class="step-progress mb-3" v-if="renewCurrentStep < 3">
              <div class="step" :class="{ active: renewCurrentStep >= 1 }">1</div>
              <div class="step-line" :class="{ active: renewCurrentStep >= 2 }"></div>
              <div class="step" :class="{ active: renewCurrentStep >= 2 }">2</div>
              <div class="step-line" :class="{ active: renewCurrentStep >= 3 }"></div>
              <div class="step" :class="{ active: renewCurrentStep >= 3 }">3</div>
            </div>
            
            <!-- Step 1: Contract Period -->
            <div v-if="renewCurrentStep === 1">
              <validation-observer ref="renewStep1Observer" v-slot="{ handleSubmit }">
                <b-form @submit.stop.prevent="handleSubmit(nextRenewStep)">
                  <b-row no-gutters>
                    <b-col md="12">
                      <h6 class="section-title mb-3" style="color: rgb(37, 91, 48) !important;">
                        <b-icon icon="calendar-range"></b-icon> Contract Period
                      </h6>
                    </b-col>
                    
                    <b-col md="4">
                      <Vinput
                        inputType="date"
                        :modelValue="editData.startDate"
                        @update:modelValue="(newValue) => (editData.startDate = newValue)"
                        :rules="{ required: true }"
                        id="text-startDate-renew"
                        name="text-startDate-renew"
                        label="Start Date"
                        class="mb-3"
                        description="When the renewed contract begins"
                        validatorName="Start Date"
                      />
                    </b-col>
                    
                    <b-col md="4">
                      <Vinput
                        inputType="date"
                        :modelValue="editData.endDate"
                        @update:modelValue="(newValue) => (editData.endDate = newValue)"
                        :rules="{ required: true }"
                        id="text-endDate-renew"
                        name="text-endDate-renew"
                        label="End Date"
                        class="mb-3"
                        description="When the renewed contract expires"
                        validatorName="End Date"
                      />
                    </b-col>
                    
                    <b-col md="4">
                      <Vinput
                        inputType="range"
                        :modelValue="editData.dueDate"
                        @update:modelValue="(newValue) => (editData.dueDate = newValue)"
                        :rules="{ required: true }"
                        id="text-dueDate-renew"
                        name="text-dueDate-renew"
                        :label="daysMessageEdit"
                        class="mb-3"
                        description="Grace period for payment"
                        validatorName="Due Date"
                        min="0"
                        max="15"
                        step="1"
                        :title="editData.dueDate.toString()"
                      />
                    </b-col>
                  </b-row>
                </b-form>
              </validation-observer>
            </div>
            
            <!-- Step 2: Payment Configuration -->
            <div v-if="renewCurrentStep === 2">
              <validation-observer ref="renewStep2Observer" v-slot="{ handleSubmit }">
                <b-form @submit.stop.prevent="handleSubmit(nextRenewStep)">
                
                    <b-col md="12">
                      <h6 class="section-title mb-3" style="color: rgb(37, 91, 48) !important;">
                        <b-icon icon="cash-stack"></b-icon> Payment Configuration
                      </h6>
                    </b-col>
                    
                    <!-- Advance Payment Section -->
                    <b-card class="mb-3" border-variant="success">
                      <template #header>
                        <h6 class="mb-0 text-success">Advance Payment Configuration</h6>
                      </template>
                      <b-row>
                        <b-col md="4">
                          <Vselect
                            :modelValue="editData.advancePeriod"
                            @update:modelValue="(newValue) => { editData.advancePeriod = newValue; updateEditInitialPayment(); }"
                            :options="periodOptions"
                            :rules="{ required: true }"
                            id="text-advance-period-renew"
                            name="text-advance-period-renew"
                            label="Advance Period Number"
                            class="mb-3 some-select"
                            description="Number of periods to pay in advance"
                            validatorName="Advance Period"
                          />
                        </b-col>
                        
                        <b-col md="4">
                          <Vselect
                            :modelValue="editData.advancePeriodtwo"
                            @update:modelValue="(newValue) => { editData.advancePeriodtwo = newValue; updateEditInitialPayment(); }"
                            :options="periodOptions2"
                            :rules="{ required: true }"
                            id="text-advancePeriodtwo-renew"
                            name="text-advancePeriodtwo-renew"
                            label="Advance Period Unit"
                            class="mb-3 some-select"
                            description="Time unit for advance payment"
                            validatorName="Period Unit"
                          />
                        </b-col>
                        
                        <b-col md="4">
                          <VinputNumber
                            inputType="number"
                            :modelValue="editData.initialPayment"
                            @update:modelValue="(newValue) => (editData.initialPayment = newValue)"
                            :rules="{ }"
                            id="text-InitalPayment-renew"
                            name="text-InitalPayment-renew"
                            label="Advance Payment"
                            class="mb-3"
                            description="Auto-calculated"
                            validatorName="Advance Payment"
                            :step=".01"
                            disabled
                          />
                        </b-col>
                      </b-row>
                      
                      <b-row>
                        <b-col md="12">
                          <VinputNumber
                            inputType="number"
                            :modelValue="editData.guaranteedMoney"
                            @update:modelValue="
                              (newValue) => (editData.guaranteedMoney = newValue)
                            "
                            :rules="{ }"
                            id="text-guaranteedMoney"
                            name="text-guaranteedMoney"
                            label="Guaranteed Money"
                            class="mb-3"
                            description="Security deposit amount"
                            validatorName="Guaranteed Money"
                            :step=".01"
                          />
                        </b-col>
                      </b-row>
                    </b-card>

                    <b-row style="">
                      <b-col
                        xs="1"
                        style="justify-content: center; align-items: center"
                      >
                        <Vselect
                          :modelValue="editData.period"
                          @update:modelValue="(newValue) => (editData.period = newValue)"
                          :options="periodOptions"
                          :rules="{ required: true }"
                          id="text-period"
                          name="text-period"
                          label="Period"
                          class="mb-1 mr-sm-2 some-select"
                          description="text-period-feedback"
                          validatorName="Period"
                        />
                      </b-col>
                        <b-col
                        xs="2"
                        style="justify-content: center; align-items: center"
                      >
                      <Vselect
                        :modelValue="editData.periodtwo"
                        @update:modelValue="
                          (newValue) => (editData.periodtwo = newValue)
                        "
                          :options="periodOptions2"
                        :rules="{ required: true }"
                        id="text-periodtwo"
                        name="text-periodtwo"
                        label="*"
                        class="mb-1 mr-sm-2 some-select"
                        description="text-periodtwo-feedback"
                        validatorName="Period"
                      />
                      </b-col>
                       <b-col
                        xs="2" style="justify-content: center; align-items: center"
                      >
                      <Vselect
                      :modelValue="editData.withHolding"
                      @update:modelValue="
                        (newValue) => (editData.withHolding = newValue)
                      "
                        :options="withHoldingOptionValue"
                      :rules="{ required: true }"
                      id="text-withHolding-option-options"
                      name="text-withHolding-option-options"
                      label="Withholding Tax (3%)"
                      class="mb-1 mr-sm-2 some-select"
                      description="text-withHolding-option-options-feedback"
                      validatorName="Withholding Tax (3%)"
                      />
                      </b-col>
                      <b-col
                        xs="2"
                        style="justify-content: center; align-items: center"
                      >
                      <Vselect
                      :modelValue="editData.penaltyOption"
                      @update:modelValue="
                        (newValue) => (editData.penaltyOption = newValue)
                      "
                        :options="penaltyOptionValue"
                      :rules="{ required: true }"
                      id="text-penalty-option-options"
                      name="text-penalty-option-options"
                      label="Penalty Options"
                      class="mb-1 mr-sm-2 some-select"
                      description="text-penalty-option-options-feedback"
                      validatorName="Penalty Options"
                      />
                      </b-col>
                       <template v-if="editData.penaltyOption === 'fixedAmount' || editData.penaltyOption === 'percentage'">
                        <b-col
                          md="12"
                          style="justify-content: center; align-items: center"
                        >
                      <Vselect
                          :modelValue="editData.penaltyCondition"
                          @update:modelValue="
                            (newValue) => (editData.penaltyCondition = newValue)
                          "
                            :options="penaltyConditionValue"
                          :rules="{ required: true }"
                          id="text-penalty-option-options"
                          name="text-penalty-condition-options"
                          label="Penalty Condition"
                          class="mb-1 mr-sm-2 some-select"
                          description="text-penalty-condition-options-feedback"
                          validatorName="Penalty Condition"
                          />
                        </b-col>
                        <template v-if="editData.penaltyCondition === 'incremental'">
                        <b-col
                          md="12"
                          style="justify-content: center; align-items: center"
                        >
                         <Vselect
                            :modelValue="editData.dateRangeForPenaltyIncrement"
                            @update:modelValue="
                              (newValue) => (editData.dateRangeForPenaltyIncrement = newValue)
                            "
                              :options="dateRangeOption"
                            :rules="{ required: true }"
                            id="text-penalty-option-options"
                            name="text-penalty-date-range-options"
                            label="Date Range for Penalty Increment"
                            class="mb-1 mr-sm-2 some-select"
                            description="text-penalty-date-range-options-feedback"
                            validatorName="Date Range for Penalty Increment"
                          />
                        </b-col>
                        <b-col
                    md="12"
                    style="justify-content: center; align-items: center"
                    v-if="editData.dateRangeForPenaltyIncrement === 'Other'"
                  >
                    <VinputNumber
                      inputType="number"
                      :modelValue="editData.dateRangeForUserInput"
                      @update:modelValue="
                        (newValue) => (editData.dateRangeForUserInput = newValue)
                      "
                      :rules="{ required: true }"
                      id="text-dateRangeForUserInput"
                      name="text-dateRangeForUserInput"
                      label="Another Date Range"
                      class="mb-1 mr-sm-2"
                      description="text-otherDateRange-feedback"
                      validatorName="Another Date Range"
                      :step="1"
                    />
                  </b-col>
                        </template>
                        <template v-if="editData.penaltyOption === 'percentage'">
                         <b-col
                          md="12"
                          style="justify-content: center; align-items: center"
                        >
                         <Vselect
                            :modelValue="editData.penaltyAmount"
                            @update:modelValue="
                              (newValue) => (editData.penaltyAmount = newValue)
                            "
                              :options="penaltyAmountPercentOption"
                            :rules="{ required: true }"
                            id="text-penalty-option-options"
                            name="text-penalty-amount-options"
                            label="Penalty Amount"
                            class="mb-1 mr-sm-2 some-select"
                            description="text-penalty-amount-options-feedback"
                            validatorName="Penalty Amount"
                          />
                        </b-col>
                        <b-col
                    md="12"
                    style="justify-content: center; align-items: center"
                    v-if="editData.penaltyAmount === 'Other'"
                  >
                    <VinputNumber
                      inputType="number"
                      :modelValue="editData.penaltyAmountPercent"
                      @update:modelValue="
                        (newValue) => (editData.penaltyAmountPercent = newValue)
                      "
                      :rules="{ required: true }"
                      id="text-penaltyAmountPercent"
                      name="text-penaltyAmountPercent"
                      label="Penalty Amount of monthy price in percent"
                      class="mb-1 mr-sm-2"
                      description="text-otherPenaltyPerent-feedback"
                      validatorName="Penalty Amount of monthy price in percent"
                      :step=".01"
                    />
                  </b-col>
                         </template>
                         <template v-if="editData.penaltyOption === 'fixedAmount'">
                              <b-col
                          md="12"
                          style="justify-content: center; align-items: center"
                        >
                         <Vselect
                            :modelValue="editData.penaltyAmount"
                            @update:modelValue="
                              (newValue) => (editData.penaltyAmount = newValue)
                            "
                              :options="penaltyAmountFixedOption"
                            :rules="{ required: true }"
                            id="text-penalty-option-options"
                            name="text-penalty-amount-options"
                            label="Penalty Amount"
                            class="mb-1 mr-sm-2 some-select"
                            description="text-penalty-amount-options-feedback"
                            validatorName="Penalty Amount"
                          />
                        </b-col>
                        <b-col
                    md="12"
                    style="justify-content: center; align-items: center"
                    v-if="editData.penaltyAmount === 'Other'"
                  >
                    <VinputNumber
                      inputType="number"
                      :modelValue="editData.penaltyAmountFixed"
                      @update:modelValue="
                        (newValue) => (editData.penaltyAmountFixed = newValue)
                      "
                      :rules="{ required: true }"
                      id="text-penaltyAmountFixed"
                      name="text-penaltyAmountFixed"
                      label="Fixed Amount of penalty"
                      class="mb-1 mr-sm-2"
                      description="text-otherPenaltyFixed-feedback"
                      validatorName="Fixed Amount of penalty"
                      :step=".01"
                    />
                  </b-col>
                        </template>
                        </template>
                  
                  <!-- File Upload Section -->
                  <b-col md="12" class="mt-3">
                    <p class="mt-2" v-if="editData.encodedPdf !== null && editData.encodedPdf !=='' ">Attached file: <b-badge @click="downloadFile(editData.contractId)" variant="primary">Document</b-badge></p>
                    <b-col
                      md="12"
                      style="justify-content: center; align-items: center"
                    >
                      Attach Document 
                    </b-col>
                    <b-col
                      md="12"
                      style="justify-content: center; align-items: center"
                    >
                      <b-form-file v-model="file" ref="file-input" class="mb-2" accept=".pdf,.jpg,.png,.jpeg,.doc,.docx" @change="handleFileChange" :disabled="isUploading"></b-form-file>
                      <p class="mt-2">Selected file: <b>{{ file ? file.name : '' }}</b></p>
                      <div v-if="fileError" class="text-danger mt-2">{{ fileError }}</div>
                      <div v-if="isUploading" class="mt-2">
                        <b-progress :value="uploadProgress" :max="100" show-progress animated></b-progress>
                        <small class="text-muted">Uploading... {{ uploadProgress }}%</small>
                      </div>
                    </b-col>
                  </b-col>
                </b-row>
              </b-form>
            </validation-observer>
          </div>
          
          <!-- Step 3: Preview -->
          <div v-if="renewCurrentStep === 3">
            <div class="contract-review-section">
              <div class="text-center mb-3">
                <h6 class="section-title" style="color: rgb(37, 91, 48) !important;">
                  <b-icon icon="file-pdf"></b-icon> Renewal Contract Preview
                </h6>
              </div>
              <div class="contract-review-container">
                <div class="text-center mb-4">
                  <h4 class="text-primary">Contract Renewal Review</h4>
                  <p class="text-muted">Please review all renewal details before submission</p>
                </div>
                
                <div class="contract-document bg-light p-4 rounded border">
                  <div class="document-header text-center mb-4">
                    <h5 class="text-primary mb-1">CONTRACT RENEWAL AGREEMENT</h5>
                    <p class="text-muted small">This renewal extends the existing rental agreement under updated terms</p>
                  </div>
                  
                  <!-- Renewal Summary -->
                  <div class="contract-section mb-4">
                    <h6 class="section-title border-bottom pb-2 mb-3" style="color: rgb(37, 91, 48) !important;">
                      <b-icon icon="calendar-range"></b-icon> RENEWAL TERMS
                    </h6>
                    <b-card class="border-primary">
                      <b-row>
                        <b-col cols="4"><strong>New Start Date:</strong></b-col>
                        <b-col cols="8">{{ editData.startDate }}</b-col>
                        <b-col cols="4"><strong>New End Date:</strong></b-col>
                        <b-col cols="8">{{ editData.endDate }}</b-col>
                        <b-col cols="4"><strong>Payment Due:</strong></b-col>
                        <b-col cols="8">{{ editData.dueDate }} days</b-col>
                        <b-col cols="4"><strong>Advance Payment:</strong></b-col>
                        <b-col cols="8">{{ numberWithCommas(editData.initialPayment) }} ETB</b-col>
                        <b-col cols="4"><strong>Security Deposit:</strong></b-col>
                        <b-col cols="8">{{ numberWithCommas(editData.guaranteedMoney) }} ETB</b-col>
                      </b-row>
                    </b-card>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <!-- Navigation Buttons -->
          <div class="modal-navigation mt-4">
            <b-row class="justify-content-between align-items-center">
              <b-col cols="auto">
                <b-button 
                  variant="outline-secondary" 
                  :disabled="renewCurrentStep === 1" 
                  @click="previousRenewStep"
                  class="px-4"
                >
                  <b-icon icon="chevron-left"></b-icon> Previous
                </b-button>
              </b-col>
              <b-col cols="auto">
                <div class="d-flex align-items-center">
                  <span class="text-muted me-2">Step {{ renewCurrentStep }} of 3</span>
                  <div class="progress" style="width: 120px; height: 6px;">
                    <div 
                      class="progress-bar" 
                      style="background-color: rgb(37, 91, 48) !important;"
                      :style="{ width: (renewCurrentStep / 3) * 100 + '%' }"
                    ></div>
                  </div>
                </div>
              </b-col>
              <b-col cols="auto">
                <b-button 
                  v-if="renewCurrentStep < 2"
                  variant="primary" 
                  @click="validateAndNextRenewStep"
                  class="px-4"
                  style="background-color: rgb(37, 91, 48) !important; border-color: rgb(37, 91, 48) !important;"
                >
                  Next <b-icon icon="chevron-right"></b-icon>
                </b-button>
                <b-button 
                  v-else-if="renewCurrentStep === 2"
                  variant="info"
                  @click="validateAndNextRenewStep"
                  class="px-4"
                  style="background-color: #17a2b8 !important; border-color: #17a2b8 !important;"
                >
                  <b-icon icon="eye"></b-icon> Preview
                </b-button>
                <b-button 
                  v-else
                  variant="success"
                  @click="confirmSubmitEditForm"
                  class="px-4"
                  style="background-color: rgb(37, 91, 48) !important; border-color: rgb(37, 91, 48) !important;"
                  :disabled="isUploading || isSubmitting"
                >
                  <b-spinner v-if="isUploading || isSubmitting" small class="mr-2"></b-spinner>
                  <b-icon v-else icon="check-circle"></b-icon> 
                  {{ isUploading || isSubmitting ? 'Submitting...' : 'Submit Renewal' }}
                </b-button>
              </b-col>
            </b-row>
          </div>
          </b-modal>
      </div>
      <div class="row mt-3">
        <div class="col-12">
          <card class="strpied-tabled-with-hover"
                body-classes="table-full-width table-responsive"
          >
            <template slot="header">
                <b-row>
                  <b-col lg="2" class="mt-4">
                    <b-button v-if="modulePermission.create == 1" @click="AddContract()" class="btn-outline-primary">
                      <b-icon class="text-center" icon="plus"></b-icon> New Contract
                    </b-button>
                  </b-col>
                  <b-col lg="2" class="mt-4">
                    <b-button style="padding: 8px 10px !important;" v-if="modulePermission.delete == 1" @click="DisableContract()" class="btn-outline-primary">
                      <b-icon class="text-center" icon="eye-slash"></b-icon> Terminate Contract
                    </b-button>
                  </b-col>
                  <b-col lg="1" >
                    <label class="some-label" for="select-status">Status</label>
                    <b-form-select id="select-status" v-model="contractStatus" :options="contractStatusOptions"></b-form-select>
                  </b-col>
                  <b-col lg="2">
                    <label for="datepicker-from">Date From</label>
                    <b-input-group>
                      <b-form-datepicker v-model="DateFrom" placeholder="Select start date" value-as-date :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" id="datepicker-from" locale="en-US" size="sm" today-button reset-button close-button></b-form-datepicker>
                    </b-input-group>
                  </b-col>
                  <b-col lg="2">
                    <label for="datepicker-to">Date To</label>
                    <b-input-group>
                      <b-form-datepicker v-model="DateTo" placeholder="Select end date" value-as-date :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" id="datepicker-to" locale="en-US" size="sm" today-button reset-button close-button></b-form-datepicker>
                    </b-input-group>
                  </b-col>
                  <b-col lg="1" class="mt-4">
                    <b-button class="btn-secondary" id="datepicker-btn" @click="getContractByOwnerID()">Filter</b-button>
                  </b-col>
                   <b-col lg="2" class="mt-4">
                  <b-form-group class="mb-0">
                    <b-input-group size="sm">
                      <b-form-input
                        id="filter-input"
                        v-model="filter"
                        type="search"
                        placeholder="Search all columns..."
                      ></b-form-input>

                      <b-input-group-append>
                        <b-button class="btn-secondary" :disabled="!filter" @click="filter = ''"
                          >Clear</b-button
                        >
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-col>
                </b-row>
                <b-row>
                <b-col lg="8" class="my-1"></b-col>
               
              </b-row>
            </template>
            <div class="table-container">
            <b-table-simple
                :small="true"
                sticky-header
                style="max-height: 395px;"
                striped
                responsive
                hover
              >
                <b-thead>
                  <b-tr>
                    <b-th>No.</b-th>
                    <b-th>Contract ID</b-th>
                    <b-th>Tenant</b-th>
                    <b-th>House</b-th>
                    <b-th>Monthly Price</b-th>
                    <b-th>Start Date</b-th>
                    <b-th>End Date</b-th>
                    <b-th v-if="!disabledData">Next Payment Date</b-th>
                    <b-th v-else>Terminated on</b-th>
                    <b-th>Payment Status</b-th>
                    <b-th>Due Date</b-th>
                    <b-th>Created By</b-th>
                    <b-th>Actions</b-th>
                  </b-tr>
                </b-thead>
               <template v-if="spinner">
                <b-tbody class="text-center">
                   <b-tr >
                       <b-td colspan="9" class="text-center" style="display: table-cell">
                        <b-spinner
                        style="height: 3rem; width: 3rem;"
                          variant="warning"
                        ></b-spinner>
                       </b-td>
                    </b-tr>
                </b-tbody>
                </template>
                <template v-else>
                  <b-tbody>
                    <template v-if="filterTable.length === 0">
                        <b-tr>
                          <b-td colspan="9" class="text-center">Nothing found</b-td>
                          <b-td>-</b-td>
                        </b-tr>
                    </template>
                    <template v-else>
                    <b-tr
                      v-for="(item, index) in filterTable"
                      :key="item.ID"
                    >
                        <b-td>{{(currentPage - 1) * perPage + index + 1}}</b-td>
                        <b-td>{{item.contractIdentifier}}</b-td>
                        <b-td>{{item.tenant.fullName}}</b-td>
                        <b-td>{{item.house.building.buildingName}} - {{item.house.floor}} - {{item.house.roomNumber}}</b-td>
                        <b-td>{{numberWithCommas(item.monthlyPrice)}}</b-td>
                        <b-td>{{item.startDate}}</b-td>
                        <b-td>{{item.endDate}}</b-td>
                        <b-td v-if="!disabledData">{{item.nextPaymentDate}}</b-td>
                        <b-td v-else>{{item.disableDate}}</b-td>
                        <b-td>{{item.paymentStatus}}</b-td>
                        <b-td>{{item.dueDate}} days</b-td>
                        <b-td>{{item.registeredBy}}</b-td>
                        <b-td>
                          <b-icon icon="eye-fill" class="btn-icon mr-2" @click="ViewDetail(item.contractId)" v-b-tooltip.hover title="View Details"></b-icon>
                          <template v-if="!disabledData">
                            <b-icon v-if="modulePermission.update == 1" icon="pencil-square" class="btn-icon mr-2" @click="EditContract(item.contractId)" v-b-tooltip.hover title="Edit Contract"></b-icon>
                          </template>
                          <template v-else>
                            <b-icon v-if="modulePermission.update == 1" icon="pencil-square" class="btn-icon mr-2" @click="EnableContract(item.contractIdentifier)" v-b-tooltip.hover title="Renew Contract"></b-icon>
                          </template>
                          <b-icon icon="file-pdf-fill" class="btn-icon" @click="downloadFile(item.contractId)" v-b-tooltip.hover title="Download PDF"></b-icon>
                        </b-td>
                    </b-tr>
                    </template>
                  </b-tbody>
                </template>
              </b-table-simple>
            </div>
            <div class="pagination-container mt-2">
            <b-row>
                <b-col md="3">
                  <b-form-group
                    id="fieldset-horizontal"
                    label-cols="8" label-cols-xs="8" label-size="md"
                    label="records per page"
                    label-for="input-horizontal"
                    label-align-xl="right"  
                  >
                  <b-form-select id="input-horizontal" v-model="perPage" :options="pageOptions" @change="changePerPage"></b-form-select>
                  </b-form-group>
                </b-col>
                <b-col md="9">
                  <b-pagination v-model="currentPage" :per-page="perPage" :total-rows="totalRows" @page-click="changePage" align="right"></b-pagination>
                </b-col>
              </b-row>
            </div>
         </card>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.contract-review-container {
  max-height: 600px;
  overflow-y: auto;
}

.contract-document {
  font-family: 'Times New Roman', serif;
  line-height: 1.6;
  color: #333;
}

.document-header {
  border-bottom: 2px solid #007bff;
  padding-bottom: 15px;
}

.contract-section {
  margin-bottom: 25px;
}

.section-title {
  font-size: 1.1rem;
  font-weight: 600;
  margin-bottom: 15px;
  color: #007bff;
}

.party-info, .property-description, .terms-content, .utilities-content, .legal-content {
  box-shadow: 0 1px 3px rgba(0,0,0,0.1);
  transition: box-shadow 0.2s ease;
}

.party-info:hover, .property-description:hover, .terms-content:hover, .utilities-content:hover, .legal-content:hover {
  box-shadow: 0 2px 8px rgba(0,0,0,0.15);
}

.signature-box {
  background-color: #f8f9fa;
}

.signature-line {
  border-bottom: 1px solid #333 !important;
  margin-top: 20px;
}

.progress {
  border-radius: 10px;
  background-color: #e9ecef;
}

.progress-bar {
  border-radius: 10px;
  transition: width 0.3s ease;
}

.btn {
  border-radius: 25px;
  font-weight: 500;
  transition: all 0.2s ease;
}

.btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0,0,0,0.15);
}

.btn:disabled {
  transform: none;
  box-shadow: none;
}

/* Submit button hover effects */
.submit-btn {
  opacity: 0.7;
  transition: all 0.3s ease;
}

.submit-btn.btn-enabled {
  opacity: 1;
}

.submit-btn.btn-enabled:hover {
  background-color: rgb(30, 75, 40) !important;
  border-color: rgb(30, 75, 40) !important;
  transform: translateY(-2px);
  box-shadow: 0 6px 12px rgba(37, 91, 48, 0.3);
}

.submit-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Step Progress Indicator */
.step-progress {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
}

.step {
  width: 35px;
  height: 35px;
  border-radius: 50%;
  background-color: #e9ecef;
  color: #6c757d;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 14px;
  transition: all 0.3s ease;
}

.step.active {
  background-color: rgb(37, 91, 48);
  color: white;
}

.step-line {
  width: 60px;
  height: 2px;
  background-color: #e9ecef;
  transition: all 0.3s ease;
}

.step-line.active {
  background-color: rgb(37, 91, 48);
}

.modal-navigation {
  border-top: 1px solid #dee2e6;
  padding-top: 15px;
}

.section-title {
  color: rgb(37, 91, 48) !important;
  font-weight: 600;
  margin-bottom: 15px;
}

/* Mobile responsiveness */
/* Table Container Styles */
.table-container {
  position: relative;
  overflow-x: auto;
  margin-bottom: 0;
}

.list-table {
  max-height: 55vh;
  min-height: 120px;
}

.pagination-container {
  background-color: #fff;
  border-top: 1px solid #dee2e6;
  padding: 15px 0;
  margin-top: 0;
}

/* Responsive Table Adjustments */
@media (max-width: 1200px) {
  .table-container {
    max-height: 350px;
  }
}

@media (max-width: 992px) {
  .table-container {
    max-height: 300px;
  }
}

@media (max-width: 768px) {
  .table-container {
    max-height: 250px;
  }
  
  .pagination-container {
    padding: 10px 0;
  }
  
  .contract-document {
    font-size: 0.9rem;
  }
  
  .section-title {
    font-size: 1rem;
  }
  
  .party-info, .property-description, .terms-content, .utilities-content, .legal-content {
    padding: 15px !important;
  }
  
  .step {
    width: 30px;
    height: 30px;
    font-size: 12px;
  }
  
  .step-line {
    width: 40px;
  }
}

@media (max-width: 576px) {
  .table-container {
    max-height: 200px;
  }
  
  .pagination-container .form-group label {
    font-size: 0.8rem;
  }
}

/* Ensure proper spacing and prevent overlap */
.card-body {
  padding-bottom: 0 !important;
}

.table-full-width {
  margin-bottom: 0 !important;
}

/* Fix sticky column positioning */
.b-table-sticky-column {
  z-index: 10;
}

.table-container .table {
  margin-bottom: 0;
}
</style>

<script>
  import LTable from 'src/components/Table.vue'
  import Card from 'src/components/Cards/Card.vue'
  import Vinput from 'src/components/Inputs/Vinput.vue'
  import VinputGroup from 'src/components/Inputs/VinputGroup.vue'
  import VinputNumber from 'src/components/Inputs/VinputNumber.vue'
  import Vselect from 'src/components/Inputs/Vselect.vue'
  import VselectDouble from 'src/components/Inputs/VselectDouble.vue'
  export default {
    components: {
      LTable,
      Card,
      Vinput,
      VinputGroup,
      VinputNumber,
      Vselect,
      VselectDouble
    },
    data () {
      return {
        modulePermission: {
          view: 1,
          create: 0,
          update: 0,
          delete: 0
        },
        disableContractData: {
          billPaymentDate: "",
          buildingName: "", 
          contractIdentifier: "",
          createdDate: "",
          endDate: "",
          nextPaymentDate: "",
          remainingAmount: null,
          remainingBillPrice: null,
          remainingDate: "",
          roomNumber: "",
          startDate: "",
          status: null,
          tenantFullName:"", 
          tenantPhoneNumber: "",
          guaranteedMoney: null,
          guaranteedMoneyStatus: "",
          currencyType: "",
        },
        filter: "",
        totalRows: 0,
        pageOptions: [
          {value: 7, text: 7},
          {value: 10, text: 10},
          {value: 25, text: 25},
          {value: 50, text: 50},
          {value: 100, text: 100}
        ],
        penaltyOptionValue:[
          {value:"noPenalty",text:"No Penalty"},
          {value:"percentage",text:"By Percentage"},
          {value:"fixedAmount",text:"Fixed Amount"}
        ],
        penaltyConditionValue:[
          {value:"fixed",text:"Fixed"},
          {value:"incremental",text:"Incremental"}
        ],
        dateRangeOption:[
          {value:1,text:"1 Day"},
          {value:5,text:"5 Days"},
          {value:10,text:"10 Days"},
          {value:15,text:"15 Days"},
          {value:20,text:"20 Days"},
          {value:30,text:"30 Days"},
          {value: "Other", text: "Other"}
        ],
        penaltyAmountPercentOption:[
          {value:1,text:"1%"},
          {value:5,text:"5%"},
          {value:10,text:"10%"},
          {value:15,text:"15%"},
          {value:20,text:"20%"},
          {value:25,text:"25%"},
          {value:30,text:"30%"},
          {value:40,text:"40%"},
          {value:40,text:"50%"},
          {value:100,text:"100%"},
          {value: "Other", text: "Other"}
        ],
        penaltyAmountFixedOption:[
          {value:100,text:"100 Birr"},
          {value:500,text:"500 Birr"},
          {value:1000,text:"1000 Birr"},
          {value:2000,text:"2000 Birr"},
          {value:3000,text:"3000 Birr"},
          {value:4000,text:"4000 Birr"},
          {value:5000,text:"5000 Birr"},
          {value:10000,text:"10000 Birr"},
          {value:20000,text:"20000 Birr"},
          {value:50000,text:"50000 Birr"},
          {value: "Other", text: "Other"}
        ],
        currentPage: 1,
        perPage: 7,
        items: [],
        buildingOptions: [],
        rentCurrencyTypeOptions:[
          {value:"ETB", text:"ETB"},
          {value:"USD", text:"USD"}
        ],
        tenantOptions: [],
        houseOptions: [],
        withHoldingOptionValue: [
          {text: "No", value: "No"},
          {text: "Yes", value: "Yes"}
        ],
        periodOptions: [
          {text: 1, value: 1},
          {text: 2, value: 2},
          {text: 3, value: 3},
          {text: 4, value: 4},
          {text: 5, value: 5},
          {text: 6, value: 6},
          {text: 7, value: 7},
          {text: 8, value: 8},
          {text: 9, value: 9},
          {text: 10, value: 10},
          {text: 11, value: 11}
        ],
        periodOptions2: [
          {text: "Monthly", value: 1},
          {text: "Yearly", value: 2}
        ],
        priceOptions: [
          {value:"PerSquareMeter", text: "Per Square Meter"},
          {value:"PerMonth", text: "Monthly"}
        ],
        sexOptions:[{value:"Male",text:"Male"},
        {value:"Female",text:"Female"}
        ],
        selectedOption: "Yes", 
        addData:{
          floor:null,
          roomNumber:"",
          size:null,
          buildingId: null,
          latest_price: null,
          priceOption: "",
          rentCurrencyType: "",
          description: "",
          fullName:"",
          email:"",
          sex:"",
          phoneNumber:"",
          address:"",
          firstBillPaymentStarts:"",
          startDate:"",
          endDate:"",
          dueDate:0,
          payedAmount:0,
          tenantId: null,
          houseId: null,
          period: null,
          periodtwo: 1,
          initialPayment: null,
          guaranteedMoney: null,
          paymentRule: "",
          attachedFile: "",
          registeredBy: sessionStorage.getItem("userID"),
          userId: parseInt(sessionStorage.getItem("userID")),
          electricReading:null,
          waterReading:null,
          penaltyOption:"",
          penaltyCondition:"",
          dateRangeForPenaltyIncrement:"",
          dateRangeForUserInput:null,
          penaltyAmount:"",
          penaltyAmountPercent:null,
          penaltyAmountFixed:null,
          withHolding:"",
          advancePeriod:null,
          advancePeriodtwo:1
        },
        editData:{
          contractId: null,
          firstBillPaymentStarts:"",
          startDate: "",
          endDate: "",
          dueDate: 0,
          initialPayment: 0,
          guaranteedMoney: 0,
          paymentRule: "",
          period: 1,
          periodtwo: 1,
          encodedPdf: null,
          penaltyOption:"",
          penaltyCondition:"",
          dateRangeForPenaltyIncrement:0,
          dateRangeForUserInput:0,
          penaltyAmount:0,
          penaltyAmountPercent:0,
          penaltyAmountFixed:0,
          advancePeriod:1,
          advancePeriodtwo:1,
          withHolding:"",
          monthlyPrice:0
        },
        selectedContract:{
          contractInformation: {
              nextPaymentDate: "",
              billPaymentDate:"",
              status: 0,
              paymentStatus: "",
              payedAmount: 0,
              startDate: "",
              endDate: "",
              createdDate: "",
              dueDate: 0,
              paymentRule: "",
              period: 0,
              penaltyOption:"",
              penaltyCondition:"",
              dateRangeForPenaltyIncrement:0,
              penaltyAmount:0
          },
          guaranty: {
            guarantyAmount:"",
            currency:"",
            status:""
          },
          houseInformation: {
              floor: 0,
              roomNumber: "",
              size: 0,
              createdDate: "",
              status: 0,
              price: 0
          },
          buildingInformation: {
              buildingName: "",
              location: "",
              createdDate: "",
              status: 0,
              description: ""
          },
          tenantInformation: {
              fullName: "",
              email: "",
              phoneNumber: "",
              createdDate: "",
              address: "",
              status: 0
          },
          paymentHistory: [
          
          ],
          totalPayed: 0
        },
        houses: [],
        checkedExistingHouse: false,
        checkedExistingTenant: false,
        tabIndex: 0,
        currentStep: 1,
        houseType: 'existing',
        tenantType: 'existing',
        houseTypeOptions: [
          { text: 'Existing House', value: 'existing' },
          { text: 'New House', value: 'new' }
        ],
        tenantTypeOptions: [
          { text: 'Existing Tenant', value: 'existing' },
          { text: 'New Tenant', value: 'new' }
        ],
        aboveSelected: false,
        belowSelected: false,
        file: null,
        base64: null,
        spinner: true,
        contractId: null,
        DateFrom: "",
        DateTo: "",
        contractStatus: "Active",
        contractStatusOptions: [
          {text: "Active", value: "Active"},
          {text: "Terminated", value: "Terminated"}
        ],
        disabledData: false,
        renewCurrentStep: 1,
        errorMessage: '',
        errorMessage1: '',
        fileError: '',
        uploadProgress: 0,
        isUploading: false,
        isSubmitting: false,
        landlordName: ''
      }
    },
    watch: {
     'addData.latest_price': 'updateInitialPayment',
     'addData.advancePeriod': 'updateInitialPayment',
     'addData.advancePeriodtwo': 'updateInitialPayment',
     'editData.advancePeriod': function(newVal, oldVal) {
       const contract = this.items.find(item => item.contractId === this.editData.contractId);
       const house = contract.house;
       const monthlyPrice = house.priceOption === "PerSquareMeter" ? house.latestPrice * house.size : house.latestPrice;
       let multiplier = this.editData.advancePeriod;
       if (this.editData.advancePeriodtwo === 2) {
         multiplier = this.editData.advancePeriod * 12;
       }
       this.editData.initialPayment = monthlyPrice * multiplier;
     },
     'editData.advancePeriodtwo': function(newVal, oldVal) {
       const contract = this.items.find(item => item.contractId === this.editData.contractId);
       const house = contract.house;
       const monthlyPrice = house.priceOption === "PerSquareMeter" ? house.latestPrice * house.size : house.latestPrice;
       let multiplier = this.editData.advancePeriod;
       if (this.editData.advancePeriodtwo === 2) {
         multiplier = this.editData.advancePeriod * 12;
       }
       this.editData.initialPayment = monthlyPrice * multiplier;
     },
     'editData.initialPayment': function(newVal, oldVal) {
       console.log('*** Advance Payment Amount changed from', oldVal, 'to', newVal, '***');
     },
     'selectedContract': {
       handler: function(newVal, oldVal) {
         console.log('selectedContract watcher triggered');
         console.log('New selectedContract:', newVal);
         this.updateEditInitialPayment();
       },
       deep: true
     },
     'addData.penaltyOption': function(newVal, oldVal) {
       if (newVal !== oldVal) {
         this.addData.penaltyCondition = '';
         this.addData.dateRangeForPenaltyIncrement = '';
         this.addData.dateRangeForUserInput = 0;
         this.addData.penaltyAmount = '';
         this.addData.penaltyAmountPercent = 0;
         this.addData.penaltyAmountFixed = 0;
         this.$forceUpdate();
       }
     },
     houseType(){
      this.updateInitialPayment();
     },
      file: function (newVal, oldVal) {
        if(newVal) {
            this.handleFileChange();
        } else {
          this.base64 = null;
          this.fileError = '';
        }
      },
    },
    computed: {
      filterTable() {
        var searchItems = this.items;
        var searchString = this.filter;
        if (searchString === "") {
          return searchItems;
        }
        searchString = searchString.trim().toLowerCase();

        searchItems = searchItems.filter(function (item) {
          const searchableFields = [
            item.contractIdentifier,
            item.tenant.fullName,
            item.house.building.buildingName,
            item.house.roomNumber,
            String(item.house.floor),
            String(item.monthlyPrice),
            item.startDate,
            item.endDate,
            item.nextPaymentDate || item.disableDate,
            item.paymentStatus,
            String(item.dueDate),
            item.registeredBy
          ];
          
          return searchableFields.some(field => 
            field && field.toString().toLowerCase().indexOf(searchString) !== -1
          );
        });
        return searchItems;
      },
      daysMessage: function () {
        return "Due Date ("+ this.addData.dueDate+" Days)"
      },
      daysMessageEdit: function () {
        return "Due Date ("+ this.editData.dueDate+" Days)"
      },
      getBuildingName: function(){
        var building = "";
        if(this.addData.buildingId !== null){
          building  = this.buildingOptions.filter(x=>x.value== this.addData.buildingId)[0].text;
        }
        return building;
      },
      getHouseName: function(){
        var house = "";
        if(this.addData.houseId !== null){
          house  = this.houseOptions.filter(x=>x.value== this.addData.houseId)[0].text;
        }
        return house;
      },
      getPriceByValue(){
        var value = this.addData.houseId;
        if(value !== null && value !== "" && value !== 0){
          return this.numberWithCommas(this.houseOptions.filter(item=>item.value == value)[0].price).toString();
        }else{
          return "";
        }
      },
      getRentCurrencyType(){
     var value = this.addData.houseId;
        if(value !== null && value !== "" && value !== 0){
          return this.houseOptions.filter(item=>item.value == value)[0].rentCurrencyType;
        }else{
          return "";
        }
      },
      getPriceOptionByValue(){
        var value = this.addData.houseId;
        if(value !== null && value !== "" && value !== 0){
          return this.houseOptions.filter(item=>item.value == value)[0].priceOption.toString();
        }else{
          return "";
        }
      },
      vatLabel() {
        var value = this.addData.houseId;
        if (value !== null && value !== '' && value !== 0) {
          const house = this.houseOptions.filter(item => item.value == value)[0];
          console.log("House ",house);
          if (!house) return 'N/A';
          return house.includeVat === 'Yes' ? 'VAT Included' : 'VAT Excluded';
        }
        return this.selectedOption === 'Yes' ? 'VAT Included' : 'VAT Excluded';
      },
      existingMonthlyBase() {
        if (!this.addData.houseId) return 0;
        const house = this.houseOptions.find(item => item.value == this.addData.houseId);
        if (!house) return 0;
        return house.priceOption === 'PerSquareMeter' ? (house.price * house.size) : house.price;
      },
      existingPriceBeforeVat() {
        const base = this.existingMonthlyBase;
        const vatIncluded = this.vatLabel === 'VAT Included';
        return vatIncluded ? parseFloat((base / 1.15).toFixed(2)) : base;
      },
      existingVatAmount() {
        return parseFloat((this.existingPriceBeforeVat * 0.15).toFixed(2));
      },
      existingPriceAfterVat() {
        return parseFloat((this.existingPriceBeforeVat + this.existingVatAmount).toFixed(2));
      },
      newMonthlyBase() {
        if (this.addData.priceOption === 'PerSquareMeter' && this.addData.size && this.addData.latest_price)
          return this.addData.size * this.addData.latest_price;
        return this.addData.latest_price || 0;
      },
      newPriceBeforeVat() {
        const base = this.newMonthlyBase;
        const vatIncluded = this.selectedOption === 'Yes';
        return vatIncluded ? parseFloat((base / 1.15).toFixed(2)) : base;
      },
      newVatAmount() {
        return parseFloat((this.newPriceBeforeVat * 0.15).toFixed(2));
      },
      newPriceAfterVat() {
        return parseFloat((this.newPriceBeforeVat + this.newVatAmount).toFixed(2));
      },
      advanceVatIncluded() {
        if (this.houseType === 'existing' && this.addData.houseId) {
          return this.vatLabel === 'VAT Included';
        }
        return this.selectedOption === 'Yes';
      },
      advanceBeforeVat() {
        const adv = parseFloat(this.addData.initialPayment) || 0;
        return this.advanceVatIncluded ? parseFloat((adv / 1.15).toFixed(2)) : adv;
      },
      advanceVatAmount() {
        return parseFloat((this.advanceBeforeVat * 0.15).toFixed(2));
      },
      advanceAfterVat() {
        return parseFloat((this.advanceBeforeVat + this.advanceVatAmount).toFixed(2));
      },
      advanceCurrency() {
        return this.houseType === 'existing' ? this.getRentCurrencyType : (this.addData.rentCurrencyType || 'ETB');
      },
      computedPriceExist(){
        var value = this.addData.houseId;
        var priceOption = this.houseOptions.filter(item=>item.value == value)[0].priceOption;
        var size = this.houseOptions.filter(item=>item.value == value)[0].size;
        var price = this.houseOptions.filter(item=>item.value == value)[0].price;
        if(priceOption == "PerSquareMeter"){
          if(size !== null && price !==null) return  this.numberWithCommas(size * price).toString();
          else return null
        }else{
          return null
        }
      },
      getTenantName: function(){
         var tenant = "";
        if(this.addData.tenantId !== null){
          tenant  = this.tenantOptions.filter(x=>x.value== this.addData.tenantId)[0].text;
        }
        return tenant;
      },
      getPeriodWithSelected: function(){
        var period = "";
        var option = "";
        if(this.addData.period !== 0 && this.addData.period !== null ){
          period  = this.periodOptions.filter(x=>x.value== this.addData.period)[0].text;
          option  = this.periodOptions2.filter(x=>x.value== this.addData.periodtwo)[0].text;
        }
        return period + " " + option;
      },
      computedPrice(){
        if(this.addData.priceOption == "PerSquareMeter"){
          if(this.addData.size !== null && this.addData.latest_price !==null) return this.addData.size * this.addData.latest_price;
          else return null
        }else{
          return null
        }
      },
      showPenaltyFields() {
        return this.addData.penaltyOption === 'fixedAmount' || this.addData.penaltyOption === 'percentage';
      },
      isStep1Valid() {
        if (this.houseType === 'existing') {
          return this.addData.houseId;
        } else {
          return this.addData.buildingId && this.addData.floor && this.addData.roomNumber && 
                 this.addData.size && this.addData.priceOption && this.addData.rentCurrencyType && 
                 this.addData.latest_price;
        }
      },
      isStep2Valid() {
        if (this.tenantType === 'existing') {
          return this.addData.tenantId;
        } else {
          return this.addData.fullName && this.addData.phoneNumber && this.addData.address && this.addData.sex;
        }
      },
      isStep3Valid() {
        return this.addData.startDate && this.addData.endDate && this.addData.period && 
               this.addData.periodtwo && this.addData.advancePeriod && this.addData.advancePeriodtwo && 
               this.addData.withHolding && this.addData.penaltyOption;
      },
      isFormValid() {
        return this.isStep1Valid && this.isStep2Valid && this.isStep3Valid && !this.isSubmitting;
      },
      contractDuration() {
        if (!this.addData.startDate || !this.addData.endDate) return '';
        const start = new Date(this.addData.startDate);
        const end = new Date(this.addData.endDate);
        end.setDate(end.getDate() + 1);
        let years = end.getFullYear() - start.getFullYear();
        let months = end.getMonth() - start.getMonth();
        let days = end.getDate() - start.getDate();
        if (days < 0) {
          months--;
          const prevMonthEnd = new Date(end.getFullYear(), end.getMonth(), 0);
          days += prevMonthEnd.getDate();
        }
        if (months < 0) {
          years--;
          months += 12;
        }
        const totalMonths = years * 12 + months;
        let result = '';
        if (totalMonths > 0) result += totalMonths + (totalMonths === 1 ? ' month' : ' months');
        if (days > 0) result += (result ? ' and ' : '') + days + (days === 1 ? ' day' : ' days');
        return result || '0 days';
      },
    },
     mounted() {
      this.getModules();
      this.getBuildings();
      this.getContractByOwnerID();
      this.getHouseByOwnerID();
      this.getTenantByOwnerID();
      this.$on("AfterComplete", () => {
        this.getBuildings();
        this.getContractByOwnerID();
        this.getHouseByOwnerID();
        this.getTenantByOwnerID();
      });
    },
    methods: {
      // Navigation methods for steps
      nextStep() {
        if (this.currentStep < 4) {
          this.currentStep++;
        }
      },
      
      // Renew contract navigation methods
      nextRenewStep() {
        if (this.renewCurrentStep < 3) {
          this.renewCurrentStep++;
        }
      },
      
      validateAndNextRenewStep() {
        const observerRef = this.renewCurrentStep === 1 ? 'renewStep1Observer' : 
                           this.renewCurrentStep === 2 ? 'renewStep2Observer' : null;
        
        if (observerRef && this.$refs[observerRef]) {
          this.$refs[observerRef].validate().then(success => {
            if (success) {
              this.nextRenewStep();
            }
          });
        } else {
          this.nextRenewStep();
        }
      },
      
      previousRenewStep() {
        if (this.renewCurrentStep > 1) {
          this.renewCurrentStep--;
        }
      },
      
      validateAndNextStep() {
        const observerRef = this.currentStep === 1 ? 'step1Observer' : 
                           this.currentStep === 2 ? 'step2Observer' : 
                           this.currentStep === 3 ? 'step3Observer' : null;
        
        if (observerRef && this.$refs[observerRef]) {
          this.$refs[observerRef].validate().then(success => {
            if (success) {
              this.nextStep();
            }
          });
        } else {
          this.nextStep();
        }
      },
      previousStep() {
        if (this.currentStep > 1) {
          this.currentStep--;
        }
      },
      
      // Reset methods for type changes
      resetHouseData() {
        this.checkedExistingHouse = this.houseType === 'existing';
        // Reset house-related fields
        this.addData.houseId = null;
        this.addData.buildingId = null;
        this.addData.floor = null;
        this.addData.roomNumber = '';
        this.addData.size = null;
        this.addData.priceOption = '';
        this.addData.rentCurrencyType = '';
        this.addData.latest_price = null;
        this.addData.description = '';
        this.addData.electricReading = null;
        this.addData.waterReading = null;
        this.addData.firstBillPaymentStarts = '';
      },
      
      resetTenantData() {
        this.checkedExistingTenant = this.tenantType === 'existing';
        // Reset tenant-related fields
        this.addData.tenantId = null;
        this.addData.fullName = '';
        this.addData.email = '';
        this.addData.sex = '';
        this.addData.phoneNumber = '';
        this.addData.address = '';
      },
      
      calculateDefaultAdvancePeriod() {
        const contract = this.items.find(item => item.contractId === this.editData.contractId);
        if (contract && contract.initialPayment) {
          let monthlyPrice = contract.monthlyPrice;
          if (!monthlyPrice && contract.house) {
            monthlyPrice = contract.house.priceOption === "PerSquareMeter" ? 
              contract.house.latestPrice * contract.house.size : contract.house.latestPrice;
          }
          if (monthlyPrice && monthlyPrice > 0) {
            const ratio = contract.initialPayment / monthlyPrice;
            this.editData.advancePeriod = ratio >= 12 ? Math.round(ratio / 12) : Math.round(ratio);
            this.editData.advancePeriodtwo = ratio >= 12 ? 2 : 1;
            console.log('Calculated advancePeriod:', this.editData.advancePeriod, 'advancePeriodtwo:', this.editData.advancePeriodtwo);
          }
        }
      },
      
      EditContract(contractId) {
        this.editData.contractId = contractId;
        this.calculateDefaultAdvancePeriod();
        setTimeout(() => {
          this.$bvModal.show("modal-top-EditContract");
        }, 100);
      },
      
      // Legacy tab methods for compatibility
      nextTab() {
        if (this.tabIndex < 3) {
          this.tabIndex++;
        }
      },
      previousTab() {
        if (this.tabIndex > 0) {
          this.tabIndex--;
        }
      },
      
      updateInitialPayment() {
        // Calculate initial payment for add modal
        if (this.addData.advancePeriod && this.addData.advancePeriodtwo) {
          let monthlyPrice = 0;
          
          // Get monthly price based on house type
          if (this.houseType === 'existing' && this.addData.houseId) {
            const house = this.houseOptions.find(h => h.value === this.addData.houseId);
            if (house) {
              if (house.priceOption === 'PerSquareMeter') {
                monthlyPrice = house.price * house.size;
              } else {
                monthlyPrice = house.price;
              }
            }
          } else if (this.houseType === 'new') {
            if (this.addData.priceOption === 'PerSquareMeter' && this.addData.size && this.addData.latest_price) {
              monthlyPrice = this.addData.size * this.addData.latest_price;
            } else if (this.addData.priceOption === 'PerMonth' && this.addData.latest_price) {
              monthlyPrice = this.addData.latest_price;
            }
          }
          
          if (monthlyPrice > 0) {
            let multiplier = this.addData.advancePeriod;
            if (this.addData.advancePeriodtwo === 2) { // Yearly
              multiplier = this.addData.advancePeriod * 12;
            }
            this.addData.initialPayment = monthlyPrice * multiplier;
          }
        }
      },
      
      updateEditInitialPayment() {
        console.log('=== updateEditInitialPayment called ===');
        console.log('editData.advancePeriod:', this.editData.advancePeriod);
        console.log('editData.advancePeriodtwo:', this.editData.advancePeriodtwo);
        
        if (this.editData.advancePeriod && this.editData.advancePeriodtwo) {
          let monthlyPrice = 0;
          
          // Get monthly price from contract data - check multiple possible locations
          if (this.selectedContract) {
            // First check if monthlyPrice exists directly on selectedContract
            if (this.selectedContract.monthlyPrice) {
              monthlyPrice = this.selectedContract.monthlyPrice;
              console.log('Monthly price from selectedContract.monthlyPrice:', monthlyPrice);
            }
            // Check if it's in the items array structure (from API response)
            else if (this.items && this.items.length > 0) {
              const currentContract = this.items.find(item => item.contractId === this.editData.contractId);
              if (currentContract) {
                if (currentContract.monthlyPrice) {
                  monthlyPrice = currentContract.monthlyPrice;
                  console.log('Monthly price from items array:', monthlyPrice);
                } else if (currentContract.house) {
                  // Calculate from house data in the contract
                  const house = currentContract.house;
                  if (house.priceOption === 'PerSquareMeter' && house.size && house.latestPrice) {
                    monthlyPrice = house.latestPrice * house.size;
                    console.log('Calculated monthly price from contract house data:', house.latestPrice, '*', house.size, '=', monthlyPrice);
                  } else if (house.latestPrice) {
                    monthlyPrice = house.latestPrice;
                    console.log('Monthly price from contract house.latestPrice:', monthlyPrice);
                  }
                }
              }
            }
            // Fallback: calculate from selectedContract house data
            else if (this.selectedContract.house && this.selectedContract.house.latestPrice) {
              const house = this.selectedContract.house;
              if (house.priceOption === 'PerSquareMeter' && house.size) {
                monthlyPrice = house.latestPrice * house.size;
                console.log('Calculated monthly price from selectedContract house data:', house.latestPrice, '*', house.size, '=', monthlyPrice);
              } else {
                monthlyPrice = house.latestPrice;
                console.log('Monthly price from selectedContract house.latestPrice:', monthlyPrice);
              }
            }
            // Another fallback: use houseInformation if available
            else if (this.selectedContract.houseInformation) {
              const houseInfo = this.selectedContract.houseInformation;
              if (houseInfo.priceOption === 'PerSquareMeter' && houseInfo.size && houseInfo.price) {
                monthlyPrice = houseInfo.price * houseInfo.size;
                console.log('Calculated from houseInformation:', houseInfo.price, '*', houseInfo.size, '=', monthlyPrice);
              } else if (houseInfo.price) {
                monthlyPrice = houseInfo.price;
                console.log('Monthly price from houseInformation.price:', monthlyPrice);
              }
            }
            
            // If still no monthly price found, try to get it from editData
            if (monthlyPrice === 0 && this.editData.monthlyPrice) {
              monthlyPrice = this.editData.monthlyPrice;
              console.log('Monthly price from editData.monthlyPrice:', monthlyPrice);
            }
          }
          
          if (monthlyPrice > 0) {
            let multiplier = this.editData.advancePeriod;
            if (this.editData.advancePeriodtwo === 2) { // Yearly
              multiplier = this.editData.advancePeriod * 12;
              console.log('Yearly multiplier calculated:', multiplier);
            } else {
              console.log('Monthly multiplier:', multiplier);
            }
            
            this.editData.initialPayment = monthlyPrice * multiplier;
            console.log('Final calculation:', monthlyPrice, '*', multiplier, '=', this.editData.initialPayment);
          } else {
            console.log('Monthly price is 0 or invalid, no calculation performed');
          }
        } else {
          console.log('Missing advance period data - advancePeriod:', this.editData.advancePeriod, 'advancePeriodtwo:', this.editData.advancePeriodtwo);
        }
        console.log('=== updateEditInitialPayment end ===');
      },
      
      convertAmountToPeriods(amount, monthlyPrice) {
        // Convert advance payment amount to period number and unit
        if (!amount || !monthlyPrice || monthlyPrice <= 0) {
          return { periodNumber: 1, periodUnit: 1 }; // Default to 1 month
        }
        
        const months = Math.round(amount / monthlyPrice);
        
        // If it's a multiple of 12, convert to years
        if (months >= 12 && months % 12 === 0) {
          return {
            periodNumber: months / 12,
            periodUnit: 2 // Yearly
          };
        }
        
        // Otherwise, keep as months
        return {
          periodNumber: months,
          periodUnit: 1 // Monthly
        };
      },
      
      // Handle submit button click with immediate disable
      handleSubmitClick(event) {
        if (event) {
          event.preventDefault();
        }
        
        // Immediately disable to prevent multiple clicks
        if (this.isSubmitting) return;
        
        this.confirmSubmitAddForm();
      },
      
      // Confirmation methods for form submission
      confirmSubmitAddForm() {
        this.$bvModal.msgBoxConfirm('Are you sure you want to submit this form?', {
          title: 'Confirm',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'success',
          cancelVariant: 'danger',
          okTitle: 'YES',
          cancelTitle: 'NO',
          bodyClass: 'm-2',
          hideHeaderClose: false,
          centered: false
        })
        .then(value => {
          if (value === true) {
            this.isSubmitting = true;
            this.submitAddForm();
          }
        });
      },
      
      // Handle edit submit button click with immediate disable
      handleEditSubmitClick(event) {
        if (event) {
          event.preventDefault();
        }
        
        // Immediately disable to prevent multiple clicks
        if (this.isSubmitting) return;
        
        this.confirmSubmitEditForm();
      },
      
      confirmSubmitEditForm() {
        // if (this.isSubmitting) return;
        
        // this.$bvModal.msgBoxConfirm('Are you sure you want to submit this form?', {
        //   title: 'Confirm',
        //   size: 'sm',
        //   buttonSize: 'sm',
        //   okVariant: 'success',
        //   cancelVariant: 'danger',
        //   okTitle: 'YES',
        //   cancelTitle: 'NO',
        //   bodyClass: 'm-2',
        //   hideHeaderClose: false,
        //   centered: false
        // })
        // .then(value => {
        //   if (value === true) {
            this.submitEditForm();
        //   }
        // });
      },
      
      submitEditForm() {
        if (this.isSubmitting) return;
        
        this.isSubmitting = true;
        
        let penaltyAmount;
        let dateRange;
        if(this.editData.dateRangeForPenaltyIncrement === "Other"){
          dateRange = this.editData.dateRangeForUserInput;
        } else {
          dateRange = this.editData.dateRangeForPenaltyIncrement;
        }
        
        if (this.editData.penaltyAmount === "Other"){
          if(this.editData.penaltyAmountFixed === 0){
            penaltyAmount = this.editData.penaltyAmountPercent;
          } else {
            penaltyAmount = this.editData.penaltyAmountFixed;
          }
        } else {
          penaltyAmount = this.editData.penaltyAmount;
        }
        
        var fileToAttach = "";
        if(this.base64 != null){
          fileToAttach = this.base64.split(',')[1];
        }
        
        if(fileToAttach == ""){
          fileToAttach = this.editData.encodedPdf == null ? "" : this.editData.encodedPdf;
        }
        
        var period = this.editData.period * this.editData.periodtwo;
        
        this.$store.dispatch('EditContract', {
          contractId: this.editData.contractId,
          startDate: this.editData.startDate,
          endDate: this.editData.endDate,
          initialPayment: this.editData.initialPayment,
          guaranteedMoney: this.editData.guaranteedMoney,
          dueDate: this.editData.dueDate,
          period: period,
          paymentRule: this.editData.paymentRule,
          encodePdf: fileToAttach,
          penaltyOption: this.editData.penaltyOption,
          penaltyCondition: this.editData.penaltyCondition,
          withHolding: this.editData.withHolding,
          dateRangeForPenaltyIncrement: dateRange,
          penaltyAmount: penaltyAmount,
          userId: parseInt(sessionStorage.getItem("ID")),
          registeredBy: parseInt(sessionStorage.getItem("userID"))
        })
        .then(response => {
          this.$notifications.notify({
            message: 'Contract successfully updated.',
            horizontalAlign: 'center',
            verticalAlign: 'top',
            type: 'success'
          });
          this.$bvModal.hide('modal-top-EditContract');
          this.$bvModal.hide('modal-top-EnableContract');
          this.clearData();
          this.getContractByOwnerID();
          this.isSubmitting = false;
        })
        .catch(error => {
          this.$notifications.notify({
            message: error.response.data,
            horizontalAlign: 'center',
            verticalAlign: 'top',
            type: 'danger'
          });
          this.isSubmitting = false;
        })
        .finally(() => {
          this.isSubmitting = false;
        });
      },
      
      // Clear form data
      clearData() {
        // Reset add form data
        this.addData = {
          floor: null,
          roomNumber: "",
          size: null,
          buildingId: null,
          latest_price: null,
          priceOption: "",
          rentCurrencyType: "",
          description: "",
          fullName: "",
          email: "",
          sex: "",
          phoneNumber: "",
          address: "",
          firstBillPaymentStarts: "",
          startDate: "",
          endDate: "",
          dueDate: 0,
          payedAmount: 0,
          tenantId: null,
          houseId: null,
          period: null,
          periodtwo: 1,
          initialPayment: null,
          guaranteedMoney: null,
          paymentRule: "",
          attachedFile: "",
          registeredBy: sessionStorage.getItem("userID"),
          userId: parseInt(sessionStorage.getItem("ID")),
          electricReading: null,
          waterReading: null,
          penaltyOption: "",
          penaltyCondition: "",
          dateRangeForPenaltyIncrement: "",
          dateRangeForUserInput: null,
          penaltyAmount: "",
          penaltyAmountPercent: null,
          penaltyAmountFixed: null,
          withHolding: "",
          advancePeriod: null,
          advancePeriodtwo: 1
        };
        
        // Reset edit form data
        this.editData = {
          contractId: null,
          firstBillPaymentStarts: "",
          startDate: "",
          endDate: "",
          dueDate: 0,
          initialPayment: 0,
          guaranteedMoney: 0,
          paymentRule: "",
          period: 1,
          periodtwo: 1,
          encodedPdf: null,
          penaltyOption: "",
          penaltyCondition: "",
          dateRangeForPenaltyIncrement: 0,
          dateRangeForUserInput: 0,
          penaltyAmount: 0,
          penaltyAmountPercent: 0,
          penaltyAmountFixed: 0,
          advancePeriod: 1,
          advancePeriodtwo: 1,
          withHolding: "",
          monthlyPrice: 0
        };
        
        // Reset form states
        this.currentStep = 1;
        this.renewCurrentStep = 1;
        this.houseType = 'existing';
        this.tenantType = 'existing';
        this.selectedOption = 'Yes';
        this.landlordName = '';
        this.file = null;
        this.base64 = null;
        this.isSubmitting = false;
        this.isUploading = false;
        this.fileError = '';
        this.errorMessage = '';
        this.errorMessage1 = '';
        
        // Clear validation observers
        if (this.$refs.step1Observer) this.$refs.step1Observer.reset();
        if (this.$refs.step2Observer) this.$refs.step2Observer.reset();
        if (this.$refs.step3Observer) this.$refs.step3Observer.reset();
      },
      
      // Add missing methods
      AddContract() {
        this.clearData();
        this.currentStep = 1;
        this.isSubmitting = false;
        this.$bvModal.show('modal-top-add');
      },
      
      DisableContract() {
        this.$bvModal.show('modal-top-disable');
      },
      
      ViewDetail(contractId) {
        // Load contract details and show modal
        this.$bvModal.show('modal-top-Details');
      },
      
      EnableContract(contractIdentifier) {
        // Load contract for renewal
        this.$bvModal.show('modal-top-EnableContract');
      },
      
      downloadFile(contractId) {
        // Download contract file
        console.log('Downloading file for contract:', contractId);
      },
      
      SubmitDisableContract(contractIdentifier) {
        // Disable contract logic
        console.log('Disabling contract:', contractIdentifier);
      },
      
      searchContractByID() {
        // Search contract by ID
        console.log('Searching contract by ID:', this.contractId);
      },
      
      getContractByOwnerID() {
        // Load contracts
        console.log('Loading contracts');
      },
      
      changePerPage() {
        // Handle per page change
        console.log('Per page changed to:', this.perPage);
      },
      
      changePage(page) {
        // Handle page change
        this.currentPage = page;
      },
      
      getModules() {
        // Load module permissions
        console.log('Loading modules');
      },
      
      getBuildings() {
        // Load buildings
        console.log('Loading buildings');
      },
      
      getHouseByOwnerID() {
        this.$store.dispatch('getFreeHousesByOwnerID', { userId: sessionStorage.getItem('ID') })
          .then(response => {
            this.houseOptions = [];
            Array.from(response.data).forEach(value => {
              this.houseOptions.push({
                value: String(value.houseId),
                text: value.building.buildingName + ' - ' + value.floor + ' - ' + value.roomNumber,
                price: value.latestPrice,
                priceOption: value.priceOption,
                rentCurrencyType: value.rentCurrencyType,
                size: value.size,
                includeVat: value.includeVat,
                electricBillAmountOption: value.electricBillAmountOption,
                waterBillAmountOption: value.waterBillAmountOption,
                billExist: value.building ? value.building.billExist : 'no'
              });   
            });
          })
          .catch(error => { console.log(error); });
      },
      
      getTenantByOwnerID() {
        // Load tenants
        console.log('Loading tenants');
      },
      
      getBillOptionByHouseIdElectric(houseId) {
        // Get electric bill option for house
        return 'ByReading'; // Default return
      },
      
      getBillOptionByHouseIdWater(houseId) {
        // Get water bill option for house
        return 'ByReading'; // Default return
      },
      
      getBillExistOptionByHouseId(houseId) {
        // Get bill exist option for house
        return 'yes'; // Default return
      },
      
      getBillOptionByIDElectric(buildingId) {
        // Get electric bill option for building
        return 'ByReading'; // Default return
      },
      
      getBillOptionByIDWater(buildingId) {
        // Get water bill option for building
        return 'ByReading'; // Default return
      },
      
      getBillExistOptionByBuildingId(buildingId) {
        // Get bill exist option for building
        return 'yes'; // Default return
      },
      
      updateSize(newValue) {
        this.addData.size = newValue;
        this.updateInitialPayment();
      },
      
      updatePrice(newValue) {
        this.addData.latest_price = newValue;
        this.updateInitialPayment();
      },
      
      handleFileChange() {
        // Handle file upload
        if (this.file) {
          console.log('File selected:', this.file.name);
          // Add file processing logic here
        }
      },
      
      numberWithCommas(x) {
        if (x === null || x === undefined) return '0';
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      },
      
      calculateDuration(startDate, endDate) {
        if (!startDate || !endDate) return '';
        const start = new Date(startDate);
        // Add 1 day to end to make it inclusive (end date is fully counted)
        const end = new Date(endDate);
        end.setDate(end.getDate() + 1);
        let years = end.getFullYear() - start.getFullYear();
        let months = end.getMonth() - start.getMonth();
        let days = end.getDate() - start.getDate();
        if (days < 0) {
          months--;
          // Days in the previous month relative to end
          const prevMonthEnd = new Date(end.getFullYear(), end.getMonth(), 0);
          days += prevMonthEnd.getDate();
        }
        if (months < 0) {
          years--;
          months += 12;
        }
        const totalMonths = years * 12 + months;
        let result = '';
        if (totalMonths > 0) result += totalMonths + (totalMonths === 1 ? ' month' : ' months');
        if (days > 0) result += (result ? ' and ' : '') + days + (days === 1 ? ' day' : ' days');
        return result || '0 days';
      },

      getStatus(status) {
        return status === 1 ? 'Active' : 'Inactive';
      },
      
      getPeriod(period) {
        const periodOption = this.periodOptions.find(p => p.value === period);
        return periodOption ? periodOption.text + ' Month(s)' : period;
      },
      
      getPenaltyDescription() {
        if (this.addData.penaltyOption === 'percentage') {
          return `${this.addData.penaltyAmount}% of monthly rent`;
        } else if (this.addData.penaltyOption === 'fixedAmount') {
          return `${this.addData.penaltyAmount} ${this.addData.rentCurrencyType || 'ETB'}`;
        }
        return 'None';
      },
      
      hasUtilities() {
        return this.showElectricReading() || this.showWaterReading() || this.addData.firstBillPaymentStarts;
      },
      
      showElectricReading() {
        if (this.houseType === 'existing') {
          return this.getBillOptionByHouseIdElectric(this.addData.houseId) === 'ByReading';
        } else {
          return this.getBillOptionByIDElectric(this.addData.buildingId) === 'ByReading';
        }
      },
      
      showWaterReading() {
        if (this.houseType === 'existing') {
          return this.getBillOptionByHouseIdWater(this.addData.houseId) === 'ByReading';
        } else {
          return this.getBillOptionByIDWater(this.addData.buildingId) === 'ByReading';
        }
      },

      getContractHTML() {
        const vatLabel = this.vatLabel;
        let basePrice, vatAmount, priceAfterVat, currency;
        if (this.houseType === 'existing') {
          basePrice = this.existingPriceBeforeVat;
          vatAmount = this.existingVatAmount;
          priceAfterVat = this.existingPriceAfterVat;
          currency = this.getRentCurrencyType;
        } else {
          basePrice = this.newPriceBeforeVat;
          vatAmount = this.newVatAmount;
          priceAfterVat = this.newPriceAfterVat;
          currency = this.addData.rentCurrencyType;
        }
        const tenantRows = this.tenantType === 'existing'
          ? `<tr><td class="label">Name</td><td>${this.getTenantName}</td></tr><tr><td class="label">Role</td><td>Lessee</td></tr>`
          : `<tr><td class="label">Name</td><td>${this.addData.fullName}</td></tr>
             <tr><td class="label">Email</td><td>${this.addData.email}</td></tr>
             <tr><td class="label">Phone</td><td>+251${this.addData.phoneNumber}</td></tr>
             <tr><td class="label">Address</td><td>${this.addData.address}</td></tr>
             <tr><td class="label">Gender</td><td>${this.addData.sex}</td></tr>`;
        const propertyRows = this.houseType === 'existing'
          ? `<tr><td class="label">Property</td><td>${this.getHouseName}</td></tr>
             <tr><td class="label">Pricing</td><td>${this.getPriceOptionByValue}</td></tr>
             <tr><td class="label">Currency</td><td>${this.getRentCurrencyType}</td></tr>
             <tr><td class="label">Rate</td><td>${this.getPriceByValue} per ${this.getPriceOptionByValue === 'PerSquareMeter' ? 'sq.m' : 'month'}</td></tr>
             ${this.getPriceOptionByValue === 'PerSquareMeter' ? `<tr><td class="label">Monthly</td><td>${this.computedPriceExist}</td></tr>` : ''}`
          : `<tr><td class="label">Building</td><td>${this.getBuildingName}</td></tr>
             <tr><td class="label">Floor</td><td>${this.addData.floor}</td></tr>
             <tr><td class="label">Room</td><td>${this.addData.roomNumber}</td></tr>
             <tr><td class="label">Size</td><td>${this.addData.size} sq.m</td></tr>
             <tr><td class="label">Pricing</td><td>${this.addData.priceOption}</td></tr>
             <tr><td class="label">Currency</td><td>${this.addData.rentCurrencyType}</td></tr>
             <tr><td class="label">Rate</td><td>${this.numberWithCommas(this.addData.latest_price)} per ${this.addData.priceOption === 'PerSquareMeter' ? 'sq.m' : 'month'}</td></tr>
             ${this.addData.priceOption === 'PerSquareMeter' ? `<tr><td class="label">Monthly</td><td>${this.numberWithCommas(this.computedPrice)}</td></tr>` : ''}
             ${this.addData.description ? `<tr><td class="label">Description</td><td>${this.addData.description}</td></tr>` : ''}`;
        const utilitiesSection = (this.showElectricReading() || this.showWaterReading() || this.addData.firstBillPaymentStarts) ? `
          <div class="section">
            <div class="section-title">UTILITIES AND SERVICES</div>
            <table><tbody>
              ${this.showElectricReading() ? `<tr><td class="label">Electricity</td><td>Base reading: ${this.addData.electricReading} KWH</td></tr>` : ''}
              ${this.showWaterReading() ? `<tr><td class="label">Water</td><td>Base reading: ${this.addData.waterReading} m³</td></tr>` : ''}
              ${this.addData.firstBillPaymentStarts ? `<tr><td class="label">First Bill</td><td>${this.addData.firstBillPaymentStarts}</td></tr>` : ''}
            </tbody></table>
          </div>` : '';
        const landlordDisplay = this.landlordName || '________________________________';
        return `<!DOCTYPE html><html><head><meta charset="utf-8"><title>Rental Agreement Contract</title>
          <style>
            body{font-family:'Times New Roman',serif;color:#333;margin:40px;line-height:1.6}
            h1{text-align:center;color:#007bff;font-size:20px;margin-bottom:4px}
            .subtitle{text-align:center;color:#666;font-size:12px;margin-bottom:30px}
            .section{margin-bottom:25px}
            .section-title{font-size:14px;font-weight:bold;color:rgb(37,91,48);border-bottom:2px solid rgb(37,91,48);padding-bottom:5px;margin-bottom:12px;text-transform:uppercase}
            .parties{display:flex;gap:20px}
            .party-box{flex:1;border:1px solid #007bff;border-radius:4px;padding:12px}
            .party-header{background-color:rgb(37,91,48);color:white;padding:6px 10px;border-radius:3px;font-weight:bold;margin-bottom:10px}
            table{width:100%;border-collapse:collapse}
            td{padding:5px 8px;font-size:13px}
            td.label{font-weight:bold;width:40%;color:#444}
            .sigs{display:flex;gap:20px;margin-top:15px}
            .sigs>div{flex:1}
            .sig-box{border:1px solid #ccc;border-radius:4px;padding:15px;background:#f8f9fa}
            .sig-line{border-bottom:1px solid #333;height:40px;margin:10px 0 5px}
            @media print{body{margin:20px}}
          </style></head><body>
          <h1>RENTAL AGREEMENT CONTRACT</h1>
          <p class="subtitle">This agreement is made between the landlord and tenant under the following terms and conditions</p>
          <div class="section">
            <div class="section-title">PARTIES TO THE AGREEMENT</div>
            <div class="parties">
              <div class="party-box">
                <div class="party-header">LANDLORD</div>
                <table><tbody>
                  <tr><td class="label">Name</td><td>${landlordDisplay}</td></tr>
                  <tr><td class="label">Role</td><td>Lessor</td></tr>
                  <tr><td class="label">Rep. by</td><td>${this.getCurrentUserName()}</td></tr>
                </tbody></table>
              </div>
              <div class="party-box">
                <div class="party-header">TENANT</div>
                <table><tbody>${tenantRows}</tbody></table>
              </div>
            </div>
          </div>
          <div class="section">
            <div class="section-title">PROPERTY DETAILS</div>
            <p>The landlord hereby agrees to rent to the tenant the following described property:</p>
            <table><tbody>
              ${propertyRows}
              <tr><td class="label">VAT (15%)</td><td>${vatLabel}</td></tr>
              <tr><td class="label">Rent Amount(Before VAT)</td><td>${this.numberWithCommas(basePrice)} ${currency}</td></tr>
              <tr><td class="label">VAT Amount</td><td>${this.numberWithCommas(vatAmount)} ${currency}</td></tr>
              <tr><td class="label">Total Amount</td><td><strong>${this.numberWithCommas(priceAfterVat)} ${currency}</strong></td></tr>
            </tbody></table>
          </div>
          <div class="section">
            <div class="section-title">TERMS AND CONDITIONS</div>
            <table><tbody>
              <tr><td class="label">Start Date</td><td>${this.addData.startDate}</td></tr>
              <tr><td class="label">End Date</td><td>${this.addData.endDate}</td></tr>
              <tr><td class="label">Payment Frequency</td><td>${this.addData.period} ${this.addData.periodtwo === 1 ? 'month(s)' : 'year(s)'}</td></tr>
              <tr><td class="label">Due Date</td><td>${this.addData.dueDate} days</td></tr>
              ${this.addData.initialPayment > 0 ? `<tr><td class="label">Advance Payment</td><td>${this.numberWithCommas(this.addData.initialPayment)} ${currency}</td></tr>` : ''}
              ${this.addData.guaranteedMoney > 0 ? `<tr><td class="label">Security Deposit</td><td>${this.numberWithCommas(this.addData.guaranteedMoney)} ${currency}</td></tr>` : ''}
              <tr><td class="label">Penalty</td><td>${this.addData.penaltyOption === 'noPenalty' ? 'None' : this.getPenaltyDescription()}</td></tr>
              <tr><td class="label">VAT (15%)</td><td>${vatLabel}</td></tr>
              <tr><td class="label">W.Tax (3%)</td><td>${this.addData.withHolding === 'Yes' ? 'Applicable' : 'Not Applicable'}</td></tr>
              <tr><td class="label">Price Before VAT</td><td>${this.numberWithCommas(basePrice)}</td></tr>
              <tr><td class="label">VAT Amount</td><td>${this.numberWithCommas(vatAmount)}</td></tr>
              <tr><td class="label">Price After VAT</td><td><strong>${this.numberWithCommas(priceAfterVat)}</strong></td></tr>
            </tbody></table>
          </div>
          ${utilitiesSection}
          <div class="section">
            <div class="section-title">LEGAL AGREEMENT</div>
            <table><tbody>
              <tr><td class="label">Acknowledgment</td><td>Both parties agree to all terms and conditions</td></tr>
              <tr><td class="label">Governing Law</td><td>Laws of Ethiopia</td></tr>
              <tr><td class="label">Document</td><td>${this.file ? this.file.name : 'No additional documents'}</td></tr>
            </tbody></table>
            <div class="sigs">
              <div><div class="sig-box"><strong>Landlord Signature:</strong><div class="sig-line"></div><small>Name: ${landlordDisplay}</small><br><small>Date: _______________</small></div></div>
              <div><div class="sig-box"><strong>Tenant Signature:</strong><div class="sig-line"></div><small>Date: _______________</small></div></div>
            </div>
          </div>
        </body></html>`;
      },

      async downloadContract() {
        const html = this.getContractHTML();
        const w = window.open('', '_blank');
        w.document.write(html);
        w.document.close();
        w.focus();
        setTimeout(() => { w.print(); }, 500);
      },

      printContract() {
        const html = this.getContractHTML();
        const w = window.open('', '_blank');
        w.document.write(html);
        w.document.close();
        w.focus();
        setTimeout(() => { w.print(); }, 500);
      },

      async downloadContractLEGACY() {
        const vatIncluded = this.vatLabel;
        let basePrice, vatAmount, priceAfterVat, priceLabel;
        if (this.houseType === 'existing') {
          basePrice = this.existingPriceBeforeVat;
          vatAmount = this.existingVatAmount;
          priceAfterVat = this.existingPriceAfterVat;
          priceLabel = this.getRentCurrencyType;
        } else {
          basePrice = this.newPriceBeforeVat;
          vatAmount = this.newVatAmount;
          priceAfterVat = this.newPriceAfterVat;
          priceLabel = this.addData.rentCurrencyType;
        }
        const printWindow = window.open('', '_blank');
        const existingHouseRows = this.houseType === 'existing' ? `
          <tr><td class="label">Property</td><td>${this.getHouseName}</td></tr>
          <tr><td class="label">Pricing</td><td>${this.getPriceOptionByValue}</td></tr>
          <tr><td class="label">Currency</td><td>${this.getRentCurrencyType}</td></tr>
          <tr><td class="label">Rate</td><td>${this.getPriceByValue} per ${this.getPriceOptionByValue === 'PerSquareMeter' ? 'sq.m' : 'month'}</td></tr>
          ${this.getPriceOptionByValue === 'PerSquareMeter' ? `<tr><td class="label">Monthly</td><td>${this.computedPriceExist}</td></tr>` : ''}
        ` : `
          <tr><td class="label">Building</td><td>${this.getBuildingName}</td></tr>
          <tr><td class="label">Floor</td><td>${this.addData.floor}</td></tr>
          <tr><td class="label">Room</td><td>${this.addData.roomNumber}</td></tr>
          <tr><td class="label">Size</td><td>${this.addData.size} sq.m</td></tr>
          <tr><td class="label">Pricing</td><td>${this.addData.priceOption}</td></tr>
          <tr><td class="label">Currency</td><td>${this.addData.rentCurrencyType}</td></tr>
          <tr><td class="label">Rate</td><td>${this.numberWithCommas(this.addData.latest_price)} per ${this.addData.priceOption === 'PerSquareMeter' ? 'sq.m' : 'month'}</td></tr>
          ${this.addData.priceOption === 'PerSquareMeter' ? `<tr><td class="label">Monthly</td><td>${this.numberWithCommas(this.computedPrice)}</td></tr>` : ''}
          ${this.addData.description ? `<tr><td class="label">Description</td><td>${this.addData.description}</td></tr>` : ''}
        `;
        printWindow.document.write(`
          <html>
            <head>
              <title>Rental Agreement Contract</title>
              <style>
                body { font-family: 'Times New Roman', serif; margin: 25px; line-height: 1.5; color: #333; font-size: 12px; }
                .header { text-align: center; margin-bottom: 25px; border-bottom: 3px solid #000; padding-bottom: 15px; }
                .section { margin: 20px 0; page-break-inside: avoid; }
                .section-title { font-weight: bold; font-size: 14px; margin-bottom: 12px; color: #000; background-color: #f0f0f0; padding: 8px; border-left: 4px solid #255b30; }
                table { width: 100%; border-collapse: collapse; margin: 10px 0; }
                td { padding: 6px 10px; border: 1px solid #ddd; vertical-align: top; }
                .label { font-weight: bold; width: 35%; background-color: #f8f9fa; }
                .highlight { background-color: #e8f5e9; font-weight: bold; }
              </style>
            </head>
            <body>
              <div class="header">
                <h1>RENTAL AGREEMENT CONTRACT</h1>
                <p>This agreement is made between the landlord and tenant under the following terms and conditions</p>
              </div>
              <div class="section">
                <div class="section-title">PARTIES TO THE AGREEMENT</div>
                <table>
                  <tr><td class="label">Landlord Rep.</td><td>${this.getCurrentUserName()}</td></tr>
                  <tr><td class="label">Tenant</td><td>${this.tenantType === 'existing' ? this.getTenantName : this.addData.fullName}</td></tr>
                  ${this.tenantType !== 'existing' ? `<tr><td class="label">Phone</td><td>+251${this.addData.phoneNumber}</td></tr><tr><td class="label">Address</td><td>${this.addData.address}</td></tr>` : ''}
                </table>
              </div>
              <div class="section">
                <div class="section-title">PROPERTY DETAILS</div>
                <table>
                  ${existingHouseRows}
                  <tr><td class="label">VAT (15%)</td><td>${vatIncluded}</td></tr>
                  <tr><td class="label">Price Before VAT</td><td>${this.numberWithCommas(basePrice)} ${priceLabel}</td></tr>
                  <tr><td class="label">VAT Amount (15%)</td><td>${this.numberWithCommas(vatAmount)} ${priceLabel}</td></tr>
                  <tr class="highlight"><td class="label">Price After VAT</td><td><strong>${this.numberWithCommas(priceAfterVat)} ${priceLabel}</strong></td></tr>
                </table>
              </div>
              <div class="section">
                <div class="section-title">CONTRACT TERMS</div>
                <table>
                  <tr><td class="label">Start Date</td><td>${this.addData.startDate}</td></tr>
                  <tr><td class="label">End Date</td><td>${this.addData.endDate}</td></tr>
                  <tr><td class="label">Payment Frequency</td><td>${this.addData.period} ${this.addData.periodtwo === 1 ? 'month(s)' : 'year(s)'}</td></tr>
                  <tr><td class="label">Due Date</td><td>${this.addData.dueDate} days</td></tr>
                  ${this.addData.initialPayment > 0 ? `<tr><td class="label">Advance Payment</td><td>${this.numberWithCommas(this.addData.initialPayment)} ${this.addData.rentCurrencyType || 'ETB'}</td></tr>` : ''}
                  ${this.addData.guaranteedMoney > 0 ? `<tr><td class="label">Security Deposit</td><td>${this.numberWithCommas(this.addData.guaranteedMoney)} ${this.addData.rentCurrencyType || 'ETB'}</td></tr>` : ''}
                  <tr><td class="label">Withholding Tax (3%)</td><td>${this.addData.withHolding === 'Yes' ? 'Applicable' : 'Not Applicable'}</td></tr>
                  <tr><td class="label">Penalty</td><td>${this.addData.penaltyOption === 'noPenalty' ? 'None' : this.getPenaltyDescription()}</td></tr>
                </table>
              </div>
              <div class="section">
                <div class="section-title">SIGNATURES</div>
                <table>
                  <tr><td class="label">Landlord Signature</td><td style="height:50px;"></td></tr>
                  <tr><td class="label">Tenant Signature</td><td style="height:50px;"></td></tr>
                  <tr><td class="label">Date</td><td></td></tr>
                </table>
              </div>
            </body>
          </html>
        `);
        printWindow.document.close();
        printWindow.print();
      },
      
      printContract() {
        this.downloadContract();
      },
      
      // Helper methods for contract review
      getCurrentUserName() {
        return sessionStorage.getItem('userName') || 'Property Manager';
      },
      
      printContractDetail() {
        const printWindow = window.open('', '_blank');
        printWindow.document.write(`
          <html>
            <head>
              <title>Contract Details - ${this.selectedContract.contractInformation.contractId || 'Contract'}</title>
              <style>
                body { font-family: 'Times New Roman', serif; margin: 25px; line-height: 1.5; color: #333; font-size: 12px; }
                .header { text-align: center; margin-bottom: 25px; border-bottom: 3px solid #000; padding-bottom: 15px; }
                .section { margin: 20px 0; page-break-inside: avoid; }
                .section-title { font-weight: bold; font-size: 14px; margin-bottom: 12px; color: #000; background-color: #f0f0f0; padding: 8px; border-left: 4px solid #007bff; }
                table { width: 100%; border-collapse: collapse; margin: 10px 0; }
                td { padding: 6px 10px; border: 1px solid #ddd; vertical-align: top; }
                .label { font-weight: bold; width: 35%; background-color: #f8f9fa; }
              </style>
            </head>
            <body>
              <div class="header">
                <h1>CONTRACT DETAILS</h1>
                <p>Complete contract information and current status</p>
              </div>
              
              <div class="section">
                <div class="section-title">PARTIES TO THE AGREEMENT</div>
                <table>
                  <tr><td class="label">Landlord Representative</td><td>${this.getCurrentUserName()}</td></tr>
                  <tr><td class="label">Tenant Name</td><td>${this.selectedContract.tenantInformation.fullName}</td></tr>
                  <tr><td class="label">Tenant Email</td><td>${this.selectedContract.tenantInformation.email || 'Not provided'}</td></tr>
                  <tr><td class="label">Tenant Phone</td><td>${this.selectedContract.tenantInformation.phoneNumber}</td></tr>
                  <tr><td class="label">Tenant Address</td><td>${this.selectedContract.tenantInformation.address}</td></tr>
                </table>
              </div>
              
              <div class="section">
                <div class="section-title">PROPERTY DETAILS</div>
                <table>
                  <tr><td class="label">Building</td><td>${this.selectedContract.buildingInformation.buildingName}</td></tr>
                  <tr><td class="label">Floor</td><td>${this.selectedContract.houseInformation.floor}</td></tr>
                  <tr><td class="label">Room</td><td>${this.selectedContract.houseInformation.roomNumber}</td></tr>
                  <tr><td class="label">Size</td><td>${this.selectedContract.houseInformation.size} sq.m</td></tr>
                  <tr><td class="label">Pricing</td><td>${this.selectedContract.houseInformation.priceOption}</td></tr>
                  <tr><td class="label">Currency</td><td>${this.selectedContract.guaranty.currency || 'ETB'}</td></tr>
                  <tr><td class="label">Rate</td><td>${this.numberWithCommas(this.selectedContract.houseInformation.price)} per ${this.selectedContract.houseInformation.priceOption === 'PerSquareMeter' ? 'sq.m' : 'month'}</td></tr>
                  ${this.selectedContract.houseInformation.priceOption === 'PerSquareMeter' ? `<tr><td class="label">Monthly Rent</td><td>${this.numberWithCommas(this.selectedContract.houseInformation.price * this.selectedContract.houseInformation.size)} ${this.selectedContract.guaranty.currency || 'ETB'}</td></tr>` : ''}
                  <tr><td class="label">House Status</td><td>${this.getStatus(this.selectedContract.houseInformation.status)}</td></tr>
                </table>
              </div>
              
              <div class="section">
                <div class="section-title">CONTRACT TERMS</div>
                <table>
                  <tr><td class="label">Start Date</td><td>${this.selectedContract.contractInformation.startDate}</td></tr>
                  <tr><td class="label">End Date</td><td>${this.selectedContract.contractInformation.endDate}</td></tr>
                  <tr><td class="label">Duration</td><td>${this.calculateDuration(this.selectedContract.contractInformation.startDate, this.selectedContract.contractInformation.endDate)}</td></tr>
                  <tr><td class="label">Payment Period</td><td>${this.getPeriod(this.selectedContract.contractInformation.period)}</td></tr>
                  <tr><td class="label">Due Date</td><td>${this.selectedContract.contractInformation.dueDate} days</td></tr>
                  <tr><td class="label">Next Payment</td><td>${this.selectedContract.contractInformation.nextPaymentDate}</td></tr>
                </table>
              </div>
              
              <div class="section">
                <div class="section-title">PAYMENT STATUS</div>
                <table>
                  <tr><td class="label">Rent Status</td><td>${this.selectedContract.contractInformation.paymentStatus}</td></tr>
                  <tr><td class="label">Bill Status</td><td>${this.selectedContract.contractInformation.billAmountStatus}</td></tr>
                  <tr><td class="label">Total Paid</td><td>${this.numberWithCommas(this.selectedContract.totalPayed)}</td></tr>
                </table>
              </div>
              
              <div class="section">
                <div class="section-title">GUARANTY INFORMATION</div>
                <table>
                  <tr><td class="label">Amount</td><td>${this.numberWithCommas(this.selectedContract.guaranty.guarantyAmount)} ${this.selectedContract.guaranty.currency}</td></tr>
                  <tr><td class="label">Status</td><td>${this.selectedContract.guaranty.status}</td></tr>
                </table>
              </div>
            </body>
          </html>
        `);
        printWindow.document.close();
        printWindow.print();
      },
      
      async downloadContractDetail() {
        try {
          const offlinePackageLoader = (await import('@/utils/offlinePackages.js')).default;
          const loaded = await offlinePackageLoader.loadContractsPackages();
          if (loaded && offlinePackageLoader.isHtml2PdfAvailable()) {
            this.generateContractDetailPDF();
          } else {
            this.$notifications.notify({
              message: 'PDF generation is not available. The html2pdf.js library is not properly loaded. Please contact your system administrator.',
              horizontalAlign: 'center',
              verticalAlign: 'top',
              type: 'warning'
            });
            // Fallback: offer to print instead
            const printFallback = await this.$bvModal.msgBoxConfirm(
              'PDF download is not available. Would you like to print the contract details instead?',
              {
                title: 'PDF Not Available',
                size: 'sm',
                buttonSize: 'sm',
                okVariant: 'primary',
                cancelVariant: 'secondary',
                okTitle: 'Print',
                cancelTitle: 'Cancel'
              }
            );
            if (printFallback) {
              this.printContractDetail();
            }
          }
        } catch (error) {
          console.error('Error loading offline packages:', error);
          this.$notifications.notify({
            message: 'Error loading PDF generation library. Please try again or contact support.',
            horizontalAlign: 'center',
            verticalAlign: 'top',
            type: 'danger'
          });
        }
      },
      
      generateContractDetailPDF() {
        const element = document.createElement('div');
        element.innerHTML = `
          <div style="font-family: 'Times New Roman', serif; margin: 25px; line-height: 1.5; color: #333; font-size: 12px;">
            <div style="text-align: center; margin-bottom: 25px; border-bottom: 3px solid #000; padding-bottom: 15px;">
              <h1>CONTRACT DETAILS</h1>
              <p>Complete contract information and current status</p>
            </div>
            
            <div style="margin: 20px 0;">
              <div style="font-weight: bold; font-size: 14px; margin-bottom: 12px; color: #000; background-color: #f0f0f0; padding: 8px; border-left: 4px solid #007bff;">PARTIES TO THE AGREEMENT</div>
              <table style="width: 100%; border-collapse: collapse; margin: 10px 0;">
                <tr><td style="padding: 6px 10px; border: 1px solid #ddd; font-weight: bold; width: 35%; background-color: #f8f9fa;">Landlord Representative</td><td style="padding: 6px 10px; border: 1px solid #ddd;">${this.getCurrentUserName()}</td></tr>
                <tr><td style="padding: 6px 10px; border: 1px solid #ddd; font-weight: bold; width: 35%; background-color: #f8f9fa;">Tenant Name</td><td style="padding: 6px 10px; border: 1px solid #ddd;">${this.selectedContract.tenantInformation.fullName}</td></tr>
                <tr><td style="padding: 6px 10px; border: 1px solid #ddd; font-weight: bold; width: 35%; background-color: #f8f9fa;">Tenant Email</td><td style="padding: 6px 10px; border: 1px solid #ddd;">${this.selectedContract.tenantInformation.email || 'Not provided'}</td></tr>
                <tr><td style="padding: 6px 10px; border: 1px solid #ddd; font-weight: bold; width: 35%; background-color: #f8f9fa;">Tenant Phone</td><td style="padding: 6px 10px; border: 1px solid #ddd;">${this.selectedContract.tenantInformation.phoneNumber}</td></tr>
                <tr><td style="padding: 6px 10px; border: 1px solid #ddd; font-weight: bold; width: 35%; background-color: #f8f9fa;">Tenant Address</td><td style="padding: 6px 10px; border: 1px solid #ddd;">${this.selectedContract.tenantInformation.address}</td></tr>
              </table>
            </div>
            
            <div style="margin: 20px 0;">
              <div style="font-weight: bold; font-size: 14px; margin-bottom: 12px; color: #000; background-color: #f0f0f0; padding: 8px; border-left: 4px solid #007bff;">PROPERTY DETAILS</div>
              <table style="width: 100%; border-collapse: collapse; margin: 10px 0;">
                <tr><td style="padding: 6px 10px; border: 1px solid #ddd; font-weight: bold; width: 35%; background-color: #f8f9fa;">Building</td><td style="padding: 6px 10px; border: 1px solid #ddd;">${this.selectedContract.buildingInformation.buildingName}</td></tr>
                <tr><td style="padding: 6px 10px; border: 1px solid #ddd; font-weight: bold; width: 35%; background-color: #f8f9fa;">Floor</td><td style="padding: 6px 10px; border: 1px solid #ddd;">${this.selectedContract.houseInformation.floor}</td></tr>
                <tr><td style="padding: 6px 10px; border: 1px solid #ddd; font-weight: bold; width: 35%; background-color: #f8f9fa;">Room</td><td style="padding: 6px 10px; border: 1px solid #ddd;">${this.selectedContract.houseInformation.roomNumber}</td></tr>
                <tr><td style="padding: 6px 10px; border: 1px solid #ddd; font-weight: bold; width: 35%; background-color: #f8f9fa;">Size</td><td style="padding: 6px 10px; border: 1px solid #ddd;">${this.selectedContract.houseInformation.size} sq.m</td></tr>
                <tr><td style="padding: 6px 10px; border: 1px solid #ddd; font-weight: bold; width: 35%; background-color: #f8f9fa;">Pricing</td><td style="padding: 6px 10px; border: 1px solid #ddd;">${this.selectedContract.houseInformation.priceOption}</td></tr>
                <tr><td style="padding: 6px 10px; border: 1px solid #ddd; font-weight: bold; width: 35%; background-color: #f8f9fa;">Currency</td><td style="padding: 6px 10px; border: 1px solid #ddd;">${this.selectedContract.guaranty.currency || 'ETB'}</td></tr>
                <tr><td style="padding: 6px 10px; border: 1px solid #ddd; font-weight: bold; width: 35%; background-color: #f8f9fa;">Rate</td><td style="padding: 6px 10px; border: 1px solid #ddd;">${this.numberWithCommas(this.selectedContract.houseInformation.price)} per ${this.selectedContract.houseInformation.priceOption === 'PerSquareMeter' ? 'sq.m' : 'month'}</td></tr>
                ${this.selectedContract.houseInformation.priceOption === 'PerSquareMeter' ? `<tr><td style="padding: 6px 10px; border: 1px solid #ddd; font-weight: bold; width: 35%; background-color: #f8f9fa;">Monthly Rent</td><td style="padding: 6px 10px; border: 1px solid #ddd;">${this.numberWithCommas(this.selectedContract.houseInformation.price * this.selectedContract.houseInformation.size)} ${this.selectedContract.guaranty.currency || 'ETB'}</td></tr>` : ''}
                <tr><td style="padding: 6px 10px; border: 1px solid #ddd; font-weight: bold; width: 35%; background-color: #f8f9fa;">House Status</td><td style="padding: 6px 10px; border: 1px solid #ddd;">${this.getStatus(this.selectedContract.houseInformation.status)}</td></tr>
              </table>
            </div>
            
            <div style="margin: 20px 0;">
              <div style="font-weight: bold; font-size: 14px; margin-bottom: 12px; color: #000; background-color: #f0f0f0; padding: 8px; border-left: 4px solid #007bff;">CONTRACT TERMS</div>
              <table style="width: 100%; border-collapse: collapse; margin: 10px 0;">
                <tr><td style="padding: 6px 10px; border: 1px solid #ddd; font-weight: bold; width: 35%; background-color: #f8f9fa;">Start Date</td><td style="padding: 6px 10px; border: 1px solid #ddd;">${this.selectedContract.contractInformation.startDate}</td></tr>
                <tr><td style="padding: 6px 10px; border: 1px solid #ddd; font-weight: bold; width: 35%; background-color: #f8f9fa;">End Date</td><td style="padding: 6px 10px; border: 1px solid #ddd;">${this.selectedContract.contractInformation.endDate}</td></tr>
                <tr><td style="padding: 6px 10px; border: 1px solid #ddd; font-weight: bold; width: 35%; background-color: #f8f9fa;">Duration</td><td style="padding: 6px 10px; border: 1px solid #ddd;">${this.calculateDuration(this.selectedContract.contractInformation.startDate, this.selectedContract.contractInformation.endDate)}</td></tr>
                <tr><td style="padding: 6px 10px; border: 1px solid #ddd; font-weight: bold; width: 35%; background-color: #f8f9fa;">Payment Period</td><td style="padding: 6px 10px; border: 1px solid #ddd;">${this.getPeriod(this.selectedContract.contractInformation.period)}</td></tr>
                <tr><td style="padding: 6px 10px; border: 1px solid #ddd; font-weight: bold; width: 35%; background-color: #f8f9fa;">Due Date</td><td style="padding: 6px 10px; border: 1px solid #ddd;">${this.selectedContract.contractInformation.dueDate} days</td></tr>
                <tr><td style="padding: 6px 10px; border: 1px solid #ddd; font-weight: bold; width: 35%; background-color: #f8f9fa;">Next Payment</td><td style="padding: 6px 10px; border: 1px solid #ddd;">${this.selectedContract.contractInformation.nextPaymentDate}</td></tr>
              </table>
            </div>
            
            <div style="margin: 20px 0;">
              <div style="font-weight: bold; font-size: 14px; margin-bottom: 12px; color: #000; background-color: #f0f0f0; padding: 8px; border-left: 4px solid #007bff;">PAYMENT STATUS</div>
              <table style="width: 100%; border-collapse: collapse; margin: 10px 0;">
                <tr><td style="padding: 6px 10px; border: 1px solid #ddd; font-weight: bold; width: 35%; background-color: #f8f9fa;">Rent Status</td><td style="padding: 6px 10px; border: 1px solid #ddd;">${this.selectedContract.contractInformation.paymentStatus}</td></tr>
                <tr><td style="padding: 6px 10px; border: 1px solid #ddd; font-weight: bold; width: 35%; background-color: #f8f9fa;">Bill Status</td><td style="padding: 6px 10px; border: 1px solid #ddd;">${this.selectedContract.contractInformation.billAmountStatus}</td></tr>
                <tr><td style="padding: 6px 10px; border: 1px solid #ddd; font-weight: bold; width: 35%; background-color: #f8f9fa;">Total Paid</td><td style="padding: 6px 10px; border: 1px solid #ddd;">${this.numberWithCommas(this.selectedContract.totalPayed)}</td></tr>
              </table>
            </div>
            
            <div style="margin: 20px 0;">
              <div style="font-weight: bold; font-size: 14px; margin-bottom: 12px; color: #000; background-color: #f0f0f0; padding: 8px; border-left: 4px solid #007bff;">GUARANTY INFORMATION</div>
              <table style="width: 100%; border-collapse: collapse; margin: 10px 0;">
                <tr><td style="padding: 6px 10px; border: 1px solid #ddd; font-weight: bold; width: 35%; background-color: #f8f9fa;">Amount</td><td style="padding: 6px 10px; border: 1px solid #ddd;">${this.numberWithCommas(this.selectedContract.guaranty.guarantyAmount)} ${this.selectedContract.guaranty.currency}</td></tr>
                <tr><td style="padding: 6px 10px; border: 1px solid #ddd; font-weight: bold; width: 35%; background-color: #f8f9fa;">Status</td><td style="padding: 6px 10px; border: 1px solid #ddd;">${this.selectedContract.guaranty.status}</td></tr>
              </table>
            </div>
          </div>
        `;
        
        const opt = {
          margin: 0.5,
          filename: `Contract_Details_${this.selectedContract.contractInformation.contractId || new Date().toISOString().split('T')[0]}.pdf`,
          image: { type: 'jpeg', quality: 0.98 },
          html2canvas: { scale: 2, useCORS: true },
          jsPDF: { unit: 'in', format: 'a4', orientation: 'portrait' }
        };
        
        html2pdf().set(opt).from(element).save();
      },
      
      printContract() {
        const printWindow = window.open('', '_blank');
        printWindow.document.write(`
          <html>
            <head>
              <title>Comprehensive Rental Agreement Contract</title>
              <style>
                body { font-family: 'Times New Roman', serif; margin: 25px; line-height: 1.5; color: #333; font-size: 12px; }
                .header { text-align: center; margin-bottom: 25px; border-bottom: 3px solid #000; padding-bottom: 15px; }
                .company-info { text-align: center; margin-bottom: 20px; font-size: 10px; color: #666; }
                .section { margin: 20px 0; page-break-inside: avoid; }
                .section-title { font-weight: bold; font-size: 14px; margin-bottom: 12px; color: #000; background-color: #f0f0f0; padding: 8px; border-left: 4px solid #007bff; }
                .subsection { margin: 10px 0; }
                .subsection-title { font-weight: bold; font-size: 12px; margin-bottom: 6px; color: #333; }
                .signature-section { margin-top: 40px; }
                .signature-box { display: inline-block; width: 45%; margin: 15px 2%; vertical-align: top; }
                .signature-line { border-bottom: 2px solid #000; height: 40px; margin: 12px 0; }
                table { width: 100%; border-collapse: collapse; margin: 10px 0; }
                td { padding: 6px 10px; border: 1px solid #ddd; vertical-align: top; }
                .label { font-weight: bold; width: 35%; background-color: #f8f9fa; }
                .important { background-color: #fff3cd; border-left: 4px solid #ffc107; padding: 10px; margin: 10px 0; }
                .terms-list { margin: 10px 0; padding-left: 20px; }
                .terms-list li { margin: 5px 0; }
                @media print { body { margin: 20px; font-size: 11px; } .section { margin: 15px 0; } }
              </style>
            </head>
            <body>
              <div class="company-info">
                <p>Building Management System | Generated on ${new Date().toLocaleDateString()}</p>
              </div>
              
              <div class="header">
                <h1>COMPREHENSIVE RENTAL AGREEMENT CONTRACT</h1>
                <p style="font-size: 14px; margin-top: 10px;">This legally binding agreement establishes the terms and conditions for the rental of residential property between the parties listed below.</p>
              </div>
              
              <div class="section">
                <div class="section-title">1. PARTIES TO THE AGREEMENT</div>
                <div class="subsection">
                  <div class="subsection-title">LANDLORD (Lessor)</div>
                  <table>
                    <tr><td class="label">Name</td><td></td></tr>
                    <tr><td class="label">Authorized Representative</td><td>${this.getCurrentUserName()}</td></tr>
                    <tr><td class="label">Role</td><td>Property Owner/Manager with full authority to lease the premises</td></tr>
                  </table>
                </div>
                
                <div class="subsection">
                  <div class="subsection-title">TENANT (Lessee)</div>
                  <table>
                    <tr><td class="label">Full Name</td><td>${this.tenantType === 'existing' ? this.getTenantName : this.addData.fullName}</td></tr>
                    ${this.tenantType === 'new' ? `
                    <tr><td class="label">Email Address</td><td>${this.addData.email || 'Not provided'}</td></tr>
                    <tr><td class="label">Phone Number</td><td>+251${this.addData.phoneNumber || 'Not provided'}</td></tr>
                    <tr><td class="label">Residential Address</td><td>${this.addData.address || 'Not provided'}</td></tr>
                    <tr><td class="label">Gender</td><td>${this.addData.sex || 'Not specified'}</td></tr>` : ''}
                    <tr><td class="label">Role</td><td>Tenant with rights and obligations as defined in this agreement</td></tr>
                  </table>
                </div>
              </div>
              
              <div class="section">
                <div class="section-title">2. PROPERTY DESCRIPTION AND SPECIFICATIONS</div>
                ${this.houseType === 'existing' ? `
                <table>
                  <tr><td class="label">Property Identification</td><td>${this.getHouseName}</td></tr>
                  <tr><td class="label">Pricing Structure</td><td>${this.getPriceOptionByValue}</td></tr>
                  <tr><td class="label">Currency</td><td>${this.getRentCurrencyType}</td></tr>
                  <tr><td class="label">Base Rate</td><td>${this.numberWithCommas(parseFloat(this.getPriceByValue.replace(/,/g, '')))} ${this.getRentCurrencyType} per ${this.getPriceOptionByValue === 'PerSquareMeter' ? 'square meter' : 'month'} (${this.vatLabel})</td></tr>
                  
                
                  <tr><td class="label">Rent Amount(Before VAT)</td><td>${this.numberWithCommas(this.existingPriceBeforeVat)} ${this.getRentCurrencyType}</td></tr>
                  <tr><td class="label">VAT Amount</td><td>${this.numberWithCommas(this.existingVatAmount)} ${this.getRentCurrencyType}</td></tr>
                  <tr><td class="label">Total Amount</td><td><strong>${this.numberWithCommas(this.existingPriceAfterVat)} ${this.getRentCurrencyType}</strong></td></tr>
                </table>` : `
                <table>
                  <tr><td class="label">Building Name</td><td>${this.getBuildingName}</td></tr>
                  <tr><td class="label">Floor Level</td><td>${this.addData.floor}</td></tr>
                  <tr><td class="label">Room/Unit Number</td><td>${this.addData.roomNumber}</td></tr>
                  <tr><td class="label">Total Area</td><td>${this.addData.size} square meters</td></tr>
                  <tr><td class="label">Pricing Method</td><td>${this.addData.priceOption}</td></tr>
                  <tr><td class="label">Currency</td><td>${this.addData.rentCurrencyType}</td></tr>
                  <tr><td class="label">Unit Rate</td><td>${this.numberWithCommas(this.addData.latest_price)} ${this.addData.rentCurrencyType} per ${this.addData.priceOption === 'PerSquareMeter' ? 'square meter' : 'month'}</td></tr>
                  ${this.addData.priceOption === 'PerSquareMeter' ? `<tr><td class="label">Total Monthly Rent</td><td>${this.numberWithCommas(this.computedPrice)} ${this.addData.rentCurrencyType}</td></tr>` : ''}
                  <tr><td class="label">VAT (15%)</td><td>${this.vatLabel}</td></tr>
                  <tr><td class="label">Price Before VAT</td><td>${this.numberWithCommas(this.newPriceBeforeVat)} ${this.addData.rentCurrencyType}</td></tr>
                  <tr><td class="label">VAT Amount</td><td>${this.numberWithCommas(this.newVatAmount)} ${this.addData.rentCurrencyType}</td></tr>
                  <tr><td class="label">Price After VAT</td><td><strong>${this.numberWithCommas(this.newPriceAfterVat)} ${this.addData.rentCurrencyType}</strong></td></tr>
                  ${this.addData.description ? `<tr><td class="label">Additional Notes</td><td>${this.addData.description}</td></tr>` : ''}
                </table>`}
              </div>
              
              <div class="section">
                <div class="section-title">3. LEASE TERMS AND CONDITIONS</div>
                
                <div class="subsection">
                  <div class="subsection-title">3.1 Lease Duration</div>
                  <table>
                    <tr><td class="label">Commencement Date</td><td>${this.addData.startDate}</td></tr>
                    <tr><td class="label">Termination Date</td><td>${this.addData.endDate}</td></tr>
                    <tr><td class="label">Total Lease Period</td><td>${this.calculateDuration(this.addData.startDate, this.addData.endDate)}</td></tr>
           
                  </table>
                </div>

                
                <div class="subsection">
                  <div class="subsection-title">3.2 Payment Terms</div>
                  <table>
                    <tr><td class="label">Payment Frequency</td><td>Every ${this.addData.period} ${this.addData.periodtwo === 1 ? 'month(s)' : 'year(s)'}</td></tr>
                    <tr><td class="label">Payment Due Date</td><td>${this.addData.dueDate} days grace period</td></tr>
                    <tr><td class="label">Advance Payment Period</td><td>${this.addData.advancePeriod} ${this.addData.advancePeriodtwo === 1 ? 'month(s)' : 'year(s)'}</td></tr>
                    <tr><td class="label">Advance Before VAT</td><td>${this.addData.initialPayment > 0 ? this.numberWithCommas(this.advanceBeforeVat) + ' ' + this.advanceCurrency : '-'}</td></tr>
                    <tr><td class="label">Advance VAT Amount</td><td>${this.addData.initialPayment > 0 ? this.numberWithCommas(this.advanceVatAmount) + ' ' + this.advanceCurrency : '-'}</td></tr>
                    <tr><td class="label"><strong>Advance After VAT</strong></td><td>${this.addData.initialPayment > 0 ? '<strong>' + this.numberWithCommas(this.advanceAfterVat) + ' ' + this.advanceCurrency + '</strong>' : '-'}</td></tr>
                    <tr><td class="label">Security Deposit</td><td>${this.addData.guaranteedMoney > 0 ? this.numberWithCommas(this.addData.guaranteedMoney) + ' ' + this.advanceCurrency : '0'} (Refundable upon satisfactory completion of lease)</td></tr>
                  </table>
                </div>

            
                  </table>
                </div>
                
                <div class="subsection">
                  <div class="subsection-title">3.3 Penalty and Late Payment Policy</div>
                  <table>
                    <tr><td class="label">Penalty Structure</td><td>${this.addData.penaltyOption === 'noPenalty' ? 'No penalty charges apply for late payments' : this.getPenaltyDescription()}</td></tr>
                    ${this.addData.penaltyCondition && this.addData.penaltyOption !== 'noPenalty' ? `<tr><td class="label">Penalty Application</td><td>${this.addData.penaltyCondition} penalty structure</td></tr>` : ''}
                  </table>
                </div>
                
                <div class="subsection">
                  <div class="subsection-title">3.4 Tax Information</div>
                  
                </div>
                  <table>
                    <tr><td class="label">Value Added Tax (VAT)</td><td>${this.vatLabel}</td></tr>
                    <tr><td class="label">Withholding Tax</td><td>${this.addData.withHolding === 'Yes' ? '3% withholding tax applicable as per Ethiopian tax law' : '3% withholding tax not applicable'}</td></tr>
                  </table>
                </div>
              </div>
              
              ${this.hasUtilities() ? `
              <div class="section">
                <div class="section-title">4. UTILITIES AND SERVICES</div>
                <div class="important">
                  <strong>Important:</strong> The following utility services are included with this rental agreement and are subject to the terms specified below.
                </div>
                <table>
                  ${this.showElectricReading() ? `<tr><td class="label">Electricity Service</td><td>Metered service - Initial reading: ${this.addData.electricReading} KWH. Tenant responsible for consumption above base reading.</td></tr>` : ''}
                  ${this.showWaterReading() ? `<tr><td class="label">Water Service</td><td>Metered service - Initial reading: ${this.addData.waterReading} cubic meters. Tenant responsible for consumption above base reading.</td></tr>` : ''}
                  ${this.addData.firstBillPaymentStarts ? `<tr><td class="label">Utility Billing Commencement</td><td>First utility bill payment due on: ${this.addData.firstBillPaymentStarts}</td></tr>` : ''}
                </table>
              </div>` : ''}
              
              <div class="section">
                <div class="section-title">5. PAYMENT METHOD AND BANKING INFORMATION</div>
                <div class="important">
                  <strong>Payment Method:</strong> All rental payments must be made through Tsehay Bank using any of the following convenient channels:
                </div>
                <table>
                  <tr><td class="label">Mobile Banking</td><td>Use Tsehay Bank mobile app for instant payments</td></tr>
                  <tr><td class="label">Internet Banking</td><td>Access online banking portal for secure transactions</td></tr>
                  <tr><td class="label">USSD Banking</td><td>Dial USSD code for quick mobile payments</td></tr>
                  <tr><td class="label">Branch Services</td><td>Visit any Tsehay Bank branch for in-person payments</td></tr>
                  <tr><td class="label">ATM Services</td><td>Use Tsehay Bank ATMs for payment transactions</td></tr>
                  <tr><td class="label">Payment Reference</td><td>A unique payment ID will be provided to the tenant after contract establishment. This unique ID must be used for all rental payments to ensure proper account crediting and payment tracking.</td></tr>
                </table>
              </div>
              
              <div class="section">
                <div class="section-title">6. LEGAL PROVISIONS AND RESPONSIBILITIES</div>
                
                <div class="subsection">
                  <div class="subsection-title">6.1 Tenant Responsibilities</div>
                  <ul class="terms-list">
                    <li>Maintain the property in good condition and report any damages immediately</li>
                    <li>Pay rent and utilities on time as specified in this agreement</li>
                    <li>Comply with all building rules and local regulations</li>
                    <li>Not sublease the property without written consent from the landlord</li>
                    <li>Allow reasonable access for inspections and maintenance</li>
                  </ul>
                </div>
                
                <div class="subsection">
                  <div class="subsection-title">6.2 Landlord Responsibilities</div>
                  <ul class="terms-list">
                    <li>Provide the property in habitable condition</li>
                    <li>Maintain structural integrity and essential services</li>
                    <li>Respect tenant's right to quiet enjoyment of the property</li>
                    <li>Return security deposit within 30 days of lease termination (less any legitimate deductions)</li>
                  </ul>
                </div>
                
                <div class="subsection">
                  <div class="subsection-title">6.3 Legal Framework</div>
                  <table>
                    <tr><td class="label">Governing Law</td><td>This agreement is governed by and construed in accordance with the laws of the Federal Democratic Republic of Ethiopia</td></tr>
                    <tr><td class="label">Jurisdiction</td><td>Any disputes arising from this agreement shall be resolved in Ethiopian courts</td></tr>
                    <tr><td class="label">Document Attachment</td><td>${this.file ? `Additional document attached: ${this.file.name}` : 'No additional supporting documents attached to this agreement'}</td></tr>
                  </table>
                </div>
              </div>
              
              <div class="important">
                <strong>ACKNOWLEDGMENT:</strong> Both parties acknowledge that they have read, understood, and agree to be bound by all terms and conditions set forth in this comprehensive rental agreement. This agreement represents the complete understanding between the parties and supersedes all prior negotiations, representations, or agreements relating to the subject matter.
              </div>
              
              <div class="signature-section">
                <div class="section-title">7. SIGNATURES AND EXECUTION</div>
                <p style="margin-bottom: 20px;">By signing below, both parties agree to the terms and conditions outlined in this rental agreement:</p>
                
                <div class="signature-box">
                  <p><strong>LANDLORD/AUTHORIZED REPRESENTATIVE:</strong></p>
                  <div class="signature-line"></div>
                  <p>Signature: _________________________</p>
                  <p>Name: ${this.getCurrentUserName()}</p>
                  <p>Date: _______________</p>
                  <p>Title: Property Manager</p>
                </div>
                
                <div class="signature-box">
                  <p><strong>TENANT:</strong></p>
                  <div class="signature-line"></div>
                  <p>Signature: _________________________</p>
                  <p>Name: ${this.tenantType === 'existing' ? this.getTenantName : this.addData.fullName}</p>
                  <p>Date: _______________</p>
                  <p>ID/Passport: _______________</p>
                </div>
              </div>
              
              <div style="margin-top: 30px; text-align: center; font-size: 10px; color: #666;">
                <p>This document was generated electronically by the Tsehay bank Building Management System on ${new Date().toLocaleString()}</p>
              </div>
            </body>
          </html>
        `);
        printWindow.document.close();
        printWindow.print();
      },
      
      calculateLeaseDuration() {
        if (this.addData.startDate && this.addData.endDate) {
          const start = new Date(this.addData.startDate);
          const end = new Date(this.addData.endDate);
          const diffTime = Math.abs(end - start);
          return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        }
        return 'Not specified';
      },
      
      async downloadContract() {
        try {
          const offlinePackageLoader = (await import('@/utils/offlinePackages.js')).default;
          const loaded = await offlinePackageLoader.loadContractsPackages();
          if (loaded && offlinePackageLoader.isHtml2PdfAvailable()) {
            this.generatePDF();
          } else {
            this.$notifications.notify({
              message: 'PDF generation is not available. The html2pdf.js library is not properly loaded. Please contact your system administrator.',
              horizontalAlign: 'center',
              verticalAlign: 'top',
              type: 'warning'
            });
            // Fallback: offer to print instead
            const printFallback = await this.$bvModal.msgBoxConfirm(
              'PDF download is not available. Would you like to print the contract instead?',
              {
                title: 'PDF Not Available',
                size: 'sm',
                buttonSize: 'sm',
                okVariant: 'primary',
                cancelVariant: 'secondary',
                okTitle: 'Print',
                cancelTitle: 'Cancel'
              }
            );
            if (printFallback) {
              this.printContract();
            }
          }
        } catch (error) {
          console.error('Error loading offline packages:', error);
          this.$notifications.notify({
            message: 'Error loading PDF generation library. Please try again or contact support.',
            horizontalAlign: 'center',
            verticalAlign: 'top',
            type: 'danger'
          });
        }
      },
      
      generatePDF() {
        const element = document.createElement('div');
        element.innerHTML = this.getPrintHTML().replace('<!DOCTYPE html><html><head>', '').replace('</head><body>', '').replace('</body></html>', '');
        
        const opt = {
          margin: 0.5,
          filename: `Rental_Agreement_${this.addData.startDate || new Date().toISOString().split('T')[0]}.pdf`,
          image: { type: 'jpeg', quality: 0.98 },
          html2canvas: { scale: 2, useCORS: true },
          jsPDF: { unit: 'in', format: 'a4', orientation: 'portrait' }
        };
        
        html2pdf().set(opt).from(element).save();
      },
      
      // API helper methods
      async makeApiRequest(method, url, data = null, config = {}) {
        try {
          const response = await this.$http[method](url, data, {
            timeout: 30000,
            ...config
          });
          return { success: true, data: response.data, status: response.status };
        } catch (error) {
          console.error(`API ${method.toUpperCase()} ${url} error:`, error);
          
          let errorMessage = 'An unexpected error occurred';
          
          if (error.response) {
            const status = error.response.status;
            const responseData = error.response.data;
            
            switch (status) {
              case 400:
                errorMessage = (responseData && responseData.message) || 'Invalid request data';
                break;
              case 401:
                errorMessage = 'Authentication required';
                break;
              case 403:
                errorMessage = 'Access denied';
                break;
              case 404:
                errorMessage = 'Resource not found';
                break;
              case 413:
                errorMessage = 'File too large';
                break;
              case 422:
                errorMessage = (responseData && responseData.message) || 'Validation failed';
                break;
              case 500:
                errorMessage = 'Server error. Please try again later';
                break;
              default:
                errorMessage = (responseData && responseData.message) || `Error ${status}`;
            }
          } else if (error.request) {
            errorMessage = 'Network error. Please check your connection';
          } else if (error.code === 'ECONNABORTED') {
            errorMessage = 'Request timeout. Please try again';
          }
          
          return { success: false, error: errorMessage, status: error.response && error.response.status };
        }
      },
      
      showNotification(message, type = 'info') {
        this.$notifications.notify({
          message,
          horizontalAlign: 'center',
          verticalAlign: 'top',
          type
        });
      },
      
      updateEditInitialPayment() {
        if (this.editData.advancePeriod && this.editData.advancePeriodtwo && this.editData.monthlyPrice) {
          const multiplier = this.editData.advancePeriodtwo === 1 ? this.editData.advancePeriod : this.editData.advancePeriod * 12;
          this.editData.initialPayment = this.editData.monthlyPrice * multiplier;
        }
      },
      
      // File handling methods
      handleFileChange() {
        this.fileError = '';
        if (!this.file) {
          this.base64 = null;
          return;
        }
        
        // Validate file size (max 10MB)
        const maxSize = 10 * 1024 * 1024;
        if (this.file.size > maxSize) {
          this.fileError = 'File size must be less than 10MB';
          this.file = null;
          return;
        }
        
        // Validate file type
        const allowedTypes = ['application/pdf', 'image/jpeg', 'image/jpg', 'image/png', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'];
        if (!allowedTypes.includes(this.file.type)) {
          this.fileError = 'Please select a valid file type (PDF, JPG, PNG, DOC, DOCX)';
          this.file = null;
          return;
        }
        
        this.createBase64Image(this.file);
      },
      
      createBase64Image(file) {
        const reader = new FileReader();
        reader.onload = (event) => {
          this.base64 = event.target.result.split(',')[1]; // Remove data:type;base64, prefix
        };
        reader.onerror = () => {
          this.fileError = 'Error reading file';
          this.file = null;
          this.base64 = null;
        };
        reader.readAsDataURL(file);
      },
      
      
      
      async submitEditForm() {
        this.isUploading = true;
        this.uploadProgress = 0;
        
        try {
          const formData = {
            ...this.editData,
            attachedFile: this.base64,
            fileName: this.file ? this.file.name : null,
            fileType: this.file ? this.file.type : null
          };
          
          const result = await this.makeApiRequest('put', `contracts/update/${this.editData.contractId}`, formData, {
            onUploadProgress: (progressEvent) => {
              this.uploadProgress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
            }
          });
          
          if (result.success) {
            this.showNotification('Contract updated successfully!', 'success');
            this.clearData();
            this.$bvModal.hide('modal-top-EditContract');
            await this.getContractByOwnerID();
          } else {
            this.showNotification(result.error, 'danger');
          }
        } catch (error) {
          this.showNotification('Unexpected error occurred', 'danger');
        } finally {
          this.isUploading = false;
          this.uploadProgress = 0;
        }
      },
      
      clearData() {
        // Reset all form data
        this.addData = {
          floor: null,
          roomNumber: "",
          size: null,
          buildingId: null,
          latest_price: null,
          priceOption: "",
          rentCurrencyType: "",
          description: "",
          fullName: "",
          email: "",
          sex: "",
          phoneNumber: "",
          address: "",
          firstBillPaymentStarts: "",
          startDate: "",
          endDate: "",
          dueDate: 0,
          payedAmount: 0,
          tenantId: null,
          houseId: null,
          period: null,
          periodtwo: 1,
          initialPayment: null,
          guaranteedMoney: null,
          paymentRule: "",
          attachedFile: "",
          registeredBy: sessionStorage.getItem("userID"),
          electricReading: null,
          waterReading: null,
          penaltyOption: "",
          penaltyCondition: "",
          dateRangeForPenaltyIncrement: "",
          dateRangeForUserInput: null,
          penaltyAmount: "",
          penaltyAmountPercent: null,
          penaltyAmountFixed: null,
          withHolding: "",
          advancePeriod: null,
          advancePeriodtwo: 1
        };
        
        // Reset file data
        this.file = null;
        this.base64 = null;
        this.fileError = '';
        this.uploadProgress = 0;
        this.isUploading = false;
        
        // Reset step
        this.currentStep = 1;
        this.houseType = 'existing';
        this.tenantType = 'existing';
        this.selectedOption = 'Yes';
        
        // Reset error messages
        this.errorMessage = '';
        this.errorMessage1 = '';
      },
      
      // Additional API methods
      async getContractByOwnerID() {
        this.spinner = true;
        try {
          const result = await this.makeApiRequest('get', `contracts/owner/${sessionStorage.getItem('userID')}?status=${this.contractStatus}&dateFrom=${this.DateFrom}&dateTo=${this.DateTo}`);
          
          if (result.success) {
            this.items = result.data || [];
            this.totalRows = this.items.length;
            this.disabledData = this.contractStatus === 'Terminated';
          } else {
            this.showNotification(result.error, 'warning');
            this.items = [];
          }
        } catch (error) {
          this.showNotification('Failed to load contracts', 'danger');
          this.items = [];
        } finally {
          this.spinner = false;
        }
      },
      
      async downloadFile(contractId) {
        try {
          const result = await this.makeApiRequest('get', `contracts/${contractId}/download`, null, {
            responseType: 'blob'
          });
          
          if (result.success) {
            const blob = new Blob([result.data]);
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = `contract_${contractId}_document.pdf`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
          } else {
            this.showNotification('Failed to download file', 'danger');
          }
        } catch (error) {
          this.showNotification('Error downloading file', 'danger');
        }
      },
      
      async getModules() {
        try {
          const result = await this.makeApiRequest('get', 'user/modules');
          if (result.success && result.data) {
            this.modulePermission = result.data.contracts || this.modulePermission;
          }
        } catch (error) {
          console.warn('Failed to load module permissions');
        }
      },
      
      async getBuildings() {
        try {
          const result = await this.makeApiRequest('get', 'buildings/active');
          if (result.success) {
            this.buildingOptions = result.data.map(building => ({
              value: building.id,
              text: building.name
            }));
          }
        } catch (error) {
          console.warn('Failed to load buildings');
        }
      },
      
      async getHouseByOwnerID() {
        try {
          const result = await this.makeApiRequest('get', 'houses/available');
          if (result.success) {
            this.houseOptions = result.data.map(house => ({
              value: house.id,
              text: `${house.building.name} - Floor ${house.floor} - Room ${house.roomNumber}`,
              price: house.price,
              priceOption: house.priceOption,
              rentCurrencyType: house.rentCurrencyType,
              includeVat: house.includeVat,
              size: house.size
            }));
          }
        } catch (error) {
          console.warn('Failed to load houses');
        }
      },
      
      async getTenantByOwnerID() {
        try {
          const result = await this.makeApiRequest('get', 'tenants/active');
          if (result.success) {
            this.tenantOptions = result.data.map(tenant => ({
              value: tenant.id,
              text: tenant.fullName
            }));
          }
        } catch (error) {
          console.warn('Failed to load tenants');
        }
      },
      
      getPrintHTML() {
        return `<!DOCTYPE html>
<html>
<head>
  <title>Comprehensive Rental Agreement Contract</title>
  <meta charset="utf-8">
  <style>
    @page { size: A4; margin: 20mm; }
    body { font-family: 'Times New Roman', serif; margin: 25px; line-height: 1.5; color: #333; font-size: 12px; }
    .header { text-align: center; margin-bottom: 25px; border-bottom: 3px solid #000; padding-bottom: 15px; }
    .company-info { text-align: center; margin-bottom: 20px; font-size: 10px; color: #666; }
    .section { margin: 20px 0; page-break-inside: avoid; }
    .section-title { font-weight: bold; font-size: 14px; margin-bottom: 12px; color: #000; background-color: #f0f0f0; padding: 8px; border-left: 4px solid #007bff; }
    .subsection { margin: 10px 0; }
    .subsection-title { font-weight: bold; font-size: 12px; margin-bottom: 6px; color: #333; }
    .signature-section { margin-top: 40px; }
    .signature-box { display: inline-block; width: 45%; margin: 15px 2%; vertical-align: top; }
    .signature-line { border-bottom: 2px solid #000; height: 40px; margin: 12px 0; }
    table { width: 100%; border-collapse: collapse; margin: 10px 0; }
    td { padding: 6px 10px; border: 1px solid #ddd; vertical-align: top; }
    .label { font-weight: bold; width: 35%; background-color: #f8f9fa; }
    .important { background-color: #fff3cd; border-left: 4px solid #ffc107; padding: 10px; margin: 10px 0; }
    .terms-list { margin: 10px 0; padding-left: 20px; }
    .terms-list li { margin: 5px 0; }
  </style>
</head>
<body>
  <div class="company-info">
    <p>Building Management System | Generated on ${new Date().toLocaleDateString()}</p>
  </div>
  
  <div class="header">
    <h1>COMPREHENSIVE RENTAL AGREEMENT CONTRACT</h1>
    <p style="font-size: 14px; margin-top: 10px;">This legally binding agreement establishes the terms and conditions for the rental of residential property between the parties listed below.</p>
  </div>
  
  <div class="section">
    <div class="section-title">1. PARTIES TO THE AGREEMENT</div>
    <div class="subsection">
      <div class="subsection-title">LANDLORD (Lessor)</div>
      <table>
        <tr><td class="label">Name</td><td></td></tr>
        <tr><td class="label">Authorized Representative</td><td>${this.getCurrentUserName()}</td></tr>
        <tr><td class="label">Role</td><td>Property Owner/Manager with full authority to lease the premises</td></tr>
      </table>
    </div>
    
    <div class="subsection">
      <div class="subsection-title">TENANT (Lessee)</div>
      <table>
        <tr><td class="label">Full Name</td><td>${this.tenantType === 'existing' ? this.getTenantName : this.addData.fullName}</td></tr>
        ${this.tenantType === 'new' ? `
        <tr><td class="label">Email Address</td><td>${this.addData.email || 'Not provided'}</td></tr>
        <tr><td class="label">Phone Number</td><td>+251${this.addData.phoneNumber || 'Not provided'}</td></tr>
        <tr><td class="label">Residential Address</td><td>${this.addData.address || 'Not provided'}</td></tr>
        <tr><td class="label">Gender</td><td>${this.addData.sex || 'Not specified'}</td></tr>` : ''}
        <tr><td class="label">Role</td><td>Tenant with rights and obligations as defined in this agreement</td></tr>
      </table>
    </div>
  </div>
  
  <div class="section">
    <div class="section-title">2. PROPERTY DESCRIPTION AND SPECIFICATIONS</div>
    ${this.houseType === 'existing' ? `
    <table>
      <tr><td class="label">Property Identification</td><td>${this.getHouseName}</td></tr>
      <tr><td class="label">Pricing Structure</td><td>${this.getPriceOptionByValue}</td></tr>
      <tr><td class="label">Currency</td><td>${this.getRentCurrencyType}</td></tr>
      <tr><td class="label">Base Rate</td><td>${this.numberWithCommas(parseFloat(this.getPriceByValue.replace(/,/g, '')))} ${this.getRentCurrencyType} per ${this.getPriceOptionByValue === 'PerSquareMeter' ? 'square meter' : 'month'}</td></tr>
      ${this.getPriceOptionByValue === 'PerSquareMeter' ? `<tr><td class="label">Total Monthly Rent</td><td>${this.computedPriceExist} ${this.getRentCurrencyType}</td></tr>` : ''}
    </table>` : `
    <table>
      <tr><td class="label">Building Name</td><td>${this.getBuildingName}</td></tr>
      <tr><td class="label">Floor Level</td><td>${this.addData.floor}</td></tr>
      <tr><td class="label">Room/Unit Number</td><td>${this.addData.roomNumber}</td></tr>
      <tr><td class="label">Total Area</td><td>${this.addData.size} square meters</td></tr>
      <tr><td class="label">Pricing Method</td><td>${this.addData.priceOption}</td></tr>
      <tr><td class="label">Currency</td><td>${this.addData.rentCurrencyType}</td></tr>
      <tr><td class="label">Unit Rate</td><td>${this.numberWithCommas(this.addData.latest_price)} ${this.addData.rentCurrencyType} per ${this.addData.priceOption === 'PerSquareMeter' ? 'square meter' : 'month'}</td></tr>
      ${this.addData.priceOption === 'PerSquareMeter' ? `<tr><td class="label">Total Monthly Rent</td><td>${this.numberWithCommas(this.computedPrice)} ${this.addData.rentCurrencyType}</td></tr>` : ''}
      ${this.addData.description ? `<tr><td class="label">Additional Notes</td><td>${this.addData.description}</td></tr>` : ''}
    </table>`}
  </div>
  
  <div class="section">
    <div class="section-title">3. LEASE TERMS AND CONDITIONS</div>
    
    <div class="subsection">
      <div class="subsection-title">3.1 Lease Duration</div>
      <table>
        <tr><td class="label">Commencement Date</td><td>${this.addData.startDate}</td></tr>
        <tr><td class="label">Termination Date</td><td>${this.addData.endDate}</td></tr>
        <tr><td class="label">Total Lease Period</td><td>${this.calculateDuration()} days</td></tr>
      </table>
    </div>
    
    <div class="subsection">
      <div class="subsection-title">3.2 Payment Terms</div>
      <table>
        <tr><td class="label">Payment Frequency</td><td>Every ${this.addData.period} ${this.addData.periodtwo === 1 ? 'month(s)' : 'year(s)'}</td></tr>
        <tr><td class="label">Payment Due Date</td><td>Within ${this.addData.dueDate} days of each payment period</td></tr>
        <tr><td class="label">Advance Payment</td><td>${this.numberWithCommas(this.addData.initialPayment)} ${this.addData.rentCurrencyType}</td></tr>
        <tr><td class="label">Advance Payment Period</td><td>${this.addData.advancePeriod} ${this.addData.advancePeriodtwo === 1 ? 'month(s)' : 'year(s)'} in advance</td></tr>
        <tr><td class="label">Security Deposit</td><td>${this.numberWithCommas(this.addData.guaranteedMoney)} ${this.addData.rentCurrencyType} (Refundable upon satisfactory completion of lease)</td></tr>
      </table>
    </div>
    
    <div class="subsection">
      <div class="subsection-title">3.3 Penalty and Late Payment Policy</div>
      <table>
        <tr><td class="label">Penalty Structure</td><td>${this.addData.penaltyOption === 'noPenalty' ? 'No penalty charges apply for late payments' : this.getPenaltyDescription()}</td></tr>
        ${this.addData.penaltyCondition && this.addData.penaltyOption !== 'noPenalty' ? `<tr><td class="label">Penalty Application</td><td>${this.addData.penaltyCondition} penalty structure</td></tr>` : ''}
      </table>
    </div>
    
    <div class="subsection">
      <div class="subsection-title">3.4 Tax Information</div>
      <table>
        <tr><td class="label">Value Added Tax (VAT)</td><td>${this.selectedOption === 'Yes' ? '15% VAT included in rental amount' : '15% VAT not included - tenant responsible if applicable'}</td></tr>
        <tr><td class="label">Withholding Tax</td><td>${this.addData.withHolding === 'Yes' ? '3% withholding tax applicable as per Ethiopian tax law' : '3% withholding tax not applicable'}</td></tr>
      </table>
    </div>
  </div>
  
  ${this.hasUtilities() ? `
  <div class="section">
    <div class="section-title">4. UTILITIES AND SERVICES</div>
    <div class="important">
      <strong>Important:</strong> The following utility services are included with this rental agreement and are subject to the terms specified below.
    </div>
    <table>
      ${this.showElectricReading() ? `<tr><td class="label">Electricity Service</td><td>Metered service - Initial reading: ${this.addData.electricReading} KWH. Tenant responsible for consumption above base reading.</td></tr>` : ''}
      ${this.showWaterReading() ? `<tr><td class="label">Water Service</td><td>Metered service - Initial reading: ${this.addData.waterReading} cubic meters. Tenant responsible for consumption above base reading.</td></tr>` : ''}
      ${this.addData.firstBillPaymentStarts ? `<tr><td class="label">Utility Billing Commencement</td><td>First utility bill payment due on: ${this.addData.firstBillPaymentStarts}</td></tr>` : ''}
    </table>
  </div>` : ''}
  
  <div class="section">
    <div class="section-title">5. PAYMENT METHOD AND BANKING INFORMATION</div>
    <div class="important">
      <strong>Payment Method:</strong> All rental payments must be made through Tsehay Bank using any of the following convenient channels:
    </div>
    <table>
      <tr><td class="label">Mobile Banking</td><td>Use Tsehay Bank mobile app for instant payments</td></tr>
      <tr><td class="label">Internet Banking</td><td>Access online banking portal for secure transactions</td></tr>
      <tr><td class="label">USSD Banking</td><td>Dial USSD code for quick mobile payments</td></tr>
      <tr><td class="label">Branch Services</td><td>Visit any Tsehay Bank branch for in-person payments</td></tr>
      <tr><td class="label">ATM Services</td><td>Use Tsehay Bank ATMs for payment transactions</td></tr>
      <tr><td class="label">Payment Reference</td><td>A unique payment ID will be provided to the tenant after contract establishment. This unique ID must be used for all rental payments to ensure proper account crediting and payment tracking.</td></tr>
    </table>
  </div>
  
  <div class="section">
    <div class="section-title">6. LEGAL PROVISIONS AND RESPONSIBILITIES</div>
    
    <div class="subsection">
      <div class="subsection-title">6.1 Tenant Responsibilities</div>
      <ul class="terms-list">
        <li>Maintain the property in good condition and report any damages immediately</li>
        <li>Pay rent and utilities on time as specified in this agreement</li>
        <li>Comply with all building rules and local regulations</li>
        <li>Not sublease the property without written consent from the landlord</li>
        <li>Allow reasonable access for inspections and maintenance</li>
      </ul>
    </div>
    
    <div class="subsection">
      <div class="subsection-title">6.2 Landlord Responsibilities</div>
      <ul class="terms-list">
        <li>Provide the property in habitable condition</li>
        <li>Maintain structural integrity and essential services</li>
        <li>Respect tenant's right to quiet enjoyment of the property</li>
        <li>Return security deposit within 30 days of lease termination (less any legitimate deductions)</li>
      </ul>
    </div>
    
    <div class="subsection">
      <div class="subsection-title">6.3 Legal Framework</div>
      <table>
        <tr><td class="label">Governing Law</td><td>This agreement is governed by and construed in accordance with the laws of the Federal Democratic Republic of Ethiopia</td></tr>
        <tr><td class="label">Jurisdiction</td><td>Any disputes arising from this agreement shall be resolved in Ethiopian courts</td></tr>
        <tr><td class="label">Document Attachment</td><td>${this.file ? `Additional document attached: ${this.file.name}` : 'No additional supporting documents attached to this agreement'}</td></tr>
      </table>
    </div>
  </div>
  
  <div class="important">
    <strong>ACKNOWLEDGMENT:</strong> Both parties acknowledge that they have read, understood, and agree to be bound by all terms and conditions set forth in this comprehensive rental agreement. This agreement represents the complete understanding between the parties and supersedes all prior negotiations, representations, or agreements relating to the subject matter.
  </div>
  
  <div class="signature-section">
    <div class="section-title">7. SIGNATURES AND EXECUTION</div>
    <p style="margin-bottom: 20px;">By signing below, both parties agree to the terms and conditions outlined in this rental agreement:</p>
    
    <div class="signature-box">
      <p><strong>LANDLORD/AUTHORIZED REPRESENTATIVE:</strong></p>
      <div class="signature-line"></div>
      <p>Signature: _________________________</p>
      <p>Name: ${this.getCurrentUserName()}</p>
      <p>Date: _______________</p>
      <p>Title: Property Manager</p>
    </div>
    
    <div class="signature-box">
      <p><strong>TENANT:</strong></p>
      <div class="signature-line"></div>
      <p>Signature: _________________________</p>
      <p>Name: ${this.tenantType === 'existing' ? this.getTenantName : this.addData.fullName}</p>
      <p>Date: _______________</p>
      <p>ID/Passport: _______________</p>
    </div>
  </div>
  
  <div style="margin-top: 30px; text-align: center; font-size: 10px; color: #666;">
    <p>This document was generated electronically by the Tsehay Bank Building Management System on ${new Date().toLocaleString()}</p>
  </div>
</body>
</html>`;
      },
      
      getPrintableHTML() {
        return `
          <!DOCTYPE html>
          <html>
            <head>
              <title>Comprehensive Rental Agreement Contract</title>
              <meta charset="utf-8">
              <style>
                @page {
                  size: A4;
                  margin: 20mm;
                }
                * {
                  box-sizing: border-box;
                }
                body { 
                  font-family: 'Times New Roman', serif; 
                  margin: 0;
                  padding: 0;
                  line-height: 1.5; 
                  color: #333; 
                  font-size: 12px;
                  background: white;
                }
                .page-container {
                  width: 100%;
                  max-width: 210mm;
                  margin: 0 auto;
                  background: white;
                  padding: 20px;
                }
                .header { 
                  text-align: center; 
                  margin-bottom: 25px; 
                  border-bottom: 3px solid #000; 
                  padding-bottom: 15px; 
                }
                .company-info { 
                  text-align: center; 
                  margin-bottom: 20px; 
                  font-size: 10px; 
                  color: #666; 
                }
                .section { 
                  margin: 20px 0; 
                  page-break-inside: avoid; 
                }
                .section-title { 
                  font-weight: bold; 
                  font-size: 14px; 
                  margin-bottom: 12px; 
                  color: #000; 
                  background-color: #f0f0f0; 
                  padding: 8px; 
                  border-left: 4px solid #007bff; 
                }
                .subsection { 
                  margin: 10px 0; 
                }
                .subsection-title { 
                  font-weight: bold; 
                  font-size: 12px; 
                  margin-bottom: 6px; 
                  color: #333; 
                }
                .signature-section { 
                  margin-top: 40px; 
                  page-break-inside: avoid;
                }
                .signature-box { 
                  display: inline-block; 
                  width: 45%; 
                  margin: 15px 2%; 
                  vertical-align: top; 
                }
                .signature-line { 
                  border-bottom: 2px solid #000; 
                  height: 40px; 
                  margin: 12px 0; 
                }
                table { 
                  width: 100%; 
                  border-collapse: collapse; 
                  margin: 10px 0; 
                }
                td { 
                  padding: 6px 10px; 
                  border: 1px solid #ddd; 
                  vertical-align: top; 
                  font-size: 11px;
                }
                .label { 
                  font-weight: bold; 
                  width: 35%; 
                  background-color: #f8f9fa; 
                }
                .important { 
                  background-color: #fff3cd; 
                  border-left: 4px solid #ffc107; 
                  padding: 10px; 
                  margin: 10px 0; 
                }
                .terms-list { 
                  margin: 10px 0; 
                  padding-left: 20px; 
                }
                .terms-list li { 
                  margin: 5px 0; 
                }
                h1 {
                  font-size: 18px;
                  margin: 10px 0;
                }
                h2 {
                  font-size: 16px;
                  margin: 8px 0;
                }
                p {
                  margin: 6px 0;
                }
                @media print {
                  body { 
                    margin: 0;
                    padding: 0;
                    font-size: 11px; 
                  }
                  .page-container {
                    padding: 15px;
                  }
                  .section { 
                    margin: 15px 0; 
                  }
                  .signature-section {
                    page-break-inside: avoid;
                  }
                }
              </style>
            </head>
            <body>
              <div class="page-container">
                <div class="company-info">
                  <p>Building Management System | Generated on ${new Date().toLocaleDateString()}</p>
                </div>
                
                <div class="header">
                  <h1>COMPREHENSIVE RENTAL AGREEMENT CONTRACT</h1>
                  <p style="font-size: 14px; margin-top: 10px;">This legally binding agreement establishes the terms and conditions for the rental of residential property between the parties listed below.</p>
                </div>
                
                <div class="section">
                  <div class="section-title">1. PARTIES TO THE AGREEMENT</div>
                  <div class="subsection">
                    <div class="subsection-title">LANDLORD (Lessor)</div>
                    <table>
                      <tr><td class="label">Name</td><td></td></tr>
                      <tr><td class="label">Authorized Representative</td><td>${this.getCurrentUserName()}</td></tr>
                      <tr><td class="label">Role</td><td>Property Owner/Manager with full authority to lease the premises</td></tr>
                    </table>
                  </div>
                  
                  <div class="subsection">
                    <div class="subsection-title">TENANT (Lessee)</div>
                    <table>
                      <tr><td class="label">Full Name</td><td>${this.tenantType === 'existing' ? this.getTenantName : this.addData.fullName}</td></tr>
                      ${this.tenantType === 'new' ? `
                      <tr><td class="label">Email Address</td><td>${this.addData.email || 'Not provided'}</td></tr>
                      <tr><td class="label">Phone Number</td><td>+251${this.addData.phoneNumber || 'Not provided'}</td></tr>
                      <tr><td class="label">Residential Address</td><td>${this.addData.address || 'Not provided'}</td></tr>
                      <tr><td class="label">Gender</td><td>${this.addData.sex || 'Not specified'}</td></tr>` : ''}
                      <tr><td class="label">Role</td><td>Tenant with rights and obligations as defined in this agreement</td></tr>
                    </table>
                  </div>
                </div>
                
                <div class="section">
                  <div class="section-title">2. PROPERTY DESCRIPTION AND SPECIFICATIONS</div>
                  ${this.houseType === 'existing' ? `
                  <table>
                    <tr><td class="label">Property Identification</td><td>${this.getHouseName}</td></tr>
                    <tr><td class="label">Pricing Structure</td><td>${this.getPriceOptionByValue}</td></tr>
                    <tr><td class="label">Currency</td><td>${this.getRentCurrencyType}</td></tr>
                    <tr><td class="label">Base Rate</td><td>${this.numberWithCommas(parseFloat(this.getPriceByValue.replace(/,/g, '')))} ${this.getRentCurrencyType} per ${this.getPriceOptionByValue === 'PerSquareMeter' ? 'square meter' : 'month'}</td></tr>
                    ${this.getPriceOptionByValue === 'PerSquareMeter' ? `<tr><td class="label">Total Monthly Rent</td><td>${this.computedPriceExist} ${this.getRentCurrencyType}</td></tr>` : ''}
                  </table>` : `
                  <table>
                    <tr><td class="label">Building Name</td><td>${this.getBuildingName}</td></tr>
                    <tr><td class="label">Floor Level</td><td>${this.addData.floor}</td></tr>
                    <tr><td class="label">Room/Unit Number</td><td>${this.addData.roomNumber}</td></tr>
                    <tr><td class="label">Total Area</td><td>${this.addData.size} square meters</td></tr>
                    <tr><td class="label">Pricing Method</td><td>${this.addData.priceOption}</td></tr>
                    <tr><td class="label">Currency</td><td>${this.addData.rentCurrencyType}</td></tr>
                    <tr><td class="label">Unit Rate</td><td>${this.numberWithCommas(this.addData.latest_price)} ${this.addData.rentCurrencyType} per ${this.addData.priceOption === 'PerSquareMeter' ? 'square meter' : 'month'}</td></tr>
                    ${this.addData.priceOption === 'PerSquareMeter' ? `<tr><td class="label">Total Monthly Rent</td><td>${this.numberWithCommas(this.computedPrice)} ${this.addData.rentCurrencyType}</td></tr>` : ''}
                    ${this.addData.description ? `<tr><td class="label">Additional Notes</td><td>${this.addData.description}</td></tr>` : ''}
                  </table>`}
                </div>
                
                <div class="section">
                  <div class="section-title">3. LEASE TERMS AND CONDITIONS</div>
                  
                  <div class="subsection">
                    <div class="subsection-title">3.1 Lease Duration</div>
                    <table>
                      <tr><td class="label">Commencement Date</td><td>${this.addData.startDate}</td></tr>
                      <tr><td class="label">Termination Date</td><td>${this.addData.endDate}</td></tr>
                      <tr><td class="label">Total Lease Period</td><td>${this.calculateDuration()} days</td></tr>
                    </table>
                  </div>
                  
                  <div class="subsection">
                    <div class="subsection-title">3.2 Payment Terms</div>
                    <table>
                      <tr><td class="label">Payment Frequency</td><td>Every ${this.addData.period} ${this.addData.periodtwo === 1 ? 'month(s)' : 'year(s)'}</td></tr>
                      <tr><td class="label">Payment Due Date</td><td>Within ${this.addData.dueDate} days of each payment period</td></tr>
                      <tr><td class="label">Advance Payment</td><td>${this.numberWithCommas(this.addData.initialPayment)} ${this.addData.rentCurrencyType}</td></tr>
                      <tr><td class="label">Advance Payment Period</td><td>${this.addData.advancePeriod} ${this.addData.advancePeriodtwo === 1 ? 'month(s)' : 'year(s)'} in advance</td></tr>
                      <tr><td class="label">Security Deposit</td><td>${this.numberWithCommas(this.addData.guaranteedMoney)} ${this.addData.rentCurrencyType} (Refundable upon satisfactory completion of lease)</td></tr>
                    </table>
                  </div>
                  
                  <div class="subsection">
                    <div class="subsection-title">3.3 Penalty and Late Payment Policy</div>
                    <table>
                      <tr><td class="label">Penalty Structure</td><td>${this.addData.penaltyOption === 'noPenalty' ? 'No penalty charges apply for late payments' : this.getPenaltyDescription()}</td></tr>
                      ${this.addData.penaltyCondition && this.addData.penaltyOption !== 'noPenalty' ? `<tr><td class="label">Penalty Application</td><td>${this.addData.penaltyCondition} penalty structure</td></tr>` : ''}
                    </table>
                  </div>
                  
                  <div class="subsection">
                    <div class="subsection-title">3.4 Tax Information</div>
                    <table>
                      <tr><td class="label">Value Added Tax (VAT)</td><td>${this.selectedOption === 'Yes' ? '15% VAT included in rental amount' : '15% VAT not included - tenant responsible if applicable'}</td></tr>
                      <tr><td class="label">Withholding Tax</td><td>${this.addData.withHolding === 'Yes' ? '3% withholding tax applicable as per Ethiopian tax law' : '3% withholding tax not applicable'}</td></tr>
                    </table>
                  </div>
                </div>
                
                ${this.hasUtilities() ? `
                <div class="section">
                  <div class="section-title">4. UTILITIES AND SERVICES</div>
                  <div class="important">
                    <strong>Important:</strong> The following utility services are included with this rental agreement and are subject to the terms specified below.
                  </div>
                  <table>
                    ${this.showElectricReading() ? `<tr><td class="label">Electricity Service</td><td>Metered service - Initial reading: ${this.addData.electricReading} KWH. Tenant responsible for consumption above base reading.</td></tr>` : ''}
                    ${this.showWaterReading() ? `<tr><td class="label">Water Service</td><td>Metered service - Initial reading: ${this.addData.waterReading} cubic meters. Tenant responsible for consumption above base reading.</td></tr>` : ''}
                    ${this.addData.firstBillPaymentStarts ? `<tr><td class="label">Utility Billing Commencement</td><td>First utility bill payment due on: ${this.addData.firstBillPaymentStarts}</td></tr>` : ''}
                  </table>
                </div>` : ''}
                
                <div class="section">
                  <div class="section-title">5. PAYMENT METHOD AND BANKING INFORMATION</div>
                  <div class="important">
                    <strong>Payment Method:</strong> All rental payments must be made through Tsehay Bank using any of the following convenient channels:
                  </div>
                  <table>
                    <tr><td class="label">Mobile Banking</td><td>Use Tsehay Bank mobile app for instant payments</td></tr>
                    <tr><td class="label">Internet Banking</td><td>Access online banking portal for secure transactions</td></tr>
                    <tr><td class="label">USSD Banking</td><td>Dial USSD code for quick mobile payments</td></tr>
                    <tr><td class="label">Branch Services</td><td>Visit any Tsehay Bank branch for in-person payments</td></tr>
                    <tr><td class="label">ATM Services</td><td>Use Tsehay Bank ATMs for payment transactions</td></tr>
                    <tr><td class="label">Payment Reference</td><td>A unique payment ID will be provided to the tenant after contract establishment. This unique ID must be used for all rental payments to ensure proper account crediting and payment tracking.</td></tr>
                  </table>
                </div>
                
                <div class="section">
                  <div class="section-title">6. LEGAL PROVISIONS AND RESPONSIBILITIES</div>
                  
                  <div class="subsection">
                    <div class="subsection-title">6.1 Tenant Responsibilities</div>
                    <ul class="terms-list">
                      <li>Maintain the property in good condition and report any damages immediately</li>
                      <li>Pay rent and utilities on time as specified in this agreement</li>
                      <li>Comply with all building rules and local regulations</li>
                      <li>Not sublease the property without written consent from the landlord</li>
                      <li>Allow reasonable access for inspections and maintenance</li>
                    </ul>
                  </div>
                  
                  <div class="subsection">
                    <div class="subsection-title">6.2 Landlord Responsibilities</div>
                    <ul class="terms-list">
                      <li>Provide the property in habitable condition</li>
                      <li>Maintain structural integrity and essential services</li>
                      <li>Respect tenant's right to quiet enjoyment of the property</li>
                      <li>Return security deposit within 30 days of lease termination (less any legitimate deductions)</li>
                    </ul>
                  </div>
                  
                  <div class="subsection">
                    <div class="subsection-title">6.3 Legal Framework</div>
                    <table>
                      <tr><td class="label">Governing Law</td><td>This agreement is governed by and construed in accordance with the laws of the Federal Democratic Republic of Ethiopia</td></tr>
                      <tr><td class="label">Jurisdiction</td><td>Any disputes arising from this agreement shall be resolved in Ethiopian courts</td></tr>
                      <tr><td class="label">Document Attachment</td><td>${this.file ? `Additional document attached: ${this.file.name}` : 'No additional supporting documents attached to this agreement'}</td></tr>
                    </table>
                  </div>
                </div>
                
                <div class="important">
                  <strong>ACKNOWLEDGMENT:</strong> Both parties acknowledge that they have read, understood, and agree to be bound by all terms and conditions set forth in this comprehensive rental agreement. This agreement represents the complete understanding between the parties and supersedes all prior negotiations, representations, or agreements relating to the subject matter.
                </div>
                
                <div class="signature-section">
                  <div class="section-title">7. SIGNATURES AND EXECUTION</div>
                  <p style="margin-bottom: 20px;">By signing below, both parties agree to the terms and conditions outlined in this rental agreement:</p>
                  
                  <div class="signature-box">
                    <p><strong>LANDLORD/AUTHORIZED REPRESENTATIVE:</strong></p>
                    <div class="signature-line"></div>
                    <p>Signature: _________________________</p>
                    <p>Name: ${this.getCurrentUserName()}</p>
                    <p>Date: _______________</p>
                    <p>Title: Property Manager</p>
                  </div>
                  
                  <div class="signature-box">
                    <p><strong>TENANT:</strong></p>
                    <div class="signature-line"></div>
                    <p>Signature: _________________________</p>
                    <p>Name: ${this.tenantType === 'existing' ? this.getTenantName : this.addData.fullName}</p>
                    <p>Date: _______________</p>
                    <p>ID/Passport: _______________</p>
                  </div>
                </div>
                
                <div style="margin-top: 30px; text-align: center; font-size: 10px; color: #666;">
                  <p>This document was generated electronically by the Tsehay Bank Building Management System on ${new Date().toLocaleString()}</p>
                </div>
              </div>
            </body>
          </html>
        `;
      },
      
      generatePDFContent() {
        return `<!DOCTYPE html>
<html>
<head>
  <title>Rental Agreement Contract</title>
  <style>
    body { font-family: 'Times New Roman', serif; margin: 30px; line-height: 1.6; }
    .header { text-align: center; margin-bottom: 30px; border-bottom: 2px solid #000; padding-bottom: 15px; }
    .section { margin: 20px 0; page-break-inside: avoid; }
    .section-title { font-weight: bold; font-size: 16px; margin-bottom: 10px; }
    table { width: 100%; border-collapse: collapse; margin: 10px 0; }
    td { padding: 8px; border-bottom: 1px solid #ddd; }
    .label { font-weight: bold; width: 30%; background-color: #f5f5f5; }
    .signature-section { margin-top: 50px; }
    .signature-box { display: inline-block; width: 45%; margin: 20px 2%; }
    .signature-line { border-bottom: 2px solid #000; height: 40px; margin: 10px 0; }
  </style>
</head>
<body>
  <div class="header">
    <h1>RENTAL AGREEMENT CONTRACT</h1>
    <p>This agreement is made between the landlord and tenant under the following terms and conditions</p>
  </div>
  
  <div class="section">
    <div class="section-title">PARTIES TO THE AGREEMENT</div>
    <table border="1">
      <tr><td class="label">Landlord</td><td>Property Owner</td></tr>
      <tr><td class="label">Represented by</td><td>${this.getCurrentUserName()}</td></tr>
      <tr><td class="label">Tenant</td><td>${this.tenantType === 'existing' ? this.getTenantName : this.addData.fullName}</td></tr>
      ${this.tenantType === 'new' ? `
      <tr><td class="label">Email</td><td>${this.addData.email}</td></tr>
      <tr><td class="label">Phone</td><td>+251${this.addData.phoneNumber}</td></tr>
      <tr><td class="label">Address</td><td>${this.addData.address}</td></tr>` : ''}
    </table>
  </div>
  
  <div class="section">
    <div class="section-title">PROPERTY DETAILS</div>
    <table border="1">
      ${this.houseType === 'existing' ? `
      <tr><td class="label">Property</td><td>${this.getHouseName}</td></tr>
      <tr><td class="label">Pricing Option</td><td>${this.getPriceOptionByValue}</td></tr>
      <tr><td class="label">Rate</td><td>${this.numberWithCommas(parseFloat(this.getPriceByValue.replace(/,/g, '')))} ${this.getRentCurrencyType}</td></tr>` : `
      <tr><td class="label">Building</td><td>${this.getBuildingName}</td></tr>
      <tr><td class="label">Floor</td><td>${this.addData.floor}</td></tr>
      <tr><td class="label">Room Number</td><td>${this.addData.roomNumber}</td></tr>
      <tr><td class="label">Size</td><td>${this.addData.size} square meters</td></tr>
      <tr><td class="label">Rate</td><td>${this.numberWithCommas(this.addData.latest_price)} ${this.addData.rentCurrencyType}</td></tr>`}
    </table>
  </div>
  
  <div class="section">
    <div class="section-title">TERMS AND CONDITIONS</div>
    <table border="1">
      <tr><td class="label">Start Date</td><td>${this.addData.startDate}</td></tr>
      <tr><td class="label">End Date</td><td>${this.addData.endDate}</td></tr>
      <tr><td class="label">Payment Frequency</td><td>Every ${this.addData.period} ${this.addData.periodtwo === 1 ? 'month(s)' : 'year(s)'}</td></tr>
      <tr><td class="label">Due Date</td><td>${this.addData.dueDate} days</td></tr>
      <tr><td class="label">Advance Payment</td><td>${this.numberWithCommas(this.addData.initialPayment)} ${this.addData.rentCurrencyType || 'ETB'}</td></tr>
      <tr><td class="label">Security Deposit</td><td>${this.numberWithCommas(this.addData.guaranteedMoney)} ${this.addData.rentCurrencyType || 'ETB'}</td></tr>
      <tr><td class="label">Penalty Policy</td><td>${this.addData.penaltyOption === 'noPenalty' ? 'No penalty charges apply' : this.getPenaltyDescription()}</td></tr>
      <tr><td class="label">VAT (15%)</td><td>${this.selectedOption === 'Yes' ? 'Included' : 'Not Included'}</td></tr>
      <tr><td class="label">Withholding Tax (3%)</td><td>${this.addData.withHolding === 'Yes' ? 'Applicable' : 'Not Applicable'}</td></tr>
    </table>
  </div>
  
  <div class="signature-section">
    <div class="section-title">SIGNATURES</div>
    <div class="signature-box">
      <p><strong>Landlord Signature:</strong></p>
      <div class="signature-line"></div>
      <p>Date: _______________</p>
    </div>
    <div class="signature-box">
      <p><strong>Tenant Signature:</strong></p>
      <div class="signature-line"></div>
      <p>Date: _______________</p>
    </div>
  </div>
</body>
</html>`;
      },
      
      getPenaltyDescription() {
        if (this.addData.penaltyOption === 'percentage') {
          const amount = this.addData.penaltyAmount === 'Other' ? this.addData.penaltyAmountPercent : this.addData.penaltyAmount;
          let description = `A penalty of ${amount}% of the monthly rent amount will be charged for late payments`;
          
          if (this.addData.penaltyCondition === 'incremental') {
            const dateRange = this.addData.dateRangeForPenaltyIncrement === 'Other' 
              ? this.addData.dateRangeForUserInput 
              : this.addData.dateRangeForPenaltyIncrement;
            description += `. This penalty increases incrementally every ${dateRange} days after the due date until payment is made`;
          } else if (this.addData.penaltyCondition === 'fixed') {
            description += `. This is a one-time fixed penalty applied when payment is overdue`;
          }
          
          return description;
        } else if (this.addData.penaltyOption === 'fixedAmount') {
          const amount = this.addData.penaltyAmount === 'Other' ? this.addData.penaltyAmountFixed : this.addData.penaltyAmount;
          let description = `A fixed penalty amount of ${this.numberWithCommas(amount)} ${this.addData.rentCurrencyType || 'ETB'} will be charged for late payments`;
          
          if (this.addData.penaltyCondition === 'incremental') {
            const dateRange = this.addData.dateRangeForPenaltyIncrement === 'Other' 
              ? this.addData.dateRangeForUserInput 
              : this.addData.dateRangeForPenaltyIncrement;
            description += `. This penalty amount is added incrementally every ${dateRange} days after the due date until payment is made`;
          } else if (this.addData.penaltyCondition === 'fixed') {
            description += `. This is a one-time penalty applied when payment becomes overdue`;
          }
          
          return description;
        }
        return 'No penalty charges apply for late payments';
      },
      
      hasUtilities() {
        return this.showElectricReading() || this.showWaterReading() || this.addData.firstBillPaymentStarts;
      },
      
      showElectricReading() {
        if (this.houseType === 'existing') {
          return this.getBillOptionByHouseIdElectric(this.addData.houseId) === 'ByReading';
        } else {
          return this.getBillOptionByIDElectric(this.addData.buildingId) === 'ByReading';
        }
      },
      
      showWaterReading() {
        if (this.houseType === 'existing') {
          return this.getBillOptionByHouseIdWater(this.addData.houseId) === 'ByReading';
        } else {
          return this.getBillOptionByIDWater(this.addData.buildingId) === 'ByReading';
        }
      },
      
      clearData(){
        this.addData = {
          floor:null,
          roomNumber:"",
          size:null,
          buildingId: null,
          latest_price: null,
          priceOption: "",
          rentCurrencyType: "",
          description: "",
          fullName:"",
          email:"",
          sex:"",
          phoneNumber:"",
          address:"",
          firstBillPaymentStarts:"",
          startDate:"",
          endDate:"",
          dueDate:0,
          payedAmount:0,
          tenantId: null,
          houseId: null,
          period: null,
          periodtwo: 1,
          initialPayment: null,
          guaranteedMoney: null,
          paymentRule: "",
          attachedFile: "",
          registeredBy: sessionStorage.getItem("userID"),
          electricReading:null,
          waterReading:null,
          penaltyOption:"",
          penaltyCondition:"",
          dateRangeForPenaltyIncrement:"",
          dateRangeForUserInput:null,
          penaltyAmount:"",
          penaltyAmountPercent:null,
          penaltyAmountFixed:null,
          withHolding:"",
          advancePeriod:null,
          advancePeriodtwo:1
        };
        this.checkedExistingHouse = false;
        this.checkedExistingTenant = false;
        this.tabIndex = 0;
        this.currentStep = 1;
        this.houseType = 'existing';
        this.tenantType = 'existing';
        this.file = null;
        this.base64 = null;
        this.aboveSelected = false;
        this.belowSelected = false;
        this.selectedOption = "Yes";
      },
      
     updateInitialPayment() {
     const value = this.addData.houseId;
     // Check if the user is using an existing house
     if (this.houseType === 'existing') {
      console.log("Using Existing House values");
       const existingHouse = this.houseOptions.find(item => item.value === value);
       if (!existingHouse) return; // Handle case where houseId is invalid
       const { priceOption, size, price } = existingHouse;

       // Use existing values for calculation
       const period = this.addData.advancePeriodtwo === 1
         ? this.addData.advancePeriod
         : this.addData.advancePeriod * 12;

       if (priceOption === "PerSquareMeter") {
         if (size !== null && price !== null) {
           this.addData.initialPayment = price * size * period;
         } else {
           return null;
         }
       } else {
         this.addData.initialPayment = price * period;
       }
     } else {
       // Use new house size and price values
       console.log("Using New House values");
       const { size, latest_price } = this.addData; // Assuming newSize and newPrice are part of addData

       const period = this.addData.advancePeriodtwo === 1
         ? this.addData.advancePeriod
         : this.addData.advancePeriod * 12;

       if (this.addData.priceOption === "PerSquareMeter") {
         if (size !== null && latest_price !== null) {
           this.addData.initialPayment = latest_price * size * period;
         } else {
           return null;
         }
       } else {
         this.addData.initialPayment = latest_price * period;
       }
     }
    },
        updateSize(newValue){
        this.addData.size = newValue;
        this.validateSize(newValue);
      },
        updatePrice(newValue){
        this.addData.latest_price = newValue;
        this.validatePrice(newValue);
      },
      validateSize(value){
        if(value === null || value===undefined || isNaN(value)){
          this.errorMessage = '';
        }
        else if(value <= 0){
          this.errorMessage = 'Size must be greater than zero';
        }
        else{
          this.errorMessage = '';
        }
      },
        validatePrice(value){
        if(value === null || value===undefined || isNaN(value)){
          this.errorMessage1 = '';
        }
        else if(value<= 0){
          this.errorMessage1 = 'Amount must be greater than zero';
        }
        else{
          this.errorMessage1 = '';
        }
      },
      getModules(){
        this.$store.dispatch('getModulesPermission', {userId: sessionStorage.getItem("userID")})
          .then(response=>{
              //this.items = response.data;
              //console.log("somemodules", response.data.modules);
              var modulesList = response.data.modules;
              var BuildingModule = modulesList.filter(x=>x.name === "Contract");
              if(BuildingModule !== null){
                this.modulePermission.view = BuildingModule[0].listData;
                this.modulePermission.create = BuildingModule[0].createData;
                this.modulePermission.update = BuildingModule[0].updateData;
                this.modulePermission.delete = BuildingModule[0].deleteData;
              }
          })
          .catch(error=>{
              //console.log(error);
          })
      },
      createBase64Image(FileObject) {
        const reader = new FileReader();
        reader.onload = (event) => {
          //console.log("event", event.target.result);
          this.base64=event.target.result;
        }
        reader.readAsDataURL(FileObject);
      },
      getPeriod(period){
        var periodValue = this.periodOptions.filter(x=>x.value == period);
        if(period == null || period == 0){
          return "";
        }else{
          return "Every " + periodValue[0].text + " months"
        }
      },
      getPaymentCondition(condition){
        if(condition.toLowerCase() == "above"){
          return "Advance Payment Permitted";
        }else if(condition.toLowerCase() == "below"){
          return "Partial Payment Permitted";
        }
        else if(condition.toLowerCase() == "yesboth"){
          return "Both Advance and Partial Payment are Permitted";
        }else{
          return "Neither Advance Nor Partial Payment Permitted";
        }
      },
      getStatus(status){
        return status == 1 ? "Rented" : "Free";
      },
      numberWithCommas(x) {
        if(x !== null && x !== undefined && !isNaN(x)){
            const num = parseFloat(x);
            return num.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }
        return x || '0.00';
      },
      getTenantByOwnerID(){
         this.$store.dispatch('getTenantByOwnerID',{userId: sessionStorage.getItem("ID")})
        .then(response=>{
            Array.from(response.data).forEach((value) => {
            this.tenantOptions.push({
              value: value.tenantId,
              text: value.fullName
            });
          });
        })
        .catch(error=>{
            this.$notify({
                title: 'Error',
                text: error.response.data,
                type: 'error'
            })
        })
      },
      getHouseByOwnerID(){
         this.$store.dispatch('getFreeHousesByOwnerID',{userId: sessionStorage.getItem("ID")})
        .then(response=>{
          this.houses = response.data;
            Array.from(response.data).forEach((value) => {
            this.houseOptions.push({
              value: value.houseId,
              text: value.building.buildingName+"-"+value.floor+"-"+value.roomNumber,
              price: value.latestPrice,
              size: value.size,
              priceOption: value.priceOption,
              billExist: value.building.billExist,
              electricBillAmountOption:value.electricBillAmountOption,
              waterBillAmountOption:value.waterBillAmountOption,
              rentCurrencyType:value.rentCurrencyType,
              includeVat: value.includeVat
            });
          });
        })
        .catch(error=>{
            this.$notify({
                title: 'Error',
                text: error.response.data,
                type: 'error'
            })
        })
      },
      getBuildings(){
         this.$store.dispatch('getBuildingsByOwnerID',{userId: sessionStorage.getItem("ID")})
        .then(response=>{
          // console.log("building", response.data);
            Array.from(response.data).forEach((value) => {
            this.buildingOptions.push({
              value: value.buildingId,
              text: value.buildingName,
              electricBillAmountOption: value.electricBillAmountOption,
              waterBillAmountOption: value.waterBillAmountOption,
              billExist: value.billExist,
              billPaymentPeriod: value.billPaymentPeriod
            });
          });
        })
        .catch(error=>{
            this.$notify({
                title: 'Error',
                text: error.response.data,
                type: 'error'
            })
        })
      },
      getBillOptionByIDElectric(buildingId){
        if(buildingId !== "" && buildingId !== null){
          return this.buildingOptions.filter(x=>x.value === buildingId)[0].electricBillAmountOption;
        }
      },
      getBillOptionByIDWater(buildingId){
        if(buildingId !== "" && buildingId !== null){
          return this.buildingOptions.filter(x=>x.value === buildingId)[0].waterBillAmountOption;
        }
      },
      getBillExistOptionByBuildingId(buildingId){
        if(buildingId !== "" && buildingId !== null)
        return this.buildingOptions.filter(x=>x.value === buildingId)[0].billExist;
      },
      getBillOptionByHouseIdElectric(houseId){
         if(houseId !== "" && houseId !== null){
          return this.houseOptions.filter(x=>x.value === houseId)[0].electricBillAmountOption;
        }
      },
      getBillExistOptionByHouseId(houseId){
         if(houseId !== "" && houseId !== null){
          return this.houseOptions.filter(x=>x.value === houseId)[0].billExist;
        }
      },
      getBillOptionByHouseIdWater(houseId){
         if(houseId !== "" && houseId !== null){
          return this.houseOptions.filter(x=>x.value === houseId)[0].waterBillAmountOption;
        }
      },
      getContractByOwnerID(){
        this.spinner =true;
        if(this.DateFrom !== "" && this.DateFrom !== null && this.DateTo !== "" && this.DateTo !== null){
          if(this.contractStatus === "Active"){
            this.disabledData = false;
               //console.log("start Date",this.DateFrom,"End Date",this.DateTo);
            this.$store.dispatch('getContractByOwnerIDandDate', {userId: parseInt(sessionStorage.getItem("ID")), startDate: this.DateFrom, endDate: this.DateTo , page: this.currentPage, line: this.perPage })
            .then(response=>{
            console.log("here",  response.data);
                this.items = response.data.Contents;
                this.totalRows = response.data.totalElements;
            })
            .catch(error=>{
                // this.$notify({
                //     title: 'Error',
                //     text: error.response.data,
                //     type: 'error'
                // })
                console.log(error);
            })
            .finally(msg=>{
              this.spinner =false;
            })
          }else{
            this.disabledData = true;
            console.log("start Date",this.DateFrom,"End Date",this.DateTo, "userId",sessionStorage.getItem("ID")) ;
            this.$store.dispatch('getDisabledContractByOwnerIDandDate', {userId: parseInt(sessionStorage.getItem("ID")), startDate: this.DateFrom, endDate: this.DateTo , page: this.currentPage, line: this.perPage })
            .then(response=>{
            console.log("terminate",  response.data);
                this.items = response.data.Contents;
                this.totalRows = response.data.totalElements;
            })
            .catch(error=>{
                // this.$notify({
                //     title: 'Error',
                //     text: error.response.data,
                //     type: 'error'
                // })
                //console.log(error);
            })
            .finally(msg=>{
              this.spinner =false;
            })
          }
        }else{
          if(this.contractStatus === "Active"){
            this.disabledData = false;
            this.$store.dispatch('getContractByOwnerID', {userId: sessionStorage.getItem("ID"), page: this.currentPage, line: this.perPage})
            .then(response=>{
            //console.log("here",  response.data);
                this.items = response.data.Contents;
                this.totalRows = response.data.totalElements;
            })
            .catch(error=>{
                // this.$notify({
                //     title: 'Error',
                //     text: error.response.data,
                //     type: 'error'
                // })
                //console.log(error);
            })
            .finally(msg=>{
              this.spinner =false;
            })
          }else{
            this.disabledData = true;
            this.$store.dispatch('getDisabledContractByOwnerID', {userId: sessionStorage.getItem("ID"), page: this.currentPage, line: this.perPage})
            .then(response=>{
            console.log("terminate",  response.data);
                this.items = response.data.Contents;
                this.totalRows = response.data.totalElements;
            })
            .catch(error=>{
                // this.$notify({
                //     title: 'Error',
                //     text: error.response.data,
                //     type: 'error'
                // })
                //console.log(error);
            })
            .finally(msg=>{
              this.spinner =false;
            })
          }
        }
      },
      changePage(event, page){
        this.spinner = true;
        if(this.DateFrom !== "" && this.DateFrom !== null && this.DateTo !== "" && this.DateTo !== null){
          if(this.contractStatus === "Active"){
            this.disabledData = false;
           this.$store.dispatch('getContractByOwnerIDandDate', {userId: sessionStorage.getItem("ID"), page: page, line: this.perPage, startDate: this.DateFrom, endDate: this.DateTo})
            .then(response=>{
                this.items = response.data.Contents;
                this.totalRows = response.data.totalElements;
            })
            .catch(error=>{
                // this.$notify({
                //     title: 'Error',
                //     text: error.response.data,
                //     type: 'error'
                // })
                //console.log(error);
            })
            .finally(msg=>{
              this.spinner =false;
            })
          }else{
            this.disabledData = true;
            this.$store.dispatch('getDisabledContractByOwnerIDandDate', {userId: sessionStorage.getItem("ID"), page: page, line: this.perPage, startDate: this.DateFrom, endDate: this.DateTo})
            .then(response=>{
                this.items = response.data.Contents;
                this.totalRows = response.data.totalElements;
            })
            .catch(error=>{
                // this.$notify({
                //     title: 'Error',
                //     text: error.response.data,
                //     type: 'error'
                // })
               // console.log(error);
            })
            .finally(msg=>{
              this.spinner =false;
            })
          }
        }else{    
          if(this.contractStatus === "Active"){
            this.disabledData = false;
            this.$store.dispatch('getContractByOwnerID', {userId: sessionStorage.getItem("ID"), page: page, line: this.perPage})
            .then(response=>{
                this.items = response.data.Contents;
                this.totalRows = response.data.totalElements;
            })
            .catch(error=>{
                // this.$notify({
                //     title: 'Error',
                //     text: error.response.data,
                //     type: 'error'
                // })
               // console.log(error);
            })
            .finally(msg=>{
              this.spinner =false;
            })
          }else{
            this.disabledData = true;
            this.$store.dispatch('getDisabledContractByOwnerID', {userId: sessionStorage.getItem("ID"), page: page, line: this.perPage})
            .then(response=>{
                this.items = response.data.Contents;
                this.totalRows = response.data.totalElements;
            })
            .catch(error=>{
                // this.$notify({
                //     title: 'Error',
                //     text: error.response.data,
                //     type: 'error'
                // })
               // console.log(error);
            })
            .finally(msg=>{
              this.spinner =false;
            })
          }
        }
      },
      changePerPage(event){
        this.spinner = true;
        if(this.DateFrom !== "" && this.DateFrom !== null && this.DateTo !== "" && this.DateTo !== null){
          if(this.contractStatus === "Active"){
            this.disabledData = false;
            this.$store.dispatch('getContractByOwnerIDandDate', {userId: sessionStorage.getItem("ID"), page: this.currentPage, line: this.perPage, startDate: this.DateFrom, endDate: this.DateTo})
            .then(response=>{
                this.items = response.data.Contents;
                this.totalRows = response.data.totalElements;
            })
            .catch(error=>{
                // this.$notify({
                //     title: 'Error',
                //     text: error.response.data,
                //     type: 'error'
                // })
                //console.log(error);
            })
            .finally(msg=>{
              this.spinner =false;
            })
          }else{
            this.disabledData = true;
             this.$store.dispatch('getDisabledContractByOwnerIDandDate', {userId: sessionStorage.getItem("ID"), page: this.currentPage, line: this.perPage, startDate: this.DateFrom, endDate: this.DateTo})
            .then(response=>{
                this.items = response.data.Contents;
                this.totalRows = response.data.totalElements;
            })
            .catch(error=>{
                // this.$notify({
                //     title: 'Error',
                //     text: error.response.data,
                //     type: 'error'
                // })
                //console.log(error);
            })
            .finally(msg=>{
              this.spinner =false;
            })
          }
        }else{
           if(this.contractStatus === "Active"){
            this.disabledData = false;
            this.$store.dispatch('getContractByOwnerID', {userId: sessionStorage.getItem("ID"), page: this.currentPage, line: this.perPage})
            .then(response=>{
                this.items = response.data.Contents;
                this.totalRows = response.data.totalElements;
            })
            .catch(error=>{
                // this.$notify({
                //     title: 'Error',
                //     text: error.response.data,
                //     type: 'error'
                // })
                //console.log(error);
            })
            .finally(msg=>{
              this.spinner =false;
            })
          }else{
            this.disabledData = true;
             this.$store.dispatch('getDisabledContractByOwnerID', {userId: sessionStorage.getItem("ID"), page: this.currentPage, line: this.perPage})
            .then(response=>{
                this.items = response.data.Contents;
                this.totalRows = response.data.totalElements;
            })
            .catch(error=>{
                // this.$notify({
                //     title: 'Error',
                //     text: error.response.data,
                //     type: 'error'
                // })
               // console.log(error);
            })
            .finally(msg=>{
              this.spinner =false;
            })
          }
        }
      },
      AddContract(){
        this.isSubmitting = false;
        this.currentStep = 1;
        this.$bvModal.show('modal-top-add');
      },
      ViewDetail(ID){
        this.$store.dispatch('GetContractDetailById', {contractId: ID})
        .then(response=>{
          this.selectedContract = response.data;
          //console.log("herea", response.data);
            this.$bvModal.show('modal-top-Details');
            this.clearData();
        })
        .catch(error=>{
          this.$notifications.notify(
              {
                message: error.response.data,
                horizontalAlign: 'center',
                verticalAlign: 'top',
                type: 'danger'
              })
            //console.log(error);
        })
      },
      EditContract(ID){
        var selected = this.items.filter(item=> item.contractId == ID)[0];

        this.editData.penaltyOption= selected.penaltyOption;
        this.editData.penaltyCondition=selected.penaltyCondition;
        this.editData.dateRangeForPenaltyIncrement=selected.dateRange;
        this.editData.penaltyAmount=selected.penaltyAmount;

        this.editData.contractId = ID;
        this.editData.startDate = selected.startDate;
        this.editData.endDate = selected.endDate;
        this.editData.initialPayment = selected.initialPayment;
        this.editData.guaranteedMoney = selected.guaranteedMoney;
        this.editData.dueDate = selected.dueDate;
        this.editData.withHolding= selected.withHolding;
        if(selected.period<11){
          this.editData.period = selected.period;
          this.editData.periodtwo = 1;
        }else{
          this.editData.period = selected.period/12;
          this.editData.periodtwo = 2;
        }

       // console.log("soemojgod", selected);

        this.editData.paymentRule = selected.paymentRule;

        if( this.editData.paymentRule == "yesBoth" ){
          this.aboveSelected = this.belowSelected = true;
        }
        else if (this.editData.paymentRule == "below"){
          this.aboveSelected = false;
          this.belowSelected = true;
        }
        else if(this.editData.paymentRule == "above"){
          this.aboveSelected = true;
          this.belowSelected = false;
        }
        else{
          this.aboveSelected =  this.belowSelected = false;
        }

         this.$store.dispatch('GetContractFile', {contractId:ID})
          .then(response=>{
              if(response.data.encodedPdf !="" && response.data.encodedPdf !=null){
                this.editData.encodedPdf = response.data.encodedPdf;
              }
          })
          .catch(error=>{
             // console.log(error);
          })
          .finally(msg=>{
            this.$bvModal.show('modal-top-EditContract');
          })
      },
       submitEditForm(){
        if(this.file !== null){
          if(this.file.type !="application/pdf"){
            this.$notifications.notify(
            {
              message: "Invalid document format",
              horizontalAlign: 'center',
              verticalAlign: 'top',
              type: 'danger'
            })
            return;
          }
          if(this.file.size > 2000000){
            this.$notifications.notify(
            {
              message: "Document size should not be exceed 2MB",
              horizontalAlign: 'center',
              verticalAlign: 'top',
              type: 'danger'
            })
            return;
          }
       }
        this.$bvModal.msgBoxConfirm('Are you sure you want to submit this form?', {
              title: 'Confirm',
              size: 'sm',
              buttonSize: 'sm',
              okVariant: 'success',
              cancelVariant: 'danger',
              okTitle: 'YES',
              cancelTitle: 'NO',
              bodyClass: 'm-2',
              hideHeaderClose: false,
              centered: false
          })
          .then(value => {
            let penaltyAmount;
                  let dateRange;
                  if(this.editData.dateRangeForPenaltyIncrement==="Other"){
                    dateRange=this.editData.dateRangeForUserInput
                  }
                  else{
                    dateRange=this.editData.dateRangeForPenaltyIncrement
                  }
                  if (this.editData.penaltyAmount==="Other"){
                    if(this.editData.penaltyAmountFixed===0){
                      penaltyAmount=this.editData.penaltyAmountPercent
                    }
                    else{
                      penaltyAmount=this.editData.penaltyAmountFixed
                    }
                  }
                  else{
                    penaltyAmount=this.editData.penaltyAmount
                  }
              if(value === true){
                var fileToAttach = "";

                if(this.base64 != null){
                  fileToAttach = this.base64.split(',')[1];
                }

                if(fileToAttach == ""){
                  fileToAttach = this.editData.encodedPdf == null ? "" : this.editData.encodedPdf;
                }

                var period = this.editData.period * this.editData.periodtwo;

                if(this.aboveSelected && this.belowSelected) this.editData.paymentRule = "yesBoth";
                else if (!this.aboveSelected && this.belowSelected) this.editData.paymentRule = "below";
                else if(this.aboveSelected && !this.belowSelected) this.editData.paymentRule = "above";
                else this.editData.paymentRule = "notBoth";
                this.$store.dispatch('EditContract', {
                    contractId : this.editData.contractId,
                    startDate : this.editData.startDate,
                    endDate : this.editData.endDate,
                    initialPayment:  this.editData.initialPayment,
                    guaranteedMoney: this.editData.guaranteedMoney,
                    dueDate : this.editData.dueDate,
                    period: period,  
                    paymentRule:  this.editData.paymentRule,
                    encodePdf: fileToAttach,
                    penaltyOption: this.editData.penaltyOption,
                    penaltyCondition: this.editData.penaltyCondition,
                    withHolding: this.editData.withHolding,
                    dateRangeForPenaltyIncrement: dateRange,
                    penaltyAmount: penaltyAmount,
                    userId: parseInt(sessionStorage.getItem("ID")),
                    registeredBy: parseInt(sessionStorage.getItem("userID"))

                })
                  .then(response=>{
                      this.$notifications.notify(
                        {
                          message: `Contract successfully updated.`,
                          horizontalAlign: 'center',
                          verticalAlign: 'top',
                          type: 'success'
                        })
                        this.$bvModal.hide('modal-top-EditContract');
                        this.clearData();
                  })
                  .catch(error=>{
                     this.$notifications.notify(
                      {
                        message: error.response.data,
                        horizontalAlign: 'center',
                        verticalAlign: 'top',
                        type: 'danger'
                      })
                     // console.log(error);
                  })
              }
          })
          .catch(error=>{
             // console.log(error)
          })
       },
       downloadFile(ID){
        this.$store.dispatch('GetContractFile', {contractId:ID})
          .then(response=>{
              if(response.data.encodedPdf !="" && response.data.encodedPdf !=null){
                const linkSource = `data:application/pdf;base64,${response.data.encodedPdf}`;
                 const downloadLink = document.createElement("a");
                 const fileName = "document1.pdf";
 
                 downloadLink.href = linkSource;
                 downloadLink.download = fileName;
                 downloadLink.click();
              }else{
                this.$notifications.notify(
                {
                  message: "No document attached to this contract.",
                  horizontalAlign: 'center',
                  verticalAlign: 'top',
                  type: 'danger'
                })
              }
          })
          .catch(error=>{
              this.$notifications.notify(
              {
                message: error.response.data,
                horizontalAlign: 'center',
                verticalAlign: 'top',
                type: 'danger'
              })
             // console.log(error);
          })
       },
       DisableContract(){
          this.$bvModal.show('modal-top-disable');
       },
       searchContractByID(){
        this.$store.dispatch('GetContractByID', {contractIdentifier: this.contractId, userId: parseInt(sessionStorage.getItem("ID"))})
          .then(response=>{
            console.log("terminate",response.data);
              this.disableContractData = response.data;
              this.$bvModal.show('modal-top-disable-detail');
          })
          .catch(error=>{
              this.$notifications.notify(
              {
                message: error.response.data,
                horizontalAlign: 'center',
                verticalAlign: 'top',
                type: 'danger'
              })
              // console.log(error);
          })
       },
       SubmitDisableContract(ID){
        var msgt  = "";
        if(this.disableContractData.remainingDate !=="No remaining Date.") {
          msgt += "The tenant is already paid for "+this.disableContractData.remainingDate+ " days. ";
        }
        this.$bvModal.msgBoxConfirm(msgt+'Are you sure you want to terminate this contract?', {
            title: 'Confirm',
            size: 'sm',
            buttonSize: 'sm',
            okVariant: 'success',
            cancelVariant: 'danger',
            okTitle: 'YES',
            cancelTitle: 'NO',
            bodyClass: 'm-2',
            hideHeaderClose: false,
            centered: false
        })
        .then(value => {
            if(value === true){
              this.$store.dispatch('disableContract', {contractIdentifier: ID})
              .then(response=>{
                  this.$notifications.notify(
                  {
                    message: `Contract terminated successfully.`,
                    horizontalAlign: 'center',
                    verticalAlign: 'top',
                    type: 'success'
                  })
                  this.$bvModal.hide('modal-top-disable-detail');
                  this.$bvModal.hide('modal-top-disable');
                  this.clearData();
              })
              .catch(error=>{
                  this.$notifications.notify(
                  {
                    message: error.response.data,
                    horizontalAlign: 'center',
                    verticalAlign: 'top',
                    type: 'danger'
                  })
                 // console.log(error);
              })
            }
        })
        .catch(error=>{
         // console.log(error);
        })
       },
      EnableContract(ID){
        this.$bvModal.show('modal-top-EnableContract');
        this.editData.contractIdentifier = ID;
      },
      submitEnableForm(){
        this.$bvModal.msgBoxConfirm('Are you sure you want to renew this contract?', {
            title: 'Confirm',
            size: 'sm',
            buttonSize: 'sm',
            okVariant: 'success',
            cancelVariant: 'danger',
            okTitle: 'YES',
            cancelTitle: 'NO',
            bodyClass: 'm-2',
            hideHeaderClose: false,
            centered: false
        })
        .then(value => {

          let penaltyAmount;
          let dateRange;
          if(this.editData.dateRangeForPenaltyIncrement==="Other"){
              dateRange=this.editData.dateRangeForUserInput
            }
          else{
             dateRange=this.editData.dateRangeForPenaltyIncrement
            }
          if (this.editData.penaltyAmount==="Other"){
              if(this.editData.penaltyAmountFixed===0){
                    penaltyAmount=this.editData.penaltyAmountPercent
                  }
              else{
                    penaltyAmount=this.editData.penaltyAmountFixed
                  }
            }
          else{
              penaltyAmount=this.editData.penaltyAmount
            }
            if(value === true){
              var fileToAttach = "";

                if(this.base64 != null){
                  fileToAttach = this.base64.split(',')[1];
                }

                if(fileToAttach == ""){
                  fileToAttach = this.editData.encodedPdf == null ? "" : this.editData.encodedPdf;
                }

              var period = this.editData.period * this.editData.periodtwo;
              this.$store.dispatch('enableContract', {
                userId : sessionStorage.getItem("ID"),
                contractIdentifier: this.editData.contractIdentifier,
                startDate : this.editData.startDate,
                endDate : this.editData.endDate,
                initialPayment:  this.editData.initialPayment,
                guaranteedMoney: this.editData.guaranteedMoney,
                dueDate : this.editData.dueDate,
                period: period,
                encodePdf: fileToAttach,
                registeredBy: sessionStorage.getItem("userID"),
                penaltyOption: this.editData.penaltyOption,
                penaltyCondition: this.editData.penaltyCondition,
                withHolding: this.editData.withHolding,
                dateRangeForPenaltyIncrement: dateRange,
                penaltyAmount: penaltyAmount,
              })
              .then(response=>{
                  this.$notifications.notify(
                  {
                    message: `Contract Renewed successfully.`,
                    horizontalAlign: 'center',
                    verticalAlign: 'top',
                    type: 'success'
                  })
                  this.clearData();
              })
              .catch(error=>{
                  this.$notifications.notify(
                  {
                    message: error.response.data,
                    horizontalAlign: 'center',
                    verticalAlign: 'top',
                    type: 'danger'
                  })
                 // console.log(error);
              })
            }
        })
        .catch(error=>{
        //  console.log(error);
        })
      },
      clearData(){
        this.buildingOptions = [];
        this.tenantOptions = [];
        this.houseOptions = [];
        this.houseType='existing',
        this.tenantType='existing',
        this.checkedExistingHouse = this.checkedExistingTenant = false;
        this.addData.floor=null;
        this.addData.roomNumber="";
        this.addData.size=null;
        this.addData.buildingId=null;
        this.addData.latest_price=null;
        this.addData.fullName=null;
        this.addData.email="";
        this.addData.phoneNumber="";
        this.addData.address="";
        this.addData.startDate="";
        this.addData.endDate="";
        this.addData.dueDate=0;
        this.addData.penaltyAmount=0;
        this.addData.penaltyCondition=null;
        this.addData.penaltyOption=null;
        this.addData.dateRangeForPenaltyIncrement=0;
        this.addData.payedAmount=null;
        this.addData.priceOption = null;
        this.addData.rentCurrencyType = null;
        this.addData.withHolding = null;
        this.addData.advancePeriod = null;
        this.addData.advancePeriodtwo = 1;
        this.editData.rentCurrencyType = null;
        this.addData.initialPayment=0;
        this.addData.guaranteedMoney=0;
        this.addData.tenantId= null;
        this.addData.houseId= null;
        this.editData.contractId= null;
        this.editData.startDate= "";
        this.editData.endDate= "";
        this.editData.dueDate= 0;
        this.editData.initialPayment= 0;
        this.editData.guaranteedMoney= 0;
        this.editData.paymentRule= "";
        this.editData.period= 1;
        this.editData.periodtwo= 1;
        this.editData.encodedPdf= null;
        this.editData.penaltyAmount=0;
        this.editData.penaltyCondition=null;
        this.editData.penaltyOption=null;
        this.editData.dateRangeForPenaltyIncrement=null;
        this.addData.electricReading = null;
        this.addData.waterReading = null;
        this.addData.firstBillPaymentStarts = null;
        this.base64 = null;
        this.tabIndex = 0;
        this.contractId = null;
        this.$emit('AfterComplete');
      },
      
      submitAddForm() {
        this.loading = true;
        
        const contractData = {
          tenantId: this.tenantType === 'existing' ? this.addData.tenantId : null,
          fullName: this.tenantType === 'new' ? this.addData.fullName : null,
          email: this.tenantType === 'new' ? this.addData.email : null,
          phoneNumber: this.tenantType === 'new' ? '+251'+this.addData.phoneNumber : null,
          address: this.tenantType === 'new' ? this.addData.address : null,
          sex: this.tenantType === 'new' ? this.addData.sex : null,
          houseId: this.houseType === 'existing' ? this.addData.houseId : null,
          buildingId: this.houseType === 'new' ? this.addData.buildingId : null,
          floor: this.houseType === 'new' ? this.addData.floor : null,
          roomNumber: this.houseType === 'new' ? this.addData.roomNumber : null,
          size: this.houseType === 'new' ? this.addData.size : null,
          description: this.houseType === 'new' ? this.addData.description : null,
          includeVat: this.houseType === 'new' ? this.selectedOption : null,
          rentCurrencyType: this.houseType === 'new' ? this.addData.rentCurrencyType : null,
          priceOption: this.houseType === 'new' ? this.addData.priceOption : null,
          price: this.houseType === 'new' ? this.addData.latest_price : null,
          startDate: this.addData.startDate,
          endDate: this.addData.endDate,
          dueDate: this.addData.dueDate,
          initialPayment: this.addData.initialPayment,
          guaranteedMoney: this.addData.guaranteedMoney || 0,
          withHolding: this.addData.withHolding,
          payedAmount: this.addData.payedAmount,
          paymentRule: this.addData.paymentRule,
          period: this.addData.period,
          penaltyOption: this.addData.penaltyOption || 'noPenalty',
          penaltyAmount: this.addData.penaltyAmount === 'Other' ? 
            (this.addData.penaltyOption === 'percentage' ? this.addData.penaltyAmountPercent : this.addData.penaltyAmountFixed) : 
            this.addData.penaltyAmount || 0,
          penaltyCondition: this.addData.penaltyCondition || 'fixed',
          dateRangeForPenaltyIncrement: this.addData.dateRangeForPenaltyIncrement === 'Other' ? 
            this.addData.dateRangeForUserInput : this.addData.dateRangeForPenaltyIncrement || 0,
          electricReading: this.addData.electricReading || null,
          waterReading: this.addData.waterReading || null,
          firstBillPaymentStarts: this.addData.firstBillPaymentStarts || null,
          registeredBy: parseInt(sessionStorage.getItem('userID')),
          userId: parseInt(sessionStorage.getItem('userID')),
          encodePdf: this.base64
        };
        
        this.$store.dispatch('CreateContractMerged', contractData)
          .then(response => {
            this.loading = false;
            this.clearData();
            this.currentStep = 1;
            this.$bvModal.hide("modal-top-add");
            this.isSubmitting = false;
            this.$bvToast.toast("Contract added successfully!", {
              title: "Success",
              variant: "success",
              solid: true,
            });
          })
          .catch(error => {
            this.loading = false;
            this.isSubmitting = false;
            
            console.error('Contract creation error:', error);
            
            if (error.response && error.response.data) {
              if (typeof error.response.data === "object") {
                if (error.response.data.errorMessage) {
                  this.errorMessage = error.response.data.errorMessage;
                  this.expectedAmount = error.response.data.expectedAmount;
                  this.belowAmount = error.response.data.belowAmount;
                  this.aboveAmount = error.response.data.aboveAmount;
                  this.differenceAmount = error.response.data.differenceAmount;
                  this.$bvModal.show("modal-payment-error");
                } else {
                  const errorMsg = JSON.stringify(error.response.data);
                  this.$bvToast.toast(errorMsg, {
                    title: "Error",
                    variant: "danger",
                    solid: true,
                    autoHideDelay: 5000
                  });
                }
              } else {
                this.$bvToast.toast(error.response.data.toString(), {
                  title: "Error",
                  variant: "danger",
                  solid: true,
                  autoHideDelay: 5000
                });
              }
            } else {
              this.$bvToast.toast("An unexpected error occurred. Please try again.", {
                title: "Error",
                variant: "danger",
                solid: true,
                autoHideDelay: 5000
              });
            }
          })
      }
    }
  }
</script>
<style lang="scss" scoped>
  @media only screen and (max-width: 600px) {
    .mob-title{
      display: none !important;
    }
  }
.b-table-sticky-column:last-child {
  right: 0;
}
.error-message {
  color: rgb(219, 63, 63);
  font-size: 0.875rem;
  margin-top: 0.25rem;
}
.text-warning {
    color: rgba(240, 206, 13, 0.937) !important;
}
.btn-icon{
  font-size: 27px !important;
  padding: 3px 5px 3px 5px;
  width: 40px;
  color:  rgb(37, 91, 48);
  border: 2px solid rgb(37, 91, 48);
}
.btn-icon:hover,
.btn-icon:focus {
  cursor: pointer;
  background-color: rgb(37, 91, 48) !important;
  color: rgba(240, 206, 13, 0.937) !important;
  border-radius: 4px;
  transition: .4s;
}
</style>